(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("ePRCc", function(module, exports) {

$parcel$export(module.exports, "useLocalTheme", function () { return $accf6af03d9a0365$export$dbf11ffda29a233f; });
$parcel$export(module.exports, "make", function () { return $accf6af03d9a0365$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $hR2pB = parcelRequire("hR2pB");

var $hciIG = parcelRequire("hciIG");

var $3HXuA = parcelRequire("3HXuA");

var $3Wlzc = parcelRequire("3Wlzc");

var $lybpH = parcelRequire("lybpH");

var $gCzsf = parcelRequire("gCzsf");

var $1Gpco = parcelRequire("1Gpco");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
var $accf6af03d9a0365$export$602eac185826482c = {};
var $accf6af03d9a0365$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($1Gpco.empty);
var $accf6af03d9a0365$export$ca328f169d304df4 = $accf6af03d9a0365$export$a078c61943f9dbbe.Provider;
function $accf6af03d9a0365$export$ed607c48b9829acd(themes, reference) {
    return $i7mYY.getBy(themes, function(t) {
        if (reference !== undefined && reference) return $7bjme.equal(reference._0, t.themeId);
        else return false;
    });
}
function $accf6af03d9a0365$export$dbf11ffda29a233f(param) {
    return $g85JO.useContext($accf6af03d9a0365$export$a078c61943f9dbbe);
}
function $accf6af03d9a0365$var$BaseWithTheme(Props) {
    var initiator = Props.initiator;
    var style = Props.style;
    var reference = Props.reference;
    var classNameOpt = Props.className;
    var portal = Props.portal;
    var children = Props.children;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var match$2 = match$1.settings;
    var pdpTheme = match$2.pdpTheme;
    var plpTheme = match$2.plpTheme;
    var baseTheme = match$2.theme;
    var match$3 = $hBcYV.useRouter(undefined);
    var isPLP = $lybpH.useIsPLP(undefined);
    var isPDP = $2whNH.isSome(match$3.anyProductId);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, match$1.categories);
    var activeCategoryTheme = $2whNH.map($2whNH.orElse(activeCategory, match$2.indexNode), function(category) {
        return category.pageTheme;
    });
    var accountThemes = $2whNH.map(match$1.transitiveAccount, function(account) {
        return account.themes;
    });
    var propTheme = $g85JO.useMemo(function() {
        return $2whNH.flatMap(accountThemes, function(themes) {
            return $accf6af03d9a0365$export$ed607c48b9829acd(themes, reference);
        });
    }, [
        accountThemes,
        reference
    ]);
    var pdpTheme$1 = $g85JO.useMemo(function() {
        return $2whNH.keep(pdpTheme, function(param) {
            return isPDP;
        });
    }, [
        pdpTheme,
        isPDP
    ]);
    var plpTheme$1 = $g85JO.useMemo(function() {
        return $2whNH.keep(plpTheme, function(param) {
            return isPLP;
        });
    }, [
        plpTheme,
        isPLP
    ]);
    var pageTheme = $g85JO.useMemo(function() {
        return $2whNH.flatMap(accountThemes, function(themes) {
            return $accf6af03d9a0365$export$ed607c48b9829acd(themes, activeCategoryTheme);
        });
    }, [
        accountThemes,
        activeCategoryTheme
    ]);
    var theme = $g85JO.useMemo(function() {
        return $2whNH.getWithDefault($2whNH.orElse($2whNH.orElse($2whNH.orElse(propTheme, pdpTheme$1), pageTheme), plpTheme$1), baseTheme);
    }, [
        propTheme,
        pdpTheme$1,
        plpTheme$1,
        pageTheme,
        baseTheme
    ]);
    var style$1 = $g85JO.useMemo(function() {
        return $3HXuA.combineMaybe($3HXuA.makeStyle(theme), style);
    }, [
        theme.themeUpdatedAt
    ]);
    var children$1 = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataId: "maker-theme-" + $iv6Yc._1($3Wlzc.toString, theme.themeId),
        dataInitiator: initiator,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $hciIG.getClassName(undefined),
                className
            ]),
            style: style$1
        }, /*#__PURE__*/ $g85JO.createElement($accf6af03d9a0365$export$ca328f169d304df4, {
            value: theme,
            children: children
        }))
    });
    if (portal) return /*#__PURE__*/ $g85JO.createElement($hR2pB.default, {
        children: children$1
    });
    else return children$1;
}
$accf6af03d9a0365$var$BaseWithTheme.displayName = "BaseWithTheme";
var $accf6af03d9a0365$export$dd44f18ab656f3bb = $accf6af03d9a0365$var$BaseWithTheme;
 /* context Not a pure module */ 
});
parcelRegister("hR2pB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff941ddcf6b2a29$export$2e2bcd8739ae039; });

var $6fLEz = parcelRequire("6fLEz");

var $3ICMl = parcelRequire("3ICMl");

var $3Geph = parcelRequire("3Geph");
var $cff941ddcf6b2a29$var$Portal = void 0;
if ((0, (/*@__PURE__*/$parcel$interopDefault($6fLEz))).createPortal) $cff941ddcf6b2a29$var$Portal = (0, $3ICMl.default);
else $cff941ddcf6b2a29$var$Portal = (0, $3Geph.default);
var $cff941ddcf6b2a29$export$2e2bcd8739ae039 = $cff941ddcf6b2a29$var$Portal;

});
parcelRegister("3ICMl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b538fcc5d79d68a$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $g85JO = parcelRequire("g85JO");

var $bnpdr = parcelRequire("bnpdr");

var $6fLEz = parcelRequire("6fLEz");

var $6F30o = parcelRequire("6F30o");
var $2b538fcc5d79d68a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $2b538fcc5d79d68a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b538fcc5d79d68a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2b538fcc5d79d68a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $gfRPo._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2b538fcc5d79d68a$var$Portal = function(_React$Component) {
    $2b538fcc5d79d68a$var$_inherits(Portal, _React$Component);
    function Portal() {
        $2b538fcc5d79d68a$var$_classCallCheck(this, Portal);
        return $2b538fcc5d79d68a$var$_possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
    }
    $2b538fcc5d79d68a$var$_createClass(Portal, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
            }
        },
        {
            key: "render",
            value: function render() {
                if (!(0, $6F30o.canUseDOM)) return null;
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement("div");
                    document.body.appendChild(this.defaultNode);
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fLEz))).createPortal(this.props.children, this.props.node || this.defaultNode);
            }
        }
    ]);
    return Portal;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$2b538fcc5d79d68a$var$Portal.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).node.isRequired,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).any
};
var $2b538fcc5d79d68a$export$2e2bcd8739ae039 = $2b538fcc5d79d68a$var$Portal;

});
parcelRegister("6F30o", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", function () { return $4d98e72f48a5e1f3$export$71594e8a50f746f4; });
var $4d98e72f48a5e1f3$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("3Geph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae07839a5b5028b$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $g85JO = parcelRequire("g85JO");

var $6fLEz = parcelRequire("6fLEz");

var $bnpdr = parcelRequire("bnpdr");
var $2ae07839a5b5028b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $2ae07839a5b5028b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2ae07839a5b5028b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2ae07839a5b5028b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $gfRPo._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2ae07839a5b5028b$var$Portal = function(_React$Component) {
    $2ae07839a5b5028b$var$_inherits(Portal, _React$Component);
    function Portal() {
        $2ae07839a5b5028b$var$_classCallCheck(this, Portal);
        return $2ae07839a5b5028b$var$_possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
    }
    $2ae07839a5b5028b$var$_createClass(Portal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderPortal();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(props) {
                this.renderPortal();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, (/*@__PURE__*/$parcel$interopDefault($6fLEz))).unmountComponentAtNode(this.defaultNode || this.props.node);
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
                this.portal = null;
            }
        },
        {
            key: "renderPortal",
            value: function renderPortal(props) {
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement("div");
                    document.body.appendChild(this.defaultNode);
                }
                var children = this.props.children;
                // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
                if (typeof this.props.children.type === "function") children = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).cloneElement(this.props.children);
                this.portal = (0, (/*@__PURE__*/$parcel$interopDefault($6fLEz))).unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return Portal;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
var $2ae07839a5b5028b$export$2e2bcd8739ae039 = $2ae07839a5b5028b$var$Portal;
$2ae07839a5b5028b$var$Portal.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).node.isRequired,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).any
};

});


parcelRegister("hciIG", function(module, exports) {

$parcel$export(module.exports, "getClassName", function () { return $c852140474cac1fe$export$307b18b61172f7ed; });
$parcel$export(module.exports, "make", function () { return $c852140474cac1fe$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $2Mb3w = parcelRequire("2Mb3w");

var $ezf3v = parcelRequire("ezf3v");

var $hR2pB = parcelRequire("hR2pB");

var $41eh7 = parcelRequire("41eh7");
var $c852140474cac1fe$export$83d89fbfd8236492 = $41eh7.getVersion(undefined);

if ($c852140474cac1fe$export$83d89fbfd8236492 === "v2") (parcelRequire("9R0no"));
function $c852140474cac1fe$export$307b18b61172f7ed(param) {
    var match = $2Mb3w.getOS(undefined);
    var osClassName;
    switch(match){
        case /* Mac */ 0:
            osClassName = "mac";
            break;
        case /* Windows */ 1:
            osClassName = "windows";
            break;
        case /* Linux */ 2:
            osClassName = "linux";
            break;
        case /* IOS */ 3:
        case /* UnknownOs */ 4:
            osClassName = "";
            break;
    }
    if ($c852140474cac1fe$export$83d89fbfd8236492 === "v3") return $ezf3v.prefix($1TRFX.make([
        "maker-base",
        "antialiased",
        osClassName
    ]));
    else return $1TRFX.make([
        "quickview",
        $ezf3v.prefix($1TRFX.make([
            "antialiased",
            osClassName
        ]))
    ]);
}
function $c852140474cac1fe$var$Base(Props) {
    var classNameOpt = Props.className;
    var portal = Props.portal;
    var style = Props.style;
    var children = Props.children;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var tmp = {
        className: $1TRFX.make([
            $c852140474cac1fe$export$307b18b61172f7ed(undefined),
            className
        ])
    };
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var children$1 = /*#__PURE__*/ $g85JO.createElement("div", tmp, children);
    if (portal) return /*#__PURE__*/ $g85JO.createElement($hR2pB.default, {
        children: children$1
    });
    else return children$1;
}
$c852140474cac1fe$var$Base.displayName = "Base";
var $c852140474cac1fe$export$dd44f18ab656f3bb = $c852140474cac1fe$var$Base;
 /* version Not a pure module */ 
});
parcelRegister("9R0no", function(module, exports) {


module.exports = (parcelRequire("gcarF"))((parcelRequire("7wgKE")).resolve("lcTMQ"));

});
parcelRegister("gcarF", function(module, exports) {
"use strict";

var $7J4BA = parcelRequire("7J4BA");
module.exports = $7J4BA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("7J4BA", function(module, exports) {
"use strict";
var $5a004edf52e5b33a$var$cachedBundles = {};
var $5a004edf52e5b33a$var$cachedPreloads = {};
var $5a004edf52e5b33a$var$cachedPrefetches = {};
function $5a004edf52e5b33a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5a004edf52e5b33a$var$cachedPreloads;
        case "prefetch":
            return $5a004edf52e5b33a$var$cachedPrefetches;
        default:
            return $5a004edf52e5b33a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5a004edf52e5b33a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("7wgKE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $579884101b2e33e1$export$6503ec6e8aabbaf; }, function (v) { return $579884101b2e33e1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $579884101b2e33e1$export$f7ad0328861e2f03; }, function (v) { return $579884101b2e33e1$export$f7ad0328861e2f03 = v; });
var $579884101b2e33e1$export$6503ec6e8aabbaf;
var $579884101b2e33e1$export$f7ad0328861e2f03;
"use strict";
var $579884101b2e33e1$var$mapping = new Map();
function $579884101b2e33e1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$579884101b2e33e1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $579884101b2e33e1$var$resolve(id) {
    var resolved = $579884101b2e33e1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$579884101b2e33e1$export$6503ec6e8aabbaf = $579884101b2e33e1$var$register;
$579884101b2e33e1$export$f7ad0328861e2f03 = $579884101b2e33e1$var$resolve;

});



parcelRegister("3HXuA", function(module, exports) {

$parcel$export(module.exports, "combineMaybe", function () { return $2b33892a833387bb$export$456987f66d6a5ee0; });
$parcel$export(module.exports, "makeStyle", function () { return $2b33892a833387bb$export$f8777a72970d840a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $7ybfR = parcelRequire("7ybfR");
function $2b33892a833387bb$export$b1fd874f6ecae195(style, maybe) {
    return $2whNH.mapWithDefault(maybe, style, function(param) {
        return $7ybfR.unsafeAddProp(style, param[0], param[1]);
    });
}
function $2b33892a833387bb$export$456987f66d6a5ee0(style, maybe) {
    return $2whNH.mapWithDefault(maybe, style, function(toCombine) {
        return Object.assign({}, style, toCombine);
    });
}
function $2b33892a833387bb$export$cb43647390aef607(fontFamily) {
    var fallback = "sans-serif";
    return $2whNH.getWithDefault($2whNH.map($i7mYY.get(fontFamily.split(";"), 0), function(fontFamily) {
        return $i7mYY.concat($i7mYY.keep($i7mYY.keepMap(fontFamily.split(/\,[\s]/), function(s) {
            return s;
        }), function(s) {
            return s !== fallback;
        }), [
            fallback
        ]).join(",");
    }), fontFamily);
}
function $2b33892a833387bb$export$43c3f997d7b43efe(fontWeight) {
    switch(fontWeight){
        case /* WeightAuto */ 0:
            return;
        case /* WeightThin */ 1:
            return "100";
        case /* WeightLight */ 2:
            return "300";
        case /* WeightNormal */ 3:
            return "400";
        case /* WeightMedium */ 4:
            return "500";
        case /* WeightSemiBold */ 5:
            return "600";
        case /* WeightBold */ 6:
            return "700";
    }
}
function $2b33892a833387bb$export$ca3b5729e2f34875(fixedOpt, art, color) {
    var fixed = fixedOpt !== undefined ? fixedOpt : false;
    if (typeof art === "number") return color;
    if (art.TAG !== /* GradientArt */ 0) return art._0;
    var gradient = art._0.trim();
    if (gradient.endsWith(")") && fixed) return gradient + " no-repeat 0 0 / 100vw 100vh";
    else return gradient;
}
function $2b33892a833387bb$export$f8777a72970d840a(theme) {
    var match = theme.backgroundArt;
    var tmp;
    tmp = typeof match === "number" || match.TAG !== /* GradientArt */ 0 ? undefined : [
        "--smartnav-background-attachment",
        "fixed"
    ];
    return $7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($2b33892a833387bb$export$b1fd874f6ecae195($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($2b33892a833387bb$export$b1fd874f6ecae195($2b33892a833387bb$export$b1fd874f6ecae195($7ybfR.unsafeAddProp($2b33892a833387bb$export$b1fd874f6ecae195($2b33892a833387bb$export$b1fd874f6ecae195($2b33892a833387bb$export$b1fd874f6ecae195($7ybfR.unsafeAddProp($2b33892a833387bb$export$b1fd874f6ecae195({}, $2whNH.map($2whNH.map(theme.bodyFont.fontFamily, $2b33892a833387bb$export$cb43647390aef607), function(fontFamily) {
        return [
            "--smartnav-font-family",
            fontFamily
        ];
    })), "--smartnav-font-scale", String(theme.bodyFont.fontSizeScale)), $2whNH.map($2whNH.flatMap(theme.bodyFont.fontWeight, $2b33892a833387bb$export$43c3f997d7b43efe), function(weight) {
        return [
            "--smartnav-font-weight",
            weight
        ];
    })), $2whNH.map($2whNH.map(theme.headingFont.fontFamily, $2b33892a833387bb$export$cb43647390aef607), function(fontFamily) {
        return [
            "--smartnav-heading-font-family",
            fontFamily
        ];
    })), $2whNH.map($2whNH.flatMap(theme.headingFont.fontWeight, $2b33892a833387bb$export$43c3f997d7b43efe), function(weight) {
        return [
            "--smartnav-heading-font-weight",
            weight
        ];
    })), "--smartnav-heading-font-scale", String(theme.headingFont.fontSizeScale)), $2whNH.map($2whNH.map(theme.buttonFont.fontFamily, $2b33892a833387bb$export$cb43647390aef607), function(fontFamily) {
        return [
            "--smartnav-button-font-family",
            fontFamily
        ];
    })), $2whNH.map($2whNH.flatMap(theme.buttonFont.fontWeight, $2b33892a833387bb$export$43c3f997d7b43efe), function(weight) {
        return [
            "--smartnav-button-font-weight",
            weight
        ];
    })), "--smartnav-button-font-scale", String(theme.buttonFont.fontSizeScale)), "--smartnav-color-primary", theme.primaryColor), "--smartnav-color-secondary", theme.secondaryColor), "--smartnav-color-tertiary", theme.tertiaryColor), "--smartnav-color-accent", theme.accentColor), "--smartnav-color-drawer-main", theme.drawerBackgroundColor), "--smartnav-color-drawer-label", theme.drawerLabelColor), "--smartnav-background-color", theme.backgroundColor), "--smartnav-background-art", $2b33892a833387bb$export$ca3b5729e2f34875(true, theme.backgroundArt, theme.backgroundColor)), tmp), "--smartnav-border-radius", theme.roundedEdges), "--smartnav-col-gutter", theme.columnGutter), "--smartnav-row-gutter", theme.rowGutter), "--smartnav-section-vertical-padding", theme.sectionVerticalPadding), "--smartnav-section-padding-top", $2whNH.getWithDefault(theme.sectionPaddingTop, theme.sectionVerticalPadding)), "--smartnav-section-padding-bottom", $2whNH.getWithDefault(theme.sectionPaddingBottom, theme.sectionVerticalPadding)), "--smartnav-color-placeholder", theme.placeholderColor), "--smartnav-color-product-discount-main", theme.productPriceDiscountBackgroundColor), "--smartnav-color-product-discount-label", theme.productPriceDiscountLabelColor), "--smartnav-color-product-promo-main", theme.productPromoBackgroundColor), "--smartnav-color-product-promo-label", theme.productPromoLabelColor);
}
var $2b33892a833387bb$export$89abf52a030e56ee;
var $2b33892a833387bb$export$892596cec99bc70e;
var $2b33892a833387bb$export$f1c8ff7305c3a8b7;
 /* No side effect */ 
});
parcelRegister("7ybfR", function(module, exports) {

$parcel$export(module.exports, "unsafeAddProp", function () { return $57f47058d37a3fea$export$b964351a8b6439d5; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $57f47058d37a3fea$export$b964351a8b6439d5(style, key, value) {
    var dict = {};
    dict[key] = value;
    return Object.assign({}, style, dict);
}
 /* No side effect */ 
});


parcelRegister("lybpH", function(module, exports) {

$parcel$export(module.exports, "useIsPLP", function () { return $fb05a07240e7411f$export$767d8aecf848a7c2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");

var $5RX6O = parcelRequire("5RX6O");
function $fb05a07240e7411f$export$767d8aecf848a7c2(param) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var routerProvider = $hBcYV.useRouter(undefined);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */ 1;
    var match$1 = routerProvider.listPageType;
    var isProductsView = match$1 !== undefined && (typeof match$1 === "number" || match$1.TAG !== /* Category */ 0) ? true : false;
    return $g85JO.useMemo(function() {
        if (activeCategory !== undefined) {
            if ($1xf0g.hasProducts(activeCategory) || $1xf0g.Link.isStoreCategoryLink(activeCategory)) {
                if ($1xf0g.hasSubCategories(activeCategory)) return isForcingPLP;
                else return true;
            } else return false;
        } else if ($2whNH.isSome($2whNH.flatMap(config.settings.indexNode, function(category) {
            return $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
        })) && ($2whNH.isSome(routerProvider.productFilters) || isForcingPLP)) return true;
        else return isProductsView;
    }, [
        activeCategory,
        isForcingPLP,
        config.settings.indexNode,
        routerProvider
    ]);
}
 /* react Not a pure module */ 
});
parcelRegister("5RX6O", function(module, exports) {

$parcel$export(module.exports, "useCategoryDisplayPriority", function () { return $445fc0c5d59fdc49$export$7713192b3fcf4a05; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $445fc0c5d59fdc49$export$7713192b3fcf4a05(category) {
    var match = $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined);
    var categoryDisplayPriority = $2whNH.map(category, function(c) {
        return c.displayPriority;
    });
    var indexDisplayPriority = $2whNH.map(match$1.config.settings.indexNode, function(c) {
        return c.displayPriority;
    });
    if (match.isForcingPLP) return /* ProductsFirst */ 1;
    else if (categoryDisplayPriority !== undefined) return categoryDisplayPriority;
    else if (indexDisplayPriority !== undefined) return indexDisplayPriority;
    else return /* ChildrenFirst */ 0;
}
 /* RouterProvider-Showside Not a pure module */ 
});



parcelRegister("c6E1z", function(module, exports) {

$parcel$export(module.exports, "useCategoryProducts", function () { return $8d05178c27e0df52$export$f337e7a60b0a32d8; });
$parcel$export(module.exports, "useRelatedProducts", function () { return $8d05178c27e0df52$export$e3ae536c897ef5da; });
$parcel$export(module.exports, "useProductsById", function () { return $8d05178c27e0df52$export$3b903da50cc43b4c; });
$parcel$export(module.exports, "useProductById", function () { return $8d05178c27e0df52$export$cd7dfe9e68096f3e; });
$parcel$export(module.exports, "useMarkets", function () { return $8d05178c27e0df52$export$f072c2e8a8bce353; });
$parcel$export(module.exports, "usePaginateCategories", function () { return $8d05178c27e0df52$export$c558d62c540a75e; });
$parcel$export(module.exports, "useCategories", function () { return $8d05178c27e0df52$export$17897f9a67d1488d; });
$parcel$export(module.exports, "useCacheOnlyProducts", function () { return $8d05178c27e0df52$export$e463d8cb688cc535; });
$parcel$export(module.exports, "useCategoriesByProduct", function () { return $8d05178c27e0df52$export$1de15f529cc98472; });
$parcel$export(module.exports, "useCategory", function () { return $8d05178c27e0df52$export$d29a5185919f928b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");

var $f9ONQ = parcelRequire("f9ONQ");

var $1xvYg = parcelRequire("1xvYg");

var $fEMeF = parcelRequire("fEMeF");

var $8u0V4 = parcelRequire("8u0V4");

var $2gwg0 = parcelRequire("2gwg0");

var $9bmXk = parcelRequire("9bmXk");

var $bygWp = parcelRequire("bygWp");

var $dkuGO = parcelRequire("dkuGO");

var $h7kEx = parcelRequire("h7kEx");

var $bZsVp = parcelRequire("bZsVp");

var $juPKE = parcelRequire("juPKE");

var $bjgUL = parcelRequire("bjgUL");

var $8E2YL = parcelRequire("8E2YL");

var $9XHIv = parcelRequire("9XHIv");

var $gXxeV = parcelRequire("gXxeV");

var $c06xW = parcelRequire("c06xW");

var $04dLg = parcelRequire("04dLg");

var $ij6do = parcelRequire("ij6do");
var $8d05178c27e0df52$export$271f9f08425019c7 = /* @__PURE__ */ $1xvYg.create("UseApi-Showside.NotFound");
function $8d05178c27e0df52$export$fd7d3d9947ccd0ba(swrInfiniteResult) {
    var error = swrInfiniteResult.error;
    var data = swrInfiniteResult.data;
    var reachedEnd = $2whNH.getWithDefault($2whNH.map($2whNH.flatMap(data, function(pages) {
        return $i7mYY.get(pages, pages.length - 1 | 0);
    }), function(lastPage) {
        return lastPage.page.next === undefined;
    }), false);
    var numLoadedPages = $2whNH.getWithDefault($2whNH.map(data, function(prim) {
        return prim.length;
    }), 0);
    var firstPage = $2whNH.flatMap(data, function(__x) {
        return $i7mYY.get(__x, 0);
    });
    var products = $2whNH.map(data, function(data) {
        return $i7mYY.concatMany($i7mYY.map(data, function(page) {
            return page.products;
        }));
    });
    var filters = $2whNH.flatMap(firstPage, function(page) {
        return page.filters;
    });
    var defaultSortOrder = $2whNH.flatMap(firstPage, function(page) {
        return page.defaultSortOrder;
    });
    var availableSorts = $2whNH.flatMap(firstPage, function(page) {
        return page.availableSorts;
    });
    var total = $2whNH.flatMap(firstPage, function(page) {
        return page.total;
    });
    var syncStatus = $2whNH.flatMap(firstPage, function(page) {
        return page.syncStatus;
    });
    return {
        products: products,
        filters: filters,
        availableSorts: availableSorts,
        defaultSortOrder: defaultSortOrder,
        numPages: swrInfiniteResult.size,
        setNumPages: swrInfiniteResult.setSize,
        numLoadedPages: numLoadedPages,
        reachedEnd: reachedEnd,
        error: error,
        isFetching: data === undefined && error === undefined,
        total: total,
        syncStatus: syncStatus
    };
}
var $8d05178c27e0df52$export$5417565526494bee = function(d) {
    if (d.hasOwnProperty("data")) return d.data !== 1;
    else return true;
};
function $8d05178c27e0df52$export$7c9531d2902abe7(response) {
    var data = $2whNH.map(response.data, function(data) {
        return $i7mYY.keep(data, $8d05178c27e0df52$export$5417565526494bee);
    });
    var error = $2whNH.keep(response.error, $8d05178c27e0df52$export$5417565526494bee);
    return {
        data: data,
        size: response.size,
        setSize: response.setSize,
        isValidating: response.isValidating,
        error: error,
        mutate: response.mutate
    };
}
function $8d05178c27e0df52$export$ec6cb30556a6b91c(response) {
    var data = $2whNH.keep(response.data, $8d05178c27e0df52$export$5417565526494bee);
    var error = $2whNH.keep(response.error, $8d05178c27e0df52$export$5417565526494bee);
    return {
        error: error,
        data: data,
        isValidating: response.isValidating,
        mutate: response.mutate
    };
}
function $8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, fetcher) {
    return $8d05178c27e0df52$export$7c9531d2902abe7($2gEz2.useSWRInfinite(undefined, undefined, undefined, undefined, false, undefined, false, getKey, fetcher));
}
function $8d05178c27e0df52$export$41b6679633ce3eb7(key, fetcher) {
    return $8d05178c27e0df52$export$ec6cb30556a6b91c($2gEz2.useSWR(undefined, undefined, undefined, false, key, fetcher));
}
function $8d05178c27e0df52$export$c628ede9ef2875bb(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
    var limit = limitOpt !== undefined ? limitOpt : 10;
    var match = $8u0V4.getValues(market);
    var language = $2whNH.map($2gwg0.getLanguage(undefined), function(prim) {
        return prim.toUpperCase();
    });
    var match$1 = $9XHIv.useParseMarket(match.country, match.currency, language);
    var language$1 = match$1[2];
    var currency = match$1[1];
    var country = match$1[0];
    var appliedFilters$1 = $fEMeF.mergeOption(appliedFilters, defaultFilters);
    var sort$1 = $2whNH.map($2whNH.orElse(sort, $2whNH.map(connection, function(connection) {
        return connection.sortBy;
    })), $04dLg.ProductSortOrder.toString);
    var shouldFetch$1 = shouldFetch && connection !== undefined;
    var getKey = function getKey(param, lastPage) {
        var page = $2whNH.flatMap(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next;
        });
        var end = $2whNH.getWithDefault($2whNH.map(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next === undefined;
        }), false);
        if (connection !== undefined && storeId !== undefined && !(end || !shouldFetch$1)) return smartnavApiHost + "/api/get_products_by_category2?category_id=" + connection.categoryId + "&store_id=" + storeId + $2whNH.mapWithDefault(page, "", function(page) {
            return "&page=" + page;
        }) + $2whNH.mapWithDefault(sort$1, "", function(sort) {
            return "&sort=" + sort;
        }) + (hideOutOfStock ? "&in_stock=true" : "") + $2whNH.mapWithDefault(appliedFilters$1, "", function(af) {
            return "&facets=" + $fEMeF.toStringOfIndex(af);
        }) + $2whNH.mapWithDefault($2whNH.flatMap(appliedFilters$1, function(param) {
            return param.minPrice;
        }), "", function(minPrice) {
            return "&min_price=" + String(minPrice | 0);
        }) + $2whNH.mapWithDefault($2whNH.flatMap(appliedFilters$1, function(param) {
            return param.maxPrice;
        }), "", function(maxPrice) {
            return "&max_price=" + String(maxPrice | 0);
        }) + "&limit=" + String(limit) + $2whNH.mapWithDefault(country, "", function(country) {
            return "&country=" + country;
        }) + $2whNH.mapWithDefault(currency, "", function(currency) {
            return "&currency=" + currency;
        }) + $2whNH.mapWithDefault(language$1, "", function(language) {
            return "&language=" + language;
        });
        else return null;
    };
    var fetcher = function fetcher(key) {
        if (connection !== undefined && storeId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $c06xW.Page.fromJson(appliedFilters$1, hideOutOfStock, categoryId, storeId, json)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
        else return Promise.resolve($c06xW.Page.empty);
    };
    return $8d05178c27e0df52$export$fd7d3d9947ccd0ba($8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, fetcher));
}
function $8d05178c27e0df52$export$de3600c22759f183(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
    var limit = limitOpt !== undefined ? limitOpt : 10;
    var match = $8u0V4.getValues(market);
    var language = $2whNH.map($2gwg0.getLanguage(undefined), function(prim) {
        return prim.toUpperCase();
    });
    var match$1 = $9XHIv.useParseMarket(match.country, match.currency, language);
    var language$1 = match$1[2];
    var currency = match$1[1];
    var country = match$1[0];
    var appliedFilters$1 = $fEMeF.mergeOption(appliedFilters, defaultFilters);
    var sort$1 = $2whNH.map($2whNH.orElse(sort, $2whNH.map(connection, function(connection) {
        return connection.sortBy;
    })), $04dLg.ProductSortOrder.toString);
    var getKey = function getKey(param, lastPage) {
        var next = $2whNH.flatMap(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next;
        });
        var end = $2whNH.getWithDefault($2whNH.map(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next === undefined;
        }), false);
        if (connection !== undefined && storeId !== undefined && shouldFetch && !end) return $2whNH.getWithDefault(next, smartnavApiHost + "/api/get_products_by_category3?category_id=" + connection.categoryId + "&store_id=" + storeId + $2whNH.mapWithDefault(sort$1, "", function(sort) {
            return "&sort=" + sort;
        }) + (hideOutOfStock ? "&in_stock=true" : "") + $2whNH.mapWithDefault(appliedFilters$1, "", function(af) {
            return "&facets=" + $fEMeF.toStringOfIndex(af);
        }) + $2whNH.mapWithDefault($2whNH.flatMap(appliedFilters$1, function(param) {
            return param.minPrice;
        }), "", function(minPrice) {
            return "&min_price=" + String(minPrice | 0);
        }) + $2whNH.mapWithDefault($2whNH.flatMap(appliedFilters$1, function(param) {
            return param.maxPrice;
        }), "", function(maxPrice) {
            return "&max_price=" + String(maxPrice | 0);
        }) + "&limit=" + String(limit) + $2whNH.mapWithDefault(country, "", function(country) {
            return "&country=" + country;
        }) + $2whNH.mapWithDefault(currency, "", function(currency) {
            return "&currency=" + currency;
        }) + $2whNH.mapWithDefault(language$1, "", function(language) {
            return "&language=" + language;
        }));
        else return null;
    };
    var fetcher = function fetcher(key) {
        if (storeId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $c06xW.Page.fromJson(appliedFilters$1, hideOutOfStock, categoryId, storeId, json)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
        else return Promise.resolve($c06xW.Page.empty);
    };
    return $8d05178c27e0df52$export$fd7d3d9947ccd0ba($8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, fetcher));
}
function $8d05178c27e0df52$export$f337e7a60b0a32d8(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
    var limit = limitOpt !== undefined ? limitOpt : 10;
    var useV3 = $2whNH.isSome($loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_use_get_products_by_category3")));
    if (useV3) return $8d05178c27e0df52$export$de3600c22759f183(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limit, sort, shouldFetch, smartnavApiHost, market, undefined);
    else return $8d05178c27e0df52$export$c628ede9ef2875bb(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limit, sort, shouldFetch, smartnavApiHost, market, undefined);
}
function $8d05178c27e0df52$export$e3ae536c897ef5da(productId, storeId, categoryId, hideOutOfStock, shouldFetch, smartnavApiHost, market, param) {
    var match = $8u0V4.getValues(market);
    var language = $2whNH.map($2gwg0.getLanguage(undefined), function(prim) {
        return prim.toUpperCase();
    });
    var match$1 = $9XHIv.useParseMarket(match.country, match.currency, language);
    var language$1 = match$1[2];
    var currency = match$1[1];
    var country = match$1[0];
    var getKey = function getKey(param, lastPage) {
        var page = $2whNH.flatMap(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next;
        });
        var end = $2whNH.getWithDefault($2whNH.map(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.page.next === undefined;
        }), false);
        if (productId === undefined) return null;
        if (end) return null;
        if (!shouldFetch) return null;
        var match = productId.trim();
        var tmp = match === "" ? "" : "product_id=" + productId + "&";
        return smartnavApiHost + "/api/get_related_products?" + tmp + $2whNH.mapWithDefault(storeId, "", function(storeId) {
            return "store_id=" + storeId;
        }) + $2whNH.mapWithDefault(page, "", function(page) {
            return "&page=" + page;
        }) + "&limit=" + String(10) + (hideOutOfStock ? "&in_stock=true" : "") + $2whNH.mapWithDefault(country, "", function(country) {
            return "&country=" + country;
        }) + $2whNH.mapWithDefault(currency, "", function(currency) {
            return "&currency=" + currency;
        }) + $2whNH.mapWithDefault(language$1, "", function(language) {
            return "&language=" + language;
        });
    };
    var fetcher = function fetcher(key) {
        if (storeId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $c06xW.Page.fromJson(undefined, hideOutOfStock, undefined, storeId, json)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
        else return Promise.resolve($c06xW.Page.empty);
    };
    return $8d05178c27e0df52$export$fd7d3d9947ccd0ba($8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, fetcher));
}
function $8d05178c27e0df52$export$f6b769bc518b88ba(storeId, getIds, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, param) {
    var match = $8u0V4.getValues(market);
    var language = $2whNH.map($2gwg0.getLanguage(undefined), function(prim) {
        return prim.toUpperCase();
    });
    var match$1 = $9XHIv.useParseMarket(match.country, match.currency, language);
    var language$1 = match$1[2];
    var currency = match$1[1];
    var country = match$1[0];
    var getKey = function getKey(page, param) {
        var ids = $iv6Yc._1(getIds, page);
        var shouldFetch$1 = shouldFetch && ids.length !== 0;
        if (storeId !== undefined && shouldFetch$1) return smartnavApiHost + "/api/get_products?product_ids=" + ids.join(",") + ("&store_id=" + storeId) + (hideOutOfStock ? "&in_stock=true" : "") + $2whNH.mapWithDefault(country, "", function(country) {
            return "&country=" + country;
        }) + $2whNH.mapWithDefault(currency, "", function(currency) {
            return "&currency=" + currency;
        }) + $2whNH.mapWithDefault(language$1, "", function(language) {
            return "&language=" + language;
        });
        else return null;
    };
    var match$2 = $8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, function(key) {
        if (storeId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $c06xW.$$Array.fromJson(hideOutOfStock, categoryId, storeId, json)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
        else return Promise.resolve([]);
    });
    var error = match$2.error;
    var data = match$2.data;
    var products = $2whNH.map(data, $i7mYY.concatMany);
    var error$1 = products !== undefined && products.length === 0 ? {
        RE_EXN_ID: $8d05178c27e0df52$export$271f9f08425019c7
    } : error;
    return {
        products: products,
        error: error$1,
        isFetching: data === undefined,
        numPages: match$2.size,
        setNumPages: match$2.setSize
    };
}
function $8d05178c27e0df52$export$9eb5db104503a25d(offsetOpt, len, input) {
    var offset = offsetOpt !== undefined ? offsetOpt : 0;
    return $i7mYY.concat([
        $i7mYY.slice(input, offset, len)
    ], input.length > (offset + len | 0) ? $8d05178c27e0df52$export$9eb5db104503a25d(offset + len | 0, len, input) : []);
}
function $8d05178c27e0df52$export$3b903da50cc43b4c(storeId, ids, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, param) {
    var batches = $8d05178c27e0df52$export$9eb5db104503a25d(undefined, 20, ids);
    var getIds = function getIds(page) {
        return $2whNH.getWithDefault($i7mYY.get(batches, page), []);
    };
    var match = $8d05178c27e0df52$export$f6b769bc518b88ba(storeId, getIds, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, undefined);
    var setNumPages = match.setNumPages;
    var numPages = match.numPages;
    var isFetching = match.isFetching;
    $g85JO.useEffect(function() {
        if (numPages < batches.length && !isFetching) $iv6Yc._1(setNumPages, numPages + 1 | 0);
    }, [
        numPages,
        isFetching
    ]);
    return {
        products: match.products,
        error: match.error,
        isFetching: isFetching,
        numPages: numPages,
        setNumPages: setNumPages
    };
}
function $8d05178c27e0df52$export$cd7dfe9e68096f3e(hideOutOfStock, categoryId, smartnavApiHost, market, productId) {
    $8u0V4.getValues(market);
    var language = $2whNH.map($2gwg0.getLanguage(undefined), function(prim) {
        return prim.toUpperCase();
    });
    var match = $8E2YL.use(undefined).config;
    var storeId = match.transitiveStoreId;
    var match$1 = $gXxeV.use(market, language, storeId, smartnavApiHost, hideOutOfStock, function(key) {
        if (storeId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $c06xW.$$Array.fromJson(hideOutOfStock, categoryId, storeId, json)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
        else return Promise.resolve([]);
    }, productId);
    var error = match$1.error;
    var data = match$1.data;
    var product;
    try {
        product = $2whNH.flatMap(data, function(data) {
            return $loT9g.undefined_to_opt(data.find(function(p) {
                return p.id === productId;
            }));
        });
    } catch (e) {
        product = undefined;
    }
    var isFetching = match$1.isValidating && data === undefined && error === undefined;
    return {
        product: product,
        error: error,
        isFetching: isFetching
    };
}
function $8d05178c27e0df52$export$f072c2e8a8bce353(smartnavApiHost, shouldFetch) {
    var match = $8E2YL.use(undefined).config;
    var storeId = match.transitiveStoreId;
    var shouldFetch$1 = shouldFetch && storeId !== undefined;
    var markets = function markets(key) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $bjgUL.decode(json, $juPKE.fromJson)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), key);
    };
    var getKey = function getKey(param) {
        if (storeId !== undefined && shouldFetch$1) return smartnavApiHost + "/api/get_markets?store_id=" + storeId;
        else return null;
    };
    var match$1 = $8d05178c27e0df52$export$41b6679633ce3eb7(getKey(undefined), markets);
    var data = match$1.data;
    var error = match$1.error;
    var isFetching = match$1.isValidating && data === undefined && error === undefined;
    return {
        markets: data,
        error: error,
        isFetching: isFetching
    };
}
function $8d05178c27e0df52$export$c558d62c540a75e(useCacheOpt, smartnavApiHost, limit, firstPageUrl, param) {
    var useCache = useCacheOpt !== undefined ? useCacheOpt : false;
    var direction = $g85JO.useRef(1);
    var setDirection = function setDirection(nextDirection) {
        direction.current = nextDirection;
    };
    var fetcher = function fetcher(next) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $bjgUL.decode(json, $ij6do.Page.fromJson)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), $bygWp.addHostnameMaybe(next, smartnavApiHost));
    };
    var getKey = function getKey(index, lastPage) {
        var nextPage = $2whNH.flatMap(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.next;
        });
        var previousPage = $2whNH.flatMap(lastPage == null ? undefined : $loT9g.some(lastPage), function(lastPage) {
            return lastPage.previous;
        });
        var match = direction.current;
        if (index !== 0) {
            if (match > 0) return $9bmXk.fromOption(nextPage);
            else if (match < 0) return $9bmXk.fromOption(previousPage);
            else return null;
        } else return $9bmXk.fromOption(firstPageUrl);
    };
    var paramDict = $d3YYW.fromArray([
        [
            "/api/get_config_nodes",
            "parent_id"
        ],
        [
            "/api/get_related_media_by_products",
            "product_ids"
        ],
        [
            "/api/get_related_media_by_category",
            "category_id"
        ]
    ]);
    var param$1 = $g85JO.useMemo(function() {
        return $2whNH.flatMap(firstPageUrl, function(url) {
            return $2whNH.flatMap($bygWp.getPathname($bygWp.addHostnameMaybe(url, smartnavApiHost)), function(path) {
                return $2whNH.flatMap($d3YYW.get(paramDict, path), function(param) {
                    return $2whNH.map($bygWp.getParam($bygWp.addHostnameMaybe(url, smartnavApiHost), param), function(value) {
                        return [
                            path,
                            param,
                            value
                        ];
                    });
                });
            });
        });
    }, [
        firstPageUrl
    ]);
    var cachedPages = useCache ? $58Tj9.stableSortBy($i7mYY.keep($i7mYY.keepMap($i7mYY.keep(Array.from($2gEz2.Cache.cache.keys()), function(key) {
        return $2whNH.mapWithDefault(param$1, false, function(param) {
            if (key.includes(param[0])) return key.includes(param[1] + "=" + param[2]);
            else return false;
        });
    }), function(key) {
        return $2gEz2.Cache.cache.get(key);
    }), function(page) {
        try {
            return page.categories.length !== 0;
        } catch (e) {
            return false;
        }
    }), function(pageA, pageB) {
        if (pageA.offset === pageB.offset) return 0;
        else if (pageA.offset > pageB.offset) return 1;
        else return -1;
    }) : [];
    var infiniteResult = $8d05178c27e0df52$export$9982c8e7e2cadcbd(getKey, fetcher);
    return {
        swr: {
            data: useCache && cachedPages.length !== 0 ? cachedPages : infiniteResult.data,
            size: infiniteResult.size,
            setSize: infiniteResult.setSize,
            isValidating: infiniteResult.isValidating,
            error: infiniteResult.error,
            mutate: infiniteResult.mutate
        },
        setDirection: setDirection,
        direction: direction.current
    };
}
function $8d05178c27e0df52$export$17897f9a67d1488d(url) {
    var fetcher = function fetcher(url) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $bjgUL.decode(json, $ij6do.Page.fromJson)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), url);
    };
    var getKey = function getKey(param) {
        if (url !== undefined && url.trim() !== "") return url;
        else return null;
    };
    return $8d05178c27e0df52$export$41b6679633ce3eb7(getKey(undefined), fetcher);
}
function $8d05178c27e0df52$export$e463d8cb688cc535(smartnavApiHost, market, hideOutOfStock, productIds) {
    var match = $8u0V4.getValues(market);
    var productsFromCache = $bZsVp.getProductsById(smartnavApiHost, match.currency, match.country, productIds);
    return $g85JO.useMemo(function() {
        return productsFromCache;
    }, [
        productsFromCache.length
    ]);
}
function $8d05178c27e0df52$export$cc0480e44d417a02(json) {
    return $iv6Yc._1($f9ONQ.Categories.Page.fromJson, json);
}
function $8d05178c27e0df52$export$1015a6162bf33f76(json) {
    return $f9ONQ.Category.fromJson(json);
}
function $8d05178c27e0df52$export$1de15f529cc98472(smartnavApiHost, storeId, productId, param) {
    var fetcher = function fetcher(param) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $dkuGO.decode(json, $8d05178c27e0df52$export$cc0480e44d417a02)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), param);
    };
    var url = storeId !== undefined && productId !== undefined ? "" + smartnavApiHost + "/api/get_categories_by_product?product_id=" + productId + "&store_id=" + storeId + "" : null;
    return $8d05178c27e0df52$export$41b6679633ce3eb7(url, fetcher);
}
function $8d05178c27e0df52$export$d29a5185919f928b(smartnavApiHost, storeId, categoryId, param) {
    var partial_arg = $h7kEx.Server.ignoreNotFoundError;
    var fetcher = function fetcher(param) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, partial_arg, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $dkuGO.decode(json, $8d05178c27e0df52$export$1015a6162bf33f76)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), param);
    };
    var url = storeId !== undefined && categoryId !== undefined ? "" + smartnavApiHost + "/api/get_category?category_id=" + categoryId + "&store_id=" + storeId + "" : null;
    return $8d05178c27e0df52$export$41b6679633ce3eb7(url, fetcher);
}
 /* SWR Not a pure module */ 
});
parcelRegister("f9ONQ", function(module, exports) {

$parcel$export(module.exports, "Product", function () { return $02d9048f3e76c404$export$264ad599d7cef668; });
$parcel$export(module.exports, "Category", function () { return $02d9048f3e76c404$export$3a8840c5b2ecf003; });
$parcel$export(module.exports, "Categories", function () { return $02d9048f3e76c404$export$e1e795cef0e670e6; });
$parcel$export(module.exports, "Products", function () { return $02d9048f3e76c404$export$92e44ea1079b9ec6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $3zjNo = parcelRequire("3zjNo");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $69lAE = parcelRequire("69lAE");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $hG39s = parcelRequire("hG39s");

var $cXHd0 = parcelRequire("cXHd0");
function $02d9048f3e76c404$var$t_encode(v) {
    switch(v){
        case /* ShopifyOkendoReviews */ 0:
            return [
                "ShopifyOkendoReviews"
            ];
        case /* ShopifyYotpoReviews */ 1:
            return [
                "ShopifyYotpoReviews"
            ];
        case /* ShopifyLooxReviews */ 2:
            return [
                "ShopifyLooxReviews"
            ];
        case /* ShopifyJudgeMeReviews */ 3:
            return [
                "ShopifyJudgeMeReviews"
            ];
        case /* ShopifyTrustooReviews */ 4:
            return [
                "ShopifyTrustooReviews"
            ];
    }
}
function $02d9048f3e76c404$var$t_decode(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "ShopifyJudgeMeReviews":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ShopifyJudgeMeReviews */ 3
            };
        case "ShopifyLooxReviews":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ShopifyLooxReviews */ 2
            };
        case "ShopifyOkendoReviews":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ShopifyOkendoReviews */ 0
            };
        case "ShopifyTrustooReviews":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ShopifyTrustooReviews */ 4
            };
        case "ShopifyYotpoReviews":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ShopifyYotpoReviews */ 1
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
var $02d9048f3e76c404$export$18ed20fa1e1fc1d1 = {
    t_encode: $02d9048f3e76c404$var$t_encode,
    t_decode: $02d9048f3e76c404$var$t_decode
};
function $02d9048f3e76c404$export$be3ced6f4da28ba(v) {
    switch(v){
        case /* PagesAppEmbed */ 0:
            return [
                "PagesAppEmbed"
            ];
        case /* NavAppEmbed */ 1:
            return [
                "NavAppEmbed"
            ];
        case /* NavAppDevEmbed */ 2:
            return [
                "NavAppDevEmbed"
            ];
        case /* BioAppEmbed */ 3:
            return [
                "BioAppEmbed"
            ];
        case /* BioAppDevEmbed */ 4:
            return [
                "BioAppDevEmbed"
            ];
        case /* NoEmbed */ 5:
            return [
                "NoEmbed"
            ];
    }
}
function $02d9048f3e76c404$export$8c5cddc4f9a087aa(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "BioAppDevEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* BioAppDevEmbed */ 4
            };
        case "BioAppEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* BioAppEmbed */ 3
            };
        case "NavAppDevEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* NavAppDevEmbed */ 2
            };
        case "NavAppEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* NavAppEmbed */ 1
            };
        case "NoEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* NoEmbed */ 5
            };
        case "PagesAppEmbed":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* PagesAppEmbed */ 0
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
function $02d9048f3e76c404$var$t_encode$1(v) {
    if (v) return [
        "Uninstalled"
    ];
    else return [
        "Active"
    ];
}
function $02d9048f3e76c404$var$t_decode$1(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "Active":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Active */ 0
            };
        case "Uninstalled":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Uninstalled */ 1
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
function $02d9048f3e76c404$var$fromString(str) {
    switch(str){
        case "active":
            return /* Active */ 0;
        case "uninstalled":
            return /* Uninstalled */ 1;
        default:
            return /* Active */ 0;
    }
}
function $02d9048f3e76c404$var$toString(sort) {
    if (sort) return "uninstalled";
    else return "active";
}
var $02d9048f3e76c404$export$96e9906d6d93a972 = {
    t_encode: $02d9048f3e76c404$var$t_encode$1,
    t_decode: $02d9048f3e76c404$var$t_decode$1,
    fromString: $02d9048f3e76c404$var$fromString,
    toString: $02d9048f3e76c404$var$toString
};
var $02d9048f3e76c404$export$678cf99e5b1365f7 = [
    "read_products",
    "read_inventory",
    "read_locations",
    "read_metaobjects",
    "read_markets",
    "read_themes",
    "read_publications",
    "write_script_tags",
    "read_script_tags",
    "read_product_listings",
    "unauthenticated_read_checkouts",
    "unauthenticated_read_content",
    "unauthenticated_read_customers",
    "unauthenticated_read_customer_tags",
    "unauthenticated_read_product_tags",
    "unauthenticated_read_selling_plans",
    "unauthenticated_read_product_listings"
];
function $02d9048f3e76c404$export$cc42ff7b6c615091(v) {
    return $d3YYW.fromArray([
        [
            "storeId",
            $3zjNo.stringToJson(v.storeId)
        ],
        [
            "platform",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.platform)
        ],
        [
            "platformToken",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.platformToken)
        ],
        [
            "platformUrl",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.platformUrl)
        ],
        [
            "reviewDataSource",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode, v.reviewDataSource)
        ],
        [
            "tagFacetExtractorRegex",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.tagFacetExtractorRegex)
        ],
        [
            "embeddedApp",
            $02d9048f3e76c404$export$be3ced6f4da28ba(v.embeddedApp)
        ],
        [
            "shopifyStorefrontAccessToken",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.shopifyStorefrontAccessToken)
        ],
        [
            "status",
            $02d9048f3e76c404$var$t_encode$1(v.status)
        ],
        [
            "shopifyScopes",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.shopifyScopes)
        ]
    ]);
}
function $02d9048f3e76c404$export$bb5e712207166a02(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var storeId = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "storeId"), null));
    if (storeId.TAG === /* Ok */ 0) {
        var platform = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "platform"), null));
        if (platform.TAG === /* Ok */ 0) {
            var platformToken = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "platformToken"), null));
            if (platformToken.TAG === /* Ok */ 0) {
                var platformUrl = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "platformUrl"), null));
                if (platformUrl.TAG === /* Ok */ 0) {
                    var reviewDataSource = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "reviewDataSource"), null));
                    if (reviewDataSource.TAG === /* Ok */ 0) {
                        var tagFacetExtractorRegex = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "tagFacetExtractorRegex"), null));
                        if (tagFacetExtractorRegex.TAG === /* Ok */ 0) {
                            var embeddedApp = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "embeddedApp"), $02d9048f3e76c404$export$8c5cddc4f9a087aa), {
                                TAG: /* Ok */ 0,
                                _0: /* NavAppEmbed */ 1
                            });
                            if (embeddedApp.TAG === /* Ok */ 0) {
                                var shopifyStorefrontAccessToken = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "shopifyStorefrontAccessToken"), null));
                                if (shopifyStorefrontAccessToken.TAG === /* Ok */ 0) {
                                    var status = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "status"), $02d9048f3e76c404$var$t_decode$1), {
                                        TAG: /* Ok */ 0,
                                        _0: /* Active */ 0
                                    });
                                    if (status.TAG === /* Ok */ 0) {
                                        var shopifyScopes = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "shopifyScopes"), function(param) {
                                            return $3zjNo.arrayFromJson($3zjNo.stringFromJson, param);
                                        }), {
                                            TAG: /* Ok */ 0,
                                            _0: []
                                        });
                                        if (shopifyScopes.TAG === /* Ok */ 0) return {
                                            TAG: /* Ok */ 0,
                                            _0: {
                                                storeId: storeId._0,
                                                platform: platform._0,
                                                platformToken: platformToken._0,
                                                platformUrl: platformUrl._0,
                                                reviewDataSource: reviewDataSource._0,
                                                tagFacetExtractorRegex: tagFacetExtractorRegex._0,
                                                embeddedApp: embeddedApp._0,
                                                shopifyStorefrontAccessToken: shopifyStorefrontAccessToken._0,
                                                status: status._0,
                                                shopifyScopes: shopifyScopes._0
                                            }
                                        };
                                        var e = shopifyScopes._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".shopifyScopes" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = status._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".status" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = shopifyStorefrontAccessToken._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".shopifyStorefrontAccessToken" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = embeddedApp._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".embeddedApp" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = tagFacetExtractorRegex._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".tagFacetExtractorRegex" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = reviewDataSource._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".reviewDataSource" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = platformUrl._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".platformUrl" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = platformToken._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".platformToken" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = platform._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".platform" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = storeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".storeId" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
var $02d9048f3e76c404$export$1c37c01eba8ed446 = [
    $02d9048f3e76c404$export$cc42ff7b6c615091,
    $02d9048f3e76c404$export$bb5e712207166a02
];
function $02d9048f3e76c404$var$t_encode$3(v) {
    return $d3YYW.fromArray([
        [
            "id",
            $3zjNo.stringToJson(v.id)
        ],
        [
            "platform",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.platform)
        ],
        [
            "platformUrl",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.platformUrl)
        ],
        [
            "shopifyStorefrontAccessToken",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.shopifyStorefrontAccessToken)
        ],
        [
            "shopifyScopes",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.shopifyScopes)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$3(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var id = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var platform = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "platform"), null));
        if (platform.TAG === /* Ok */ 0) {
            var platformUrl = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "platformUrl"), null));
            if (platformUrl.TAG === /* Ok */ 0) {
                var shopifyStorefrontAccessToken = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "shopifyStorefrontAccessToken"), null));
                if (shopifyStorefrontAccessToken.TAG === /* Ok */ 0) {
                    var shopifyScopes = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "shopifyScopes"), function(param) {
                        return $3zjNo.arrayFromJson($3zjNo.stringFromJson, param);
                    }), {
                        TAG: /* Ok */ 0,
                        _0: []
                    });
                    if (shopifyScopes.TAG === /* Ok */ 0) return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            platform: platform._0,
                            platformUrl: platformUrl._0,
                            shopifyStorefrontAccessToken: shopifyStorefrontAccessToken._0,
                            shopifyScopes: shopifyScopes._0
                        }
                    };
                    var e = shopifyScopes._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".shopifyScopes" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = shopifyStorefrontAccessToken._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".shopifyStorefrontAccessToken" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = platformUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".platformUrl" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = platform._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".platform" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var $02d9048f3e76c404$var$codec$1 = [
    $02d9048f3e76c404$var$t_encode$3,
    $02d9048f3e76c404$var$t_decode$3
];
var $02d9048f3e76c404$export$68b4491d6924a6d1 = {
    t_encode: $02d9048f3e76c404$var$t_encode$3,
    t_decode: $02d9048f3e76c404$var$t_decode$3,
    codec: $02d9048f3e76c404$var$codec$1,
    toJson: $02d9048f3e76c404$var$t_encode$3,
    fromJson: $02d9048f3e76c404$var$t_decode$3
};
function $02d9048f3e76c404$var$change_encode(v) {
    if (v.TAG === /* ReviewDataSource */ 0) return [
        "ReviewDataSource",
        $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode, v._0)
    ];
    else return [
        "Status",
        $02d9048f3e76c404$var$t_encode$1(v._0)
    ];
}
function $02d9048f3e76c404$var$change_decode(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "ReviewDataSource":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0 = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode, $i7mYY.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ReviewDataSource */ 0,
                    _0: v0._0
                }
            };
            var e = v0._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        case "Status":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$1 = $02d9048f3e76c404$var$t_decode$1($i7mYY.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Status */ 1,
                    _0: v0$1._0
                }
            };
            var e$1 = v0$1._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
function $02d9048f3e76c404$var$t_encode$4(v) {
    return $3zjNo.arrayToJson($02d9048f3e76c404$var$change_encode, v);
}
function $02d9048f3e76c404$var$t_decode$4(v) {
    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$change_decode, v);
}
var $02d9048f3e76c404$var$codec$2 = [
    $02d9048f3e76c404$var$t_encode$4,
    $02d9048f3e76c404$var$t_decode$4
];
var $02d9048f3e76c404$export$efb53073f026782 = {
    change_encode: $02d9048f3e76c404$var$change_encode,
    change_decode: $02d9048f3e76c404$var$change_decode,
    t_encode: $02d9048f3e76c404$var$t_encode$4,
    t_decode: $02d9048f3e76c404$var$t_decode$4,
    codec: $02d9048f3e76c404$var$codec$2,
    toJson: $02d9048f3e76c404$var$t_encode$4,
    fromJson: $02d9048f3e76c404$var$t_decode$4
};
function $02d9048f3e76c404$var$t_encode$5(v) {
    switch(v){
        case /* Default */ 0:
            return [
                "Default"
            ];
        case /* Featured */ 1:
            return [
                "Featured"
            ];
        case /* BestSellers */ 2:
            return [
                "BestSellers"
            ];
        case /* Newest */ 3:
            return [
                "Newest"
            ];
        case /* HighestPrice */ 4:
            return [
                "HighestPrice"
            ];
        case /* LowestPrice */ 5:
            return [
                "LowestPrice"
            ];
        case /* HighestDiscount */ 6:
            return [
                "HighestDiscount"
            ];
    }
}
function $02d9048f3e76c404$var$t_decode$5(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "BestSellers":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* BestSellers */ 2
            };
        case "Default":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Default */ 0
            };
        case "Featured":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Featured */ 1
            };
        case "HighestDiscount":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* HighestDiscount */ 6
            };
        case "HighestPrice":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* HighestPrice */ 4
            };
        case "LowestPrice":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* LowestPrice */ 5
            };
        case "Newest":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Newest */ 3
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
var $02d9048f3e76c404$var$all = [
    /* Default */ 0,
    /* Featured */ 1,
    /* BestSellers */ 2,
    /* Newest */ 3,
    /* HighestPrice */ 4,
    /* LowestPrice */ 5,
    /* HighestDiscount */ 6
];
function $02d9048f3e76c404$var$fromString$1(str) {
    switch(str){
        case "best_sellers":
            return /* BestSellers */ 2;
        case "default":
            return /* Default */ 0;
        case "featured":
            return /* Featured */ 1;
        case "highest_discount":
            return /* HighestDiscount */ 6;
        case "highest_price":
            return /* HighestPrice */ 4;
        case "lowest_price":
            return /* LowestPrice */ 5;
        case "newest":
            return /* Newest */ 3;
        default:
            return /* Default */ 0;
    }
}
function $02d9048f3e76c404$var$toString$1(sort) {
    switch(sort){
        case /* Default */ 0:
            return "default";
        case /* Featured */ 1:
            return "featured";
        case /* BestSellers */ 2:
            return "best_sellers";
        case /* Newest */ 3:
            return "newest";
        case /* HighestPrice */ 4:
            return "highest_price";
        case /* LowestPrice */ 5:
            return "lowest_price";
        case /* HighestDiscount */ 6:
            return "highest_discount";
    }
}
var $02d9048f3e76c404$export$1fffe7771e220b3d = {
    t_encode: $02d9048f3e76c404$var$t_encode$5,
    t_decode: $02d9048f3e76c404$var$t_decode$5,
    all: $02d9048f3e76c404$var$all,
    fromString: $02d9048f3e76c404$var$fromString$1,
    toString: $02d9048f3e76c404$var$toString$1
};
function $02d9048f3e76c404$var$t_encode$6(v) {
    return $d3YYW.fromArray([
        [
            "url",
            $3zjNo.stringToJson(v.url)
        ],
        [
            "size",
            $3zjNo.optionToJson(function(param) {
                return [
                    $3zjNo.intToJson(param[0]),
                    $3zjNo.intToJson(param[1])
                ];
            }, v.size)
        ],
        [
            "altText",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.altText)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$6(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var url = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var size = $3zjNo.optionFromJson(function(json) {
            var match = $1ArWc.classify(json);
            if (typeof match === "number") return $3zjNo.error(undefined, "Not a tuple", json);
            if (match.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a tuple", json);
            var match$1 = match._0;
            if (match$1.length !== 2) return $3zjNo.error(undefined, "Incorrect cardinality", json);
            var v0 = match$1[0];
            var v1 = match$1[1];
            var match$2 = $3zjNo.intFromJson(v0);
            var match$3 = $3zjNo.intFromJson(v1);
            if (match$2.TAG === /* Ok */ 0) {
                if (match$3.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
                var e = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[1]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }, $2whNH.getWithDefault($d3YYW.get(dict$1, "size"), null));
        if (size.TAG === /* Ok */ 0) {
            var altText = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "altText"), null));
            if (altText.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    size: size._0,
                    altText: altText._0
                }
            };
            var e = altText._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".altText" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = size._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".size" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$export$3105334b5e06e972 = {
    t_encode: $02d9048f3e76c404$var$t_encode$6,
    t_decode: $02d9048f3e76c404$var$t_decode$6
};
function $02d9048f3e76c404$var$t_encode$7(v) {
    var param = v.size;
    return $d3YYW.fromArray([
        [
            "mimeType",
            $3zjNo.stringToJson(v.mimeType)
        ],
        [
            "size",
            [
                $3zjNo.intToJson(param[0]),
                $3zjNo.intToJson(param[1])
            ]
        ],
        [
            "url",
            $3zjNo.stringToJson(v.url)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$7(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var mimeType = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "mimeType"), null));
    if (mimeType.TAG === /* Ok */ 0) {
        var json = $2whNH.getWithDefault($d3YYW.get(dict$1, "size"), null);
        var match = $1ArWc.classify(json);
        var size;
        if (typeof match === "number" || match.TAG !== /* JSONArray */ 3) size = $3zjNo.error(undefined, "Not a tuple", json);
        else {
            var match$1 = match._0;
            if (match$1.length !== 2) size = $3zjNo.error(undefined, "Incorrect cardinality", json);
            else {
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = $3zjNo.intFromJson(v0);
                var match$3 = $3zjNo.intFromJson(v1);
                if (match$2.TAG === /* Ok */ 0) {
                    if (match$3.TAG === /* Ok */ 0) size = {
                        TAG: /* Ok */ 0,
                        _0: [
                            match$2._0,
                            match$3._0
                        ]
                    };
                    else {
                        var e = match$3._0;
                        size = {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                } else {
                    var e$1 = match$2._0;
                    size = {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
            }
        }
        if (size.TAG === /* Ok */ 0) {
            var url = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    mimeType: mimeType._0,
                    size: size._0,
                    url: url._0
                }
            };
            var e$2 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = size._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".size" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = mimeType._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".mimeType" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var $02d9048f3e76c404$export$f3a17123d80000c5 = {
    t_encode: $02d9048f3e76c404$var$t_encode$7,
    t_decode: $02d9048f3e76c404$var$t_decode$7
};
function $02d9048f3e76c404$var$t_encode$8(v) {
    return $d3YYW.fromArray([
        [
            "poster",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.poster)
        ],
        [
            "sources",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$7, v.sources)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$8(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var poster = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "poster"), null));
    if (poster.TAG === /* Ok */ 0) {
        var sources = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$7, $2whNH.getWithDefault($d3YYW.get(dict$1, "sources"), null));
        if (sources.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                poster: poster._0,
                sources: sources._0
            }
        };
        var e = sources._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sources" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = poster._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".poster" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$ae01dedf5c052bb = {
    t_encode: $02d9048f3e76c404$var$t_encode$8,
    t_decode: $02d9048f3e76c404$var$t_decode$8
};
function $02d9048f3e76c404$var$t_encode$9(v) {
    if (v.TAG === /* TypeImage */ 0) return [
        "TypeImage",
        $02d9048f3e76c404$var$t_encode$6(v._0)
    ];
    else return [
        "TypeVideo",
        $02d9048f3e76c404$var$t_encode$8(v._0)
    ];
}
function $02d9048f3e76c404$var$t_decode$9(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "TypeImage":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0 = $02d9048f3e76c404$var$t_decode$6($i7mYY.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* TypeImage */ 0,
                    _0: v0._0
                }
            };
            var e = v0._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        case "TypeVideo":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$1 = $02d9048f3e76c404$var$t_decode$8($i7mYY.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* TypeVideo */ 1,
                    _0: v0$1._0
                }
            };
            var e$1 = v0$1._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
var $02d9048f3e76c404$export$7fc53215244aec38 = {
    t_encode: $02d9048f3e76c404$var$t_encode$9,
    t_decode: $02d9048f3e76c404$var$t_decode$9
};
function $02d9048f3e76c404$var$t_encode$10(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "media",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$9, v.media)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$10(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $iv6Yc._1($cXHd0.t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "page"), null));
    if (page.TAG === /* Ok */ 0) {
        var media = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$9, $2whNH.getWithDefault($d3YYW.get(dict$1, "media"), null));
        if (media.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                page: page._0,
                media: media._0
            }
        };
        var e = media._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".media" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$53929fb5a2c5d0c9 = {
    t_encode: $02d9048f3e76c404$var$t_encode$10,
    t_decode: $02d9048f3e76c404$var$t_decode$10
};
function $02d9048f3e76c404$var$t_encode$11(v) {
    return $d3YYW.fromArray([
        [
            "name",
            $3zjNo.stringToJson(v.name)
        ],
        [
            "contentUrl",
            $3zjNo.stringToJson(v.contentUrl)
        ],
        [
            "thumbnailUrl",
            $3zjNo.stringToJson(v.thumbnailUrl)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$11(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var name = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */ 0) {
        var contentUrl = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "contentUrl"), null));
        if (contentUrl.TAG === /* Ok */ 0) {
            var thumbnailUrl = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "thumbnailUrl"), null));
            if (thumbnailUrl.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    name: name._0,
                    contentUrl: contentUrl._0,
                    thumbnailUrl: thumbnailUrl._0
                }
            };
            var e = thumbnailUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".thumbnailUrl" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = contentUrl._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".contentUrl" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = name._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".name" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$export$228b9a1f50e2b301 = {
    t_encode: $02d9048f3e76c404$var$t_encode$11,
    t_decode: $02d9048f3e76c404$var$t_decode$11
};
function $02d9048f3e76c404$var$t_encode$12(v) {
    return $d3YYW.fromArray([
        [
            "count",
            $3zjNo.intToJson(v.count)
        ],
        [
            "average",
            $3zjNo.floatToJson(v.average)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$12(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var count = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "count"), null));
    if (count.TAG === /* Ok */ 0) {
        var average = $3zjNo.floatFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "average"), null));
        if (average.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                count: count._0,
                average: average._0
            }
        };
        var e = average._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".average" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = count._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".count" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$891cf6ebb52730c = {
    t_encode: $02d9048f3e76c404$var$t_encode$12,
    t_decode: $02d9048f3e76c404$var$t_decode$12
};
function $02d9048f3e76c404$var$t_encode$13(v) {
    return $d3YYW.fromArray([
        [
            "amount",
            $3zjNo.stringToJson(v.amount)
        ],
        [
            "currencyCode",
            $3zjNo.stringToJson(v.currencyCode)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$13(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var amount = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */ 0) {
        var currencyCode = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "currencyCode"), null));
        if (currencyCode.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                amount: amount._0,
                currencyCode: currencyCode._0
            }
        };
        var e = currencyCode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".currencyCode" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = amount._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".amount" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$d26bcf891bc220f6 = {
    t_encode: $02d9048f3e76c404$var$t_encode$13,
    t_decode: $02d9048f3e76c404$var$t_decode$13
};
function $02d9048f3e76c404$var$t_encode$14(v) {
    return $d3YYW.fromArray([
        [
            "unitName",
            $3zjNo.stringToJson(v.unitName)
        ],
        [
            "value",
            $3zjNo.floatToJson(v.value)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$14(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var unitName = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "unitName"), null));
    if (unitName.TAG === /* Ok */ 0) {
        var value = $3zjNo.floatFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                unitName: unitName._0,
                value: value._0
            }
        };
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = unitName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".unitName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$988a01c904bee102 = {
    t_encode: $02d9048f3e76c404$var$t_encode$14,
    t_decode: $02d9048f3e76c404$var$t_decode$14
};
function $02d9048f3e76c404$var$t_encode$15(v) {
    return $d3YYW.fromArray([
        [
            "value",
            $3zjNo.floatToJson(v.value)
        ],
        [
            "scaleMin",
            $3zjNo.floatToJson(v.scaleMin)
        ],
        [
            "scaleMax",
            $3zjNo.floatToJson(v.scaleMax)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$15(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var value = $3zjNo.floatFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */ 0) {
        var scaleMin = $3zjNo.floatFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "scaleMin"), null));
        if (scaleMin.TAG === /* Ok */ 0) {
            var scaleMax = $3zjNo.floatFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "scaleMax"), null));
            if (scaleMax.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    value: value._0,
                    scaleMin: scaleMin._0,
                    scaleMax: scaleMax._0
                }
            };
            var e = scaleMax._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".scaleMax" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = scaleMin._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".scaleMin" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = value._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".value" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$export$8ba663d22f9191ae = {
    t_encode: $02d9048f3e76c404$var$t_encode$15,
    t_decode: $02d9048f3e76c404$var$t_decode$15
};
function $02d9048f3e76c404$var$t_encode$16(v) {
    return $d3YYW.fromArray([
        [
            "text",
            $3zjNo.stringToJson(v.text)
        ],
        [
            "url",
            $3zjNo.stringToJson(v.url)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$16(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var text = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "text"), null));
    if (text.TAG === /* Ok */ 0) {
        var url = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                text: text._0,
                url: url._0
            }
        };
        var e = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = text._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$export$a6c7ac8248d6e38a = {
    t_encode: $02d9048f3e76c404$var$t_encode$16,
    t_decode: $02d9048f3e76c404$var$t_decode$16
};
function $02d9048f3e76c404$var$t_encode$17(v) {
    if (typeof v === "number") return [
        "Unsupported"
    ];
    switch(v.TAG | 0){
        case /* MultiLineTextField */ 0:
            return [
                "MultiLineTextField",
                $3zjNo.stringToJson(v._0)
            ];
        case /* SingleLineTextField */ 1:
            return [
                "SingleLineTextField",
                $3zjNo.stringToJson(v._0)
            ];
        case /* DecimalField */ 2:
            return [
                "DecimalField",
                $3zjNo.floatToJson(v._0)
            ];
        case /* IntegerField */ 3:
            return [
                "IntegerField",
                $3zjNo.floatToJson(v._0)
            ];
        case /* Dimension */ 4:
            return [
                "Dimension",
                $02d9048f3e76c404$var$t_encode$14(v._0)
            ];
        case /* Date */ 5:
            return [
                "Date",
                $3zjNo.stringToJson(v._0)
            ];
        case /* DateTime */ 6:
            return [
                "DateTime",
                $3zjNo.stringToJson(v._0)
            ];
        case /* Color */ 7:
            return [
                "Color",
                $3zjNo.stringToJson(v._0)
            ];
        case /* Boolean */ 8:
            return [
                "Boolean",
                $3zjNo.boolToJson(v._0)
            ];
        case /* Json */ 9:
            return [
                "Json",
                v._0
            ];
        case /* Money */ 10:
            return [
                "Money",
                $02d9048f3e76c404$var$t_encode$13(v._0)
            ];
        case /* Volume */ 11:
            return [
                "Volume",
                $02d9048f3e76c404$var$t_encode$14(v._0)
            ];
        case /* Weight */ 12:
            return [
                "Weight",
                $02d9048f3e76c404$var$t_encode$14(v._0)
            ];
        case /* Url */ 13:
            return [
                "Url",
                $3zjNo.stringToJson(v._0)
            ];
        case /* Rating */ 14:
            return [
                "Rating",
                $3zjNo.stringToJson(v._0)
            ];
        case /* FileReference */ 15:
            return [
                "FileReference",
                $02d9048f3e76c404$var$t_encode$9(v._0)
            ];
        case /* Audio */ 16:
            return [
                "Audio",
                $02d9048f3e76c404$var$t_encode$11(v._0)
            ];
        case /* ListColor */ 17:
            return [
                "ListColor",
                $3zjNo.arrayToJson($3zjNo.stringToJson, v._0)
            ];
        case /* ListDimension */ 18:
            return [
                "ListDimension",
                $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$14, v._0)
            ];
        case /* ListLink */ 19:
            return [
                "ListLink",
                $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$16, v._0)
            ];
        case /* ListRating */ 20:
            return [
                "ListRating",
                $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$15, v._0)
            ];
        case /* ListSingleLineTextField */ 21:
            return [
                "ListSingleLineTextField",
                $3zjNo.arrayToJson($3zjNo.stringToJson, v._0)
            ];
        case /* ListUrl */ 22:
            return [
                "ListUrl",
                $3zjNo.arrayToJson($3zjNo.stringToJson, v._0)
            ];
        case /* ListVolume */ 23:
            return [
                "ListVolume",
                $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$14, v._0)
            ];
        case /* ListWeight */ 24:
            return [
                "ListWeight",
                $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$14, v._0)
            ];
        case /* ListNumberDecimal */ 25:
            return [
                "ListNumberDecimal",
                $3zjNo.arrayToJson($3zjNo.floatToJson, v._0)
            ];
        case /* ListNumberInteger */ 26:
            return [
                "ListNumberInteger",
                $3zjNo.arrayToJson($3zjNo.floatToJson, v._0)
            ];
        case /* ListProductReference */ 27:
            return [
                "ListProductReference",
                $3zjNo.arrayToJson($hG39s.ProductId.t_encode, v._0)
            ];
    }
}
function $02d9048f3e76c404$var$t_decode$17(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "Audio":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0 = $02d9048f3e76c404$var$t_decode$11($i7mYY.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Audio */ 16,
                    _0: v0._0
                }
            };
            var e = v0._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        case "Boolean":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$1 = $3zjNo.boolFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Boolean */ 8,
                    _0: v0$1._0
                }
            };
            var e$1 = v0$1._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        case "Color":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$2 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$2.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Color */ 7,
                    _0: v0$2._0
                }
            };
            var e$2 = v0$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        case "Date":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$3 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$3.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Date */ 5,
                    _0: v0$3._0
                }
            };
            var e$3 = v0$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        case "DateTime":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$4 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$4.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* DateTime */ 6,
                    _0: v0$4._0
                }
            };
            var e$4 = v0$4._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        case "DecimalField":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$5 = $3zjNo.floatFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$5.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* DecimalField */ 2,
                    _0: v0$5._0
                }
            };
            var e$5 = v0$5._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        case "Dimension":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$6 = $02d9048f3e76c404$var$t_decode$14($i7mYY.getExn(jsonArr$1, 1));
            if (v0$6.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Dimension */ 4,
                    _0: v0$6._0
                }
            };
            var e$6 = v0$6._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                }
            };
        case "FileReference":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$7 = $02d9048f3e76c404$var$t_decode$9($i7mYY.getExn(jsonArr$1, 1));
            if (v0$7.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* FileReference */ 15,
                    _0: v0$7._0
                }
            };
            var e$7 = v0$7._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        case "IntegerField":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$8 = $3zjNo.floatFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$8.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* IntegerField */ 3,
                    _0: v0$8._0
                }
            };
            var e$8 = v0$8._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        case "Json":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$9 = {
                TAG: /* Ok */ 0,
                _0: $i7mYY.getExn(jsonArr$1, 1)
            };
            if (v0$9.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Json */ 9,
                    _0: v0$9._0
                }
            };
            var e$9 = v0$9._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                }
            };
        case "ListColor":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$10 = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$10.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListColor */ 17,
                    _0: v0$10._0
                }
            };
            var e$10 = v0$10._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                }
            };
        case "ListDimension":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$11 = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$14, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$11.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListDimension */ 18,
                    _0: v0$11._0
                }
            };
            var e$11 = v0$11._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                }
            };
        case "ListLink":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$12 = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$16, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$12.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListLink */ 19,
                    _0: v0$12._0
                }
            };
            var e$12 = v0$12._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                }
            };
        case "ListNumberDecimal":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$13 = $3zjNo.arrayFromJson($3zjNo.floatFromJson, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$13.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListNumberDecimal */ 25,
                    _0: v0$13._0
                }
            };
            var e$13 = v0$13._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                }
            };
        case "ListNumberInteger":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$14 = $3zjNo.arrayFromJson($3zjNo.floatFromJson, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$14.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListNumberInteger */ 26,
                    _0: v0$14._0
                }
            };
            var e$14 = v0$14._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                }
            };
        case "ListProductReference":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$15 = $3zjNo.arrayFromJson($hG39s.ProductId.t_decode, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$15.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListProductReference */ 27,
                    _0: v0$15._0
                }
            };
            var e$15 = v0$15._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                }
            };
        case "ListRating":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$16 = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$15, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$16.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListRating */ 20,
                    _0: v0$16._0
                }
            };
            var e$16 = v0$16._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                }
            };
        case "ListSingleLineTextField":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$17 = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$17.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListSingleLineTextField */ 21,
                    _0: v0$17._0
                }
            };
            var e$17 = v0$17._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                }
            };
        case "ListUrl":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$18 = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$18.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListUrl */ 22,
                    _0: v0$18._0
                }
            };
            var e$18 = v0$18._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                }
            };
        case "ListVolume":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$19 = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$14, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$19.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListVolume */ 23,
                    _0: v0$19._0
                }
            };
            var e$19 = v0$19._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                }
            };
        case "ListWeight":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$20 = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$14, $i7mYY.getExn(jsonArr$1, 1));
            if (v0$20.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* ListWeight */ 24,
                    _0: v0$20._0
                }
            };
            var e$20 = v0$20._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                }
            };
        case "Money":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$21 = $02d9048f3e76c404$var$t_decode$13($i7mYY.getExn(jsonArr$1, 1));
            if (v0$21.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Money */ 10,
                    _0: v0$21._0
                }
            };
            var e$21 = v0$21._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                }
            };
        case "MultiLineTextField":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$22 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$22.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* MultiLineTextField */ 0,
                    _0: v0$22._0
                }
            };
            var e$22 = v0$22._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                }
            };
        case "Rating":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$23 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$23.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Rating */ 14,
                    _0: v0$23._0
                }
            };
            var e$23 = v0$23._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                }
            };
        case "SingleLineTextField":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$24 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$24.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* SingleLineTextField */ 1,
                    _0: v0$24._0
                }
            };
            var e$24 = v0$24._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                }
            };
        case "Unsupported":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Unsupported */ 0
            };
        case "Url":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$25 = $3zjNo.stringFromJson($i7mYY.getExn(jsonArr$1, 1));
            if (v0$25.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Url */ 13,
                    _0: v0$25._0
                }
            };
            var e$25 = v0$25._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                }
            };
        case "Volume":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$26 = $02d9048f3e76c404$var$t_decode$14($i7mYY.getExn(jsonArr$1, 1));
            if (v0$26.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Volume */ 11,
                    _0: v0$26._0
                }
            };
            var e$26 = v0$26._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                }
            };
        case "Weight":
            if (tagged.length !== 2) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            var v0$27 = $02d9048f3e76c404$var$t_decode$14($i7mYY.getExn(jsonArr$1, 1));
            if (v0$27.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Weight */ 12,
                    _0: v0$27._0
                }
            };
            var e$27 = v0$27._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                }
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
var $02d9048f3e76c404$export$e7adebdc1ebd2fed = {
    t_encode: $02d9048f3e76c404$var$t_encode$17,
    t_decode: $02d9048f3e76c404$var$t_decode$17
};
function $02d9048f3e76c404$var$t_encode$18(v) {
    return $d3YYW.fromArray([
        [
            "id",
            $3zjNo.stringToJson(v.id)
        ],
        [
            "name",
            $3zjNo.stringToJson(v.name)
        ],
        [
            "values",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.values)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$18(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var id = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var values = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "values"), null));
            if (values.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    id: id._0,
                    name: name._0,
                    values: values._0
                }
            };
            var e = values._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".values" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$var$$$Option = {
    t_encode: $02d9048f3e76c404$var$t_encode$18,
    t_decode: $02d9048f3e76c404$var$t_decode$18
};
function $02d9048f3e76c404$var$t_encode$19(v) {
    return $d3YYW.fromArray([
        [
            "quantity",
            $3zjNo.optionToJson($3zjNo.intToJson, v.quantity)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$19(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var quantity = $3zjNo.optionFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict._0, "quantity"), null));
    if (quantity.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: {
            quantity: quantity._0
        }
    };
    var e = quantity._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".quantity" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
var $02d9048f3e76c404$var$Inventory = {
    t_encode: $02d9048f3e76c404$var$t_encode$19,
    t_decode: $02d9048f3e76c404$var$t_decode$19
};
function $02d9048f3e76c404$var$t_encode$20(v) {
    return $d3YYW.fromArray([
        [
            "id",
            $3zjNo.stringToJson(v.id)
        ],
        [
            "name",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.name)
        ],
        [
            "description",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.description)
        ],
        [
            "price",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.price)
        ],
        [
            "price2",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.price2)
        ],
        [
            "compareAtPrice",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.compareAtPrice)
        ],
        [
            "compareAtPrice2",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.compareAtPrice2)
        ],
        [
            "sku",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.sku)
        ],
        [
            "imageId",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.imageId)
        ],
        [
            "mediaIndex",
            $3zjNo.optionToJson($3zjNo.intToJson, v.mediaIndex)
        ],
        [
            "mediaIndexesSourcedFromVariant",
            $3zjNo.optionToJson(function(param) {
                return $3zjNo.arrayToJson($3zjNo.intToJson, param);
            }, v.mediaIndexesSourcedFromVariant)
        ],
        [
            "option1",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.option1)
        ],
        [
            "option2",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.option2)
        ],
        [
            "option3",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.option3)
        ],
        [
            "inventory",
            $02d9048f3e76c404$var$t_encode$19(v.inventory)
        ],
        [
            "inventory2",
            $02d9048f3e76c404$var$t_encode$19(v.inventory2)
        ],
        [
            "link",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.link)
        ],
        [
            "customLabels",
            $3zjNo.arrayToJson(function(param) {
                return $3zjNo.optionToJson($3zjNo.stringToJson, param);
            }, v.customLabels)
        ],
        [
            "brand",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.brand)
        ],
        [
            "mpn",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.mpn)
        ],
        [
            "promoText",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.promoText)
        ],
        [
            "metadata",
            $3zjNo.dictToJson($02d9048f3e76c404$var$t_encode$17, v.metadata)
        ],
        [
            "barcode",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.barcode)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$20(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var id = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var description = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "description"), null));
            if (description.TAG === /* Ok */ 0) {
                var price = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "price"), null));
                if (price.TAG === /* Ok */ 0) {
                    var price2 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "price2"), null));
                    if (price2.TAG === /* Ok */ 0) {
                        var compareAtPrice = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "compareAtPrice"), null));
                        if (compareAtPrice.TAG === /* Ok */ 0) {
                            var compareAtPrice2 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "compareAtPrice2"), null));
                            if (compareAtPrice2.TAG === /* Ok */ 0) {
                                var sku = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "sku"), null));
                                if (sku.TAG === /* Ok */ 0) {
                                    var imageId = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "imageId"), null));
                                    if (imageId.TAG === /* Ok */ 0) {
                                        var mediaIndex = $3zjNo.optionFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "mediaIndex"), null));
                                        if (mediaIndex.TAG === /* Ok */ 0) {
                                            var mediaIndexesSourcedFromVariant = $3zjNo.optionFromJson(function(param) {
                                                return $3zjNo.arrayFromJson($3zjNo.intFromJson, param);
                                            }, $2whNH.getWithDefault($d3YYW.get(dict$1, "mediaIndexesSourcedFromVariant"), null));
                                            if (mediaIndexesSourcedFromVariant.TAG === /* Ok */ 0) {
                                                var option1 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "option1"), null));
                                                if (option1.TAG === /* Ok */ 0) {
                                                    var option2 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "option2"), null));
                                                    if (option2.TAG === /* Ok */ 0) {
                                                        var option3 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "option3"), null));
                                                        if (option3.TAG === /* Ok */ 0) {
                                                            var inventory = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "inventory"), $02d9048f3e76c404$var$t_decode$19), {
                                                                TAG: /* Ok */ 0,
                                                                _0: {
                                                                    quantity: undefined
                                                                }
                                                            });
                                                            if (inventory.TAG === /* Ok */ 0) {
                                                                var inventory2 = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "inventory2"), $02d9048f3e76c404$var$t_decode$19), {
                                                                    TAG: /* Ok */ 0,
                                                                    _0: {
                                                                        quantity: undefined
                                                                    }
                                                                });
                                                                if (inventory2.TAG === /* Ok */ 0) {
                                                                    var link = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "link"), null));
                                                                    if (link.TAG === /* Ok */ 0) {
                                                                        var customLabels = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "customLabels"), function(param) {
                                                                            return $3zjNo.arrayFromJson(function(param) {
                                                                                return $3zjNo.optionFromJson($3zjNo.stringFromJson, param);
                                                                            }, param);
                                                                        }), {
                                                                            TAG: /* Ok */ 0,
                                                                            _0: []
                                                                        });
                                                                        if (customLabels.TAG === /* Ok */ 0) {
                                                                            var brand = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "brand"), null));
                                                                            if (brand.TAG === /* Ok */ 0) {
                                                                                var mpn = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "mpn"), null));
                                                                                if (mpn.TAG === /* Ok */ 0) {
                                                                                    var promoText = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "promoText"), null));
                                                                                    if (promoText.TAG === /* Ok */ 0) {
                                                                                        var metadata = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "metadata"), function(param) {
                                                                                            return $3zjNo.dictFromJson($02d9048f3e76c404$var$t_decode$17, param);
                                                                                        }), {
                                                                                            TAG: /* Ok */ 0,
                                                                                            _0: {}
                                                                                        });
                                                                                        if (metadata.TAG === /* Ok */ 0) {
                                                                                            var barcode = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "barcode"), null));
                                                                                            if (barcode.TAG === /* Ok */ 0) return {
                                                                                                TAG: /* Ok */ 0,
                                                                                                _0: {
                                                                                                    id: id._0,
                                                                                                    name: name._0,
                                                                                                    description: description._0,
                                                                                                    price: price._0,
                                                                                                    price2: price2._0,
                                                                                                    compareAtPrice: compareAtPrice._0,
                                                                                                    compareAtPrice2: compareAtPrice2._0,
                                                                                                    sku: sku._0,
                                                                                                    imageId: imageId._0,
                                                                                                    mediaIndex: mediaIndex._0,
                                                                                                    mediaIndexesSourcedFromVariant: mediaIndexesSourcedFromVariant._0,
                                                                                                    option1: option1._0,
                                                                                                    option2: option2._0,
                                                                                                    option3: option3._0,
                                                                                                    inventory: inventory._0,
                                                                                                    inventory2: inventory2._0,
                                                                                                    link: link._0,
                                                                                                    customLabels: customLabels._0,
                                                                                                    brand: brand._0,
                                                                                                    mpn: mpn._0,
                                                                                                    promoText: promoText._0,
                                                                                                    metadata: metadata._0,
                                                                                                    barcode: barcode._0
                                                                                                }
                                                                                            };
                                                                                            var e = barcode._0;
                                                                                            return {
                                                                                                TAG: /* Error */ 1,
                                                                                                _0: {
                                                                                                    path: ".barcode" + e.path,
                                                                                                    message: e.message,
                                                                                                    value: e.value
                                                                                                }
                                                                                            };
                                                                                        }
                                                                                        var e$1 = metadata._0;
                                                                                        return {
                                                                                            TAG: /* Error */ 1,
                                                                                            _0: {
                                                                                                path: ".metadata" + e$1.path,
                                                                                                message: e$1.message,
                                                                                                value: e$1.value
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                    var e$2 = promoText._0;
                                                                                    return {
                                                                                        TAG: /* Error */ 1,
                                                                                        _0: {
                                                                                            path: ".promoText" + e$2.path,
                                                                                            message: e$2.message,
                                                                                            value: e$2.value
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e$3 = mpn._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".mpn" + e$3.path,
                                                                                        message: e$3.message,
                                                                                        value: e$3.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$4 = brand._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".brand" + e$4.path,
                                                                                    message: e$4.message,
                                                                                    value: e$4.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$5 = customLabels._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".customLabels" + e$5.path,
                                                                                message: e$5.message,
                                                                                value: e$5.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$6 = link._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".link" + e$6.path,
                                                                            message: e$6.message,
                                                                            value: e$6.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$7 = inventory2._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".inventory2" + e$7.path,
                                                                        message: e$7.message,
                                                                        value: e$7.value
                                                                    }
                                                                };
                                                            }
                                                            var e$8 = inventory._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".inventory" + e$8.path,
                                                                    message: e$8.message,
                                                                    value: e$8.value
                                                                }
                                                            };
                                                        }
                                                        var e$9 = option3._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".option3" + e$9.path,
                                                                message: e$9.message,
                                                                value: e$9.value
                                                            }
                                                        };
                                                    }
                                                    var e$10 = option2._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".option2" + e$10.path,
                                                            message: e$10.message,
                                                            value: e$10.value
                                                        }
                                                    };
                                                }
                                                var e$11 = option1._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".option1" + e$11.path,
                                                        message: e$11.message,
                                                        value: e$11.value
                                                    }
                                                };
                                            }
                                            var e$12 = mediaIndexesSourcedFromVariant._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".mediaIndexesSourcedFromVariant" + e$12.path,
                                                    message: e$12.message,
                                                    value: e$12.value
                                                }
                                            };
                                        }
                                        var e$13 = mediaIndex._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".mediaIndex" + e$13.path,
                                                message: e$13.message,
                                                value: e$13.value
                                            }
                                        };
                                    }
                                    var e$14 = imageId._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".imageId" + e$14.path,
                                            message: e$14.message,
                                            value: e$14.value
                                        }
                                    };
                                }
                                var e$15 = sku._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".sku" + e$15.path,
                                        message: e$15.message,
                                        value: e$15.value
                                    }
                                };
                            }
                            var e$16 = compareAtPrice2._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".compareAtPrice2" + e$16.path,
                                    message: e$16.message,
                                    value: e$16.value
                                }
                            };
                        }
                        var e$17 = compareAtPrice._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".compareAtPrice" + e$17.path,
                                message: e$17.message,
                                value: e$17.value
                            }
                        };
                    }
                    var e$18 = price2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".price2" + e$18.path,
                            message: e$18.message,
                            value: e$18.value
                        }
                    };
                }
                var e$19 = price._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".price" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            }
            var e$20 = description._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".description" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                }
            };
        }
        var e$21 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$21.path,
                message: e$21.message,
                value: e$21.value
            }
        };
    }
    var e$22 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$22.path,
            message: e$22.message,
            value: e$22.value
        }
    };
}
function $02d9048f3e76c404$var$optionsToDict(variant, options) {
    var dict = {};
    var values = [
        variant.option1,
        variant.option2,
        variant.option3
    ];
    $i7mYY.forEachWithIndex(values, function(i, value) {
        var key = $2whNH.map($i7mYY.get(options, i), function(o) {
            return o.name.toLowerCase();
        });
        if (key !== undefined && value !== undefined) {
            dict[key] = value;
            return;
        }
    });
    return dict;
}
function $02d9048f3e76c404$var$isInStock(v) {
    return $2whNH.getWithDefault(v.inventory.quantity, 0) > 0;
}
var $02d9048f3e76c404$var$Variant = {
    t_encode: $02d9048f3e76c404$var$t_encode$20,
    t_decode: $02d9048f3e76c404$var$t_decode$20,
    optionsToDict: $02d9048f3e76c404$var$optionsToDict,
    isInStock: $02d9048f3e76c404$var$isInStock
};
function $02d9048f3e76c404$var$t_encode$21(v) {
    return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$20, v);
}
function $02d9048f3e76c404$var$t_decode$21(v) {
    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$20, v);
}
var $02d9048f3e76c404$var$codec$3 = [
    $02d9048f3e76c404$var$t_encode$21,
    $02d9048f3e76c404$var$t_decode$21
];
var $02d9048f3e76c404$var$Variants = {
    t_encode: $02d9048f3e76c404$var$t_encode$21,
    t_decode: $02d9048f3e76c404$var$t_decode$21,
    codec: $02d9048f3e76c404$var$codec$3,
    toJson: $02d9048f3e76c404$var$t_encode$21,
    fromJson: $02d9048f3e76c404$var$t_decode$21
};
function $02d9048f3e76c404$var$t_encode$22(v) {
    return $d3YYW.fromArray([
        [
            "v",
            $3zjNo.intToJson(v.v)
        ],
        [
            "id",
            $iv6Yc._1($hG39s.ProductId.t_encode, v.id)
        ],
        [
            "name",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.name)
        ],
        [
            "description",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.description)
        ],
        [
            "currency",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.currency)
        ],
        [
            "currency2",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.currency2)
        ],
        [
            "productType",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.productType)
        ],
        [
            "taxonomy",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.taxonomy)
        ],
        [
            "categoryId",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.categoryId)
        ],
        [
            "images",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$6, v.images)
        ],
        [
            "media",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$9, v.media)
        ],
        [
            "variants",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$20, v.variants)
        ],
        [
            "options",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$18, v.options)
        ],
        [
            "link",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.link)
        ],
        [
            "tags",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.tags)
        ],
        [
            "metadata",
            $3zjNo.dictToJson($02d9048f3e76c404$var$t_encode$17, v.metadata)
        ],
        [
            "createdAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.createdAt)
        ],
        [
            "bestSellerRank",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.bestSellerRank)
        ],
        [
            "featuredRank",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.featuredRank)
        ],
        [
            "reviewSummary",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$12, v.reviewSummary)
        ],
        [
            "promoText",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.promoText)
        ],
        [
            "lastModifiedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastModifiedAt)
        ],
        [
            "lastImportedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastImportedAt)
        ],
        [
            "deletedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.deletedAt)
        ],
        [
            "market",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.market)
        ],
        [
            "alternativeMarkets",
            $3zjNo.dictToJson(function(v) {
                return v;
            }, v.alternativeMarkets)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$22(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var v$1 = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "v"), $3zjNo.intFromJson), {
        TAG: /* Ok */ 0,
        _0: 0
    });
    if (v$1.TAG === /* Ok */ 0) {
        var id = $iv6Yc._1($hG39s.ProductId.t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
        if (id.TAG === /* Ok */ 0) {
            var name = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "name"), null));
            if (name.TAG === /* Ok */ 0) {
                var description = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "description"), null));
                if (description.TAG === /* Ok */ 0) {
                    var currency = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "currency"), null));
                    if (currency.TAG === /* Ok */ 0) {
                        var currency2 = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "currency2"), null));
                        if (currency2.TAG === /* Ok */ 0) {
                            var productType = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "productType"), null));
                            if (productType.TAG === /* Ok */ 0) {
                                var taxonomy = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "taxonomy"), null));
                                if (taxonomy.TAG === /* Ok */ 0) {
                                    var categoryId = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "categoryId"), null));
                                    if (categoryId.TAG === /* Ok */ 0) {
                                        var images = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$6, $2whNH.getWithDefault($d3YYW.get(dict$1, "images"), null));
                                        if (images.TAG === /* Ok */ 0) {
                                            var media = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "media"), function(param) {
                                                return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$9, param);
                                            }), {
                                                TAG: /* Ok */ 0,
                                                _0: []
                                            });
                                            if (media.TAG === /* Ok */ 0) {
                                                var variants = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "variants"), function(param) {
                                                    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$20, param);
                                                }), {
                                                    TAG: /* Ok */ 0,
                                                    _0: []
                                                });
                                                if (variants.TAG === /* Ok */ 0) {
                                                    var options = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$18, $2whNH.getWithDefault($d3YYW.get(dict$1, "options"), null));
                                                    if (options.TAG === /* Ok */ 0) {
                                                        var link = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "link"), null));
                                                        if (link.TAG === /* Ok */ 0) {
                                                            var tags = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "tags"), null));
                                                            if (tags.TAG === /* Ok */ 0) {
                                                                var metadata = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "metadata"), function(param) {
                                                                    return $3zjNo.dictFromJson($02d9048f3e76c404$var$t_decode$17, param);
                                                                }), {
                                                                    TAG: /* Ok */ 0,
                                                                    _0: {}
                                                                });
                                                                if (metadata.TAG === /* Ok */ 0) {
                                                                    var createdAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "createdAt"), null));
                                                                    if (createdAt.TAG === /* Ok */ 0) {
                                                                        var bestSellerRank = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "bestSellerRank"), null));
                                                                        if (bestSellerRank.TAG === /* Ok */ 0) {
                                                                            var featuredRank = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "featuredRank"), null));
                                                                            if (featuredRank.TAG === /* Ok */ 0) {
                                                                                var reviewSummary = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$12, $2whNH.getWithDefault($d3YYW.get(dict$1, "reviewSummary"), null));
                                                                                if (reviewSummary.TAG === /* Ok */ 0) {
                                                                                    var promoText = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "promoText"), null));
                                                                                    if (promoText.TAG === /* Ok */ 0) {
                                                                                        var lastModifiedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastModifiedAt"), null));
                                                                                        if (lastModifiedAt.TAG === /* Ok */ 0) {
                                                                                            var lastImportedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastImportedAt"), null));
                                                                                            if (lastImportedAt.TAG === /* Ok */ 0) {
                                                                                                var deletedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "deletedAt"), null));
                                                                                                if (deletedAt.TAG === /* Ok */ 0) {
                                                                                                    var market = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "market"), null));
                                                                                                    if (market.TAG === /* Ok */ 0) {
                                                                                                        var alternativeMarkets = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "alternativeMarkets"), function(param) {
                                                                                                            return $3zjNo.dictFromJson(function(v) {
                                                                                                                return {
                                                                                                                    TAG: /* Ok */ 0,
                                                                                                                    _0: v
                                                                                                                };
                                                                                                            }, param);
                                                                                                        }), {
                                                                                                            TAG: /* Ok */ 0,
                                                                                                            _0: {}
                                                                                                        });
                                                                                                        if (alternativeMarkets.TAG === /* Ok */ 0) return {
                                                                                                            TAG: /* Ok */ 0,
                                                                                                            _0: {
                                                                                                                v: v$1._0,
                                                                                                                id: id._0,
                                                                                                                name: name._0,
                                                                                                                description: description._0,
                                                                                                                currency: currency._0,
                                                                                                                currency2: currency2._0,
                                                                                                                productType: productType._0,
                                                                                                                taxonomy: taxonomy._0,
                                                                                                                categoryId: categoryId._0,
                                                                                                                images: images._0,
                                                                                                                media: media._0,
                                                                                                                variants: variants._0,
                                                                                                                options: options._0,
                                                                                                                link: link._0,
                                                                                                                tags: tags._0,
                                                                                                                metadata: metadata._0,
                                                                                                                createdAt: createdAt._0,
                                                                                                                bestSellerRank: bestSellerRank._0,
                                                                                                                featuredRank: featuredRank._0,
                                                                                                                reviewSummary: reviewSummary._0,
                                                                                                                promoText: promoText._0,
                                                                                                                lastModifiedAt: lastModifiedAt._0,
                                                                                                                lastImportedAt: lastImportedAt._0,
                                                                                                                deletedAt: deletedAt._0,
                                                                                                                market: market._0,
                                                                                                                alternativeMarkets: alternativeMarkets._0
                                                                                                            }
                                                                                                        };
                                                                                                        var e = alternativeMarkets._0;
                                                                                                        return {
                                                                                                            TAG: /* Error */ 1,
                                                                                                            _0: {
                                                                                                                path: ".alternativeMarkets" + e.path,
                                                                                                                message: e.message,
                                                                                                                value: e.value
                                                                                                            }
                                                                                                        };
                                                                                                    }
                                                                                                    var e$1 = market._0;
                                                                                                    return {
                                                                                                        TAG: /* Error */ 1,
                                                                                                        _0: {
                                                                                                            path: ".market" + e$1.path,
                                                                                                            message: e$1.message,
                                                                                                            value: e$1.value
                                                                                                        }
                                                                                                    };
                                                                                                }
                                                                                                var e$2 = deletedAt._0;
                                                                                                return {
                                                                                                    TAG: /* Error */ 1,
                                                                                                    _0: {
                                                                                                        path: ".deletedAt" + e$2.path,
                                                                                                        message: e$2.message,
                                                                                                        value: e$2.value
                                                                                                    }
                                                                                                };
                                                                                            }
                                                                                            var e$3 = lastImportedAt._0;
                                                                                            return {
                                                                                                TAG: /* Error */ 1,
                                                                                                _0: {
                                                                                                    path: ".lastImportedAt" + e$3.path,
                                                                                                    message: e$3.message,
                                                                                                    value: e$3.value
                                                                                                }
                                                                                            };
                                                                                        }
                                                                                        var e$4 = lastModifiedAt._0;
                                                                                        return {
                                                                                            TAG: /* Error */ 1,
                                                                                            _0: {
                                                                                                path: ".lastModifiedAt" + e$4.path,
                                                                                                message: e$4.message,
                                                                                                value: e$4.value
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                    var e$5 = promoText._0;
                                                                                    return {
                                                                                        TAG: /* Error */ 1,
                                                                                        _0: {
                                                                                            path: ".promoText" + e$5.path,
                                                                                            message: e$5.message,
                                                                                            value: e$5.value
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e$6 = reviewSummary._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".reviewSummary" + e$6.path,
                                                                                        message: e$6.message,
                                                                                        value: e$6.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$7 = featuredRank._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".featuredRank" + e$7.path,
                                                                                    message: e$7.message,
                                                                                    value: e$7.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$8 = bestSellerRank._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".bestSellerRank" + e$8.path,
                                                                                message: e$8.message,
                                                                                value: e$8.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$9 = createdAt._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".createdAt" + e$9.path,
                                                                            message: e$9.message,
                                                                            value: e$9.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$10 = metadata._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".metadata" + e$10.path,
                                                                        message: e$10.message,
                                                                        value: e$10.value
                                                                    }
                                                                };
                                                            }
                                                            var e$11 = tags._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".tags" + e$11.path,
                                                                    message: e$11.message,
                                                                    value: e$11.value
                                                                }
                                                            };
                                                        }
                                                        var e$12 = link._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".link" + e$12.path,
                                                                message: e$12.message,
                                                                value: e$12.value
                                                            }
                                                        };
                                                    }
                                                    var e$13 = options._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".options" + e$13.path,
                                                            message: e$13.message,
                                                            value: e$13.value
                                                        }
                                                    };
                                                }
                                                var e$14 = variants._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".variants" + e$14.path,
                                                        message: e$14.message,
                                                        value: e$14.value
                                                    }
                                                };
                                            }
                                            var e$15 = media._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".media" + e$15.path,
                                                    message: e$15.message,
                                                    value: e$15.value
                                                }
                                            };
                                        }
                                        var e$16 = images._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".images" + e$16.path,
                                                message: e$16.message,
                                                value: e$16.value
                                            }
                                        };
                                    }
                                    var e$17 = categoryId._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".categoryId" + e$17.path,
                                            message: e$17.message,
                                            value: e$17.value
                                        }
                                    };
                                }
                                var e$18 = taxonomy._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".taxonomy" + e$18.path,
                                        message: e$18.message,
                                        value: e$18.value
                                    }
                                };
                            }
                            var e$19 = productType._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".productType" + e$19.path,
                                    message: e$19.message,
                                    value: e$19.value
                                }
                            };
                        }
                        var e$20 = currency2._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".currency2" + e$20.path,
                                message: e$20.message,
                                value: e$20.value
                            }
                        };
                    }
                    var e$21 = currency._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".currency" + e$21.path,
                            message: e$21.message,
                            value: e$21.value
                        }
                    };
                }
                var e$22 = description._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".description" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            }
            var e$23 = name._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".name" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                }
            };
        }
        var e$24 = id._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".id" + e$24.path,
                message: e$24.message,
                value: e$24.value
            }
        };
    }
    var e$25 = v$1._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".v" + e$25.path,
            message: e$25.message,
            value: e$25.value
        }
    };
}
var $02d9048f3e76c404$var$codec$4 = [
    $02d9048f3e76c404$var$t_encode$22,
    $02d9048f3e76c404$var$t_decode$22
];
var $02d9048f3e76c404$export$264ad599d7cef668 = {
    $$Option: $02d9048f3e76c404$var$$$Option,
    Inventory: $02d9048f3e76c404$var$Inventory,
    Variant: $02d9048f3e76c404$var$Variant,
    Variants: $02d9048f3e76c404$var$Variants,
    t_encode: $02d9048f3e76c404$var$t_encode$22,
    t_decode: $02d9048f3e76c404$var$t_decode$22,
    codec: $02d9048f3e76c404$var$codec$4,
    toJson: $02d9048f3e76c404$var$t_encode$22,
    fromJson: $02d9048f3e76c404$var$t_decode$22
};
function $02d9048f3e76c404$var$t_encode$23(v) {
    return $d3YYW.fromArray([
        [
            "id",
            $iv6Yc._1($hG39s.ProductId.t_encode, v.id)
        ],
        [
            "lastModifiedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastModifiedAt)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$23(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var id = $iv6Yc._1($hG39s.ProductId.t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var lastModifiedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastModifiedAt"), null));
        if (lastModifiedAt.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                id: id._0,
                lastModifiedAt: lastModifiedAt._0
            }
        };
        var e = lastModifiedAt._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".lastModifiedAt" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$var$codec$5 = [
    $02d9048f3e76c404$var$t_encode$23,
    $02d9048f3e76c404$var$t_decode$23
];
var $02d9048f3e76c404$export$acd8746386fc9789 = {
    t_encode: $02d9048f3e76c404$var$t_encode$23,
    t_decode: $02d9048f3e76c404$var$t_decode$23,
    codec: $02d9048f3e76c404$var$codec$5,
    toJson: $02d9048f3e76c404$var$t_encode$23,
    fromJson: $02d9048f3e76c404$var$t_decode$23
};
function $02d9048f3e76c404$var$t_encode$24(v) {
    return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$23, v);
}
function $02d9048f3e76c404$var$t_decode$24(v) {
    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$23, v);
}
var $02d9048f3e76c404$var$codec$6 = [
    $02d9048f3e76c404$var$t_encode$24,
    $02d9048f3e76c404$var$t_decode$24
];
function $02d9048f3e76c404$var$t_encode$25(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "entries",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$23, v.entries)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$25(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "page"), $cXHd0.t_decode), {
        TAG: /* Ok */ 0,
        _0: $cXHd0.$$default
    });
    if (page.TAG === /* Ok */ 0) {
        var v$1 = $2whNH.getWithDefault($d3YYW.get(dict$1, "entries"), null);
        var entries = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$23, v$1);
        if (entries.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                page: page._0,
                entries: entries._0
            }
        };
        var e = entries._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".entries" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$var$codec$7 = [
    $02d9048f3e76c404$var$t_encode$25,
    $02d9048f3e76c404$var$t_decode$25
];
var $02d9048f3e76c404$var$Page = {
    t_encode: $02d9048f3e76c404$var$t_encode$25,
    t_decode: $02d9048f3e76c404$var$t_decode$25,
    codec: $02d9048f3e76c404$var$codec$7,
    toJson: $02d9048f3e76c404$var$t_encode$25,
    fromJson: $02d9048f3e76c404$var$t_decode$25
};
var $02d9048f3e76c404$export$3ab51e46cacdf4e4 = {
    t_encode: $02d9048f3e76c404$var$t_encode$24,
    t_decode: $02d9048f3e76c404$var$t_decode$24,
    codec: $02d9048f3e76c404$var$codec$6,
    toJson: $02d9048f3e76c404$var$t_encode$24,
    fromJson: $02d9048f3e76c404$var$t_decode$24,
    Page: $02d9048f3e76c404$var$Page
};
function $02d9048f3e76c404$var$t_encode$26(v) {
    return $3zjNo.arrayToJson($3zjNo.stringToJson, v);
}
function $02d9048f3e76c404$var$t_decode$26(v) {
    return $3zjNo.arrayFromJson($3zjNo.stringFromJson, v);
}
function $02d9048f3e76c404$var$t_encode$27(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "facets",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.facets)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$27(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "page"), $cXHd0.t_decode), {
        TAG: /* Ok */ 0,
        _0: $cXHd0.$$default
    });
    if (page.TAG === /* Ok */ 0) {
        var v$1 = $2whNH.getWithDefault($d3YYW.get(dict$1, "facets"), null);
        var facets = $3zjNo.arrayFromJson($3zjNo.stringFromJson, v$1);
        if (facets.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                page: page._0,
                facets: facets._0
            }
        };
        var e = facets._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".facets" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$var$codec$8 = [
    $02d9048f3e76c404$var$t_encode$27,
    $02d9048f3e76c404$var$t_decode$27
];
var $02d9048f3e76c404$var$Page$1 = {
    t_encode: $02d9048f3e76c404$var$t_encode$27,
    t_decode: $02d9048f3e76c404$var$t_decode$27,
    codec: $02d9048f3e76c404$var$codec$8,
    toJson: $02d9048f3e76c404$var$t_encode$27,
    fromJson: $02d9048f3e76c404$var$t_decode$27
};
var $02d9048f3e76c404$export$a10c58795139629f = {
    t_encode: $02d9048f3e76c404$var$t_encode$26,
    t_decode: $02d9048f3e76c404$var$t_decode$26,
    Page: $02d9048f3e76c404$var$Page$1
};
function $02d9048f3e76c404$var$t_encode$28(v) {
    return $d3YYW.fromArray([
        [
            "minPrice",
            $3zjNo.intToJson(v.minPrice)
        ],
        [
            "maxPrice",
            $3zjNo.intToJson(v.maxPrice)
        ],
        [
            "facets",
            $3zjNo.arrayToJson(function(param) {
                return [
                    $3zjNo.stringToJson(param[0]),
                    $3zjNo.intToJson(param[1])
                ];
            }, v.facets)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$28(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var minPrice = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "minPrice"), null));
    if (minPrice.TAG === /* Ok */ 0) {
        var maxPrice = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "maxPrice"), null));
        if (maxPrice.TAG === /* Ok */ 0) {
            var facets = $3zjNo.arrayFromJson(function(json) {
                var match = $1ArWc.classify(json);
                if (typeof match === "number") return $3zjNo.error(undefined, "Not a tuple", json);
                if (match.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a tuple", json);
                var match$1 = match._0;
                if (match$1.length !== 2) return $3zjNo.error(undefined, "Incorrect cardinality", json);
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = $3zjNo.stringFromJson(v0);
                var match$3 = $3zjNo.intFromJson(v1);
                if (match$2.TAG === /* Ok */ 0) {
                    if (match$3.TAG === /* Ok */ 0) return {
                        TAG: /* Ok */ 0,
                        _0: [
                            match$2._0,
                            match$3._0
                        ]
                    };
                    var e = match$3._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }, $2whNH.getWithDefault($d3YYW.get(dict$1, "facets"), null));
            if (facets.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    minPrice: minPrice._0,
                    maxPrice: maxPrice._0,
                    facets: facets._0
                }
            };
            var e = facets._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".facets" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = maxPrice._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maxPrice" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = minPrice._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".minPrice" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$var$empty_facets = [];
var $02d9048f3e76c404$var$empty = {
    minPrice: 0,
    maxPrice: 0,
    facets: $02d9048f3e76c404$var$empty_facets
};
var $02d9048f3e76c404$export$25f6a521f85bfdfa = {
    t_encode: $02d9048f3e76c404$var$t_encode$28,
    t_decode: $02d9048f3e76c404$var$t_decode$28,
    empty: $02d9048f3e76c404$var$empty
};
function $02d9048f3e76c404$var$t_encode$29(v) {
    return $d3YYW.fromArray([
        [
            "minPrice",
            $3zjNo.intToJson(v.minPrice)
        ],
        [
            "maxPrice",
            $3zjNo.intToJson(v.maxPrice)
        ],
        [
            "size",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.size)
        ],
        [
            "color",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.color)
        ],
        [
            "pattern",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.pattern)
        ],
        [
            "material",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.material)
        ],
        [
            "tag",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.tag)
        ],
        [
            "availability",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.availability)
        ],
        [
            "price",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.price)
        ],
        [
            "fabric",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.fabric)
        ],
        [
            "sleeves",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.sleeves)
        ],
        [
            "colour",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.colour)
        ],
        [
            "neckline",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.neckline)
        ],
        [
            "occasion",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.occasion)
        ],
        [
            "type_",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.type_)
        ],
        [
            "technique",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.technique)
        ],
        [
            "style",
            $3zjNo.arrayToJson($3zjNo.stringToJson, v.style)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$29(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var minPrice = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "minPrice"), null));
    if (minPrice.TAG === /* Ok */ 0) {
        var maxPrice = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "maxPrice"), null));
        if (maxPrice.TAG === /* Ok */ 0) {
            var size = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "size"), null));
            if (size.TAG === /* Ok */ 0) {
                var color = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "color"), null));
                if (color.TAG === /* Ok */ 0) {
                    var pattern = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "pattern"), null));
                    if (pattern.TAG === /* Ok */ 0) {
                        var material = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "material"), null));
                        if (material.TAG === /* Ok */ 0) {
                            var tag = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "tag"), null));
                            if (tag.TAG === /* Ok */ 0) {
                                var availability = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "availability"), null));
                                if (availability.TAG === /* Ok */ 0) {
                                    var price = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "price"), null));
                                    if (price.TAG === /* Ok */ 0) {
                                        var fabric = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "fabric"), null));
                                        if (fabric.TAG === /* Ok */ 0) {
                                            var sleeves = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "sleeves"), null));
                                            if (sleeves.TAG === /* Ok */ 0) {
                                                var colour = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "colour"), null));
                                                if (colour.TAG === /* Ok */ 0) {
                                                    var neckline = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "neckline"), null));
                                                    if (neckline.TAG === /* Ok */ 0) {
                                                        var occasion = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "occasion"), null));
                                                        if (occasion.TAG === /* Ok */ 0) {
                                                            var type_ = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "type_"), null));
                                                            if (type_.TAG === /* Ok */ 0) {
                                                                var technique = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "technique"), null));
                                                                if (technique.TAG === /* Ok */ 0) {
                                                                    var style = $3zjNo.arrayFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "style"), null));
                                                                    if (style.TAG === /* Ok */ 0) return {
                                                                        TAG: /* Ok */ 0,
                                                                        _0: {
                                                                            minPrice: minPrice._0,
                                                                            maxPrice: maxPrice._0,
                                                                            size: size._0,
                                                                            color: color._0,
                                                                            pattern: pattern._0,
                                                                            material: material._0,
                                                                            tag: tag._0,
                                                                            availability: availability._0,
                                                                            price: price._0,
                                                                            fabric: fabric._0,
                                                                            sleeves: sleeves._0,
                                                                            colour: colour._0,
                                                                            neckline: neckline._0,
                                                                            occasion: occasion._0,
                                                                            type_: type_._0,
                                                                            technique: technique._0,
                                                                            style: style._0
                                                                        }
                                                                    };
                                                                    var e = style._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".style" + e.path,
                                                                            message: e.message,
                                                                            value: e.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$1 = technique._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".technique" + e$1.path,
                                                                        message: e$1.message,
                                                                        value: e$1.value
                                                                    }
                                                                };
                                                            }
                                                            var e$2 = type_._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".type_" + e$2.path,
                                                                    message: e$2.message,
                                                                    value: e$2.value
                                                                }
                                                            };
                                                        }
                                                        var e$3 = occasion._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".occasion" + e$3.path,
                                                                message: e$3.message,
                                                                value: e$3.value
                                                            }
                                                        };
                                                    }
                                                    var e$4 = neckline._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".neckline" + e$4.path,
                                                            message: e$4.message,
                                                            value: e$4.value
                                                        }
                                                    };
                                                }
                                                var e$5 = colour._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".colour" + e$5.path,
                                                        message: e$5.message,
                                                        value: e$5.value
                                                    }
                                                };
                                            }
                                            var e$6 = sleeves._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".sleeves" + e$6.path,
                                                    message: e$6.message,
                                                    value: e$6.value
                                                }
                                            };
                                        }
                                        var e$7 = fabric._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".fabric" + e$7.path,
                                                message: e$7.message,
                                                value: e$7.value
                                            }
                                        };
                                    }
                                    var e$8 = price._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".price" + e$8.path,
                                            message: e$8.message,
                                            value: e$8.value
                                        }
                                    };
                                }
                                var e$9 = availability._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".availability" + e$9.path,
                                        message: e$9.message,
                                        value: e$9.value
                                    }
                                };
                            }
                            var e$10 = tag._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".tag" + e$10.path,
                                    message: e$10.message,
                                    value: e$10.value
                                }
                            };
                        }
                        var e$11 = material._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".material" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                            }
                        };
                    }
                    var e$12 = pattern._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".pattern" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = color._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".color" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            }
            var e$14 = size._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".size" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                }
            };
        }
        var e$15 = maxPrice._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maxPrice" + e$15.path,
                message: e$15.message,
                value: e$15.value
            }
        };
    }
    var e$16 = minPrice._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".minPrice" + e$16.path,
            message: e$16.message,
            value: e$16.value
        }
    };
}
var $02d9048f3e76c404$var$empty_size = [];
var $02d9048f3e76c404$var$empty_color = [];
var $02d9048f3e76c404$var$empty_pattern = [];
var $02d9048f3e76c404$var$empty_material = [];
var $02d9048f3e76c404$var$empty_tag = [];
var $02d9048f3e76c404$var$empty_availability = [];
var $02d9048f3e76c404$var$empty_price = [];
var $02d9048f3e76c404$var$empty_fabric = [];
var $02d9048f3e76c404$var$empty_sleeves = [];
var $02d9048f3e76c404$var$empty_colour = [];
var $02d9048f3e76c404$var$empty_neckline = [];
var $02d9048f3e76c404$var$empty_occasion = [];
var $02d9048f3e76c404$var$empty_type_ = [];
var $02d9048f3e76c404$var$empty_technique = [];
var $02d9048f3e76c404$var$empty_style = [];
var $02d9048f3e76c404$var$empty$1 = {
    minPrice: 0,
    maxPrice: 0,
    size: $02d9048f3e76c404$var$empty_size,
    color: $02d9048f3e76c404$var$empty_color,
    pattern: $02d9048f3e76c404$var$empty_pattern,
    material: $02d9048f3e76c404$var$empty_material,
    tag: $02d9048f3e76c404$var$empty_tag,
    availability: $02d9048f3e76c404$var$empty_availability,
    price: $02d9048f3e76c404$var$empty_price,
    fabric: $02d9048f3e76c404$var$empty_fabric,
    sleeves: $02d9048f3e76c404$var$empty_sleeves,
    colour: $02d9048f3e76c404$var$empty_colour,
    neckline: $02d9048f3e76c404$var$empty_neckline,
    occasion: $02d9048f3e76c404$var$empty_occasion,
    type_: $02d9048f3e76c404$var$empty_type_,
    technique: $02d9048f3e76c404$var$empty_technique,
    style: $02d9048f3e76c404$var$empty_style
};
function $02d9048f3e76c404$var$t_encode$30(v) {
    return $d3YYW.fromArray([
        [
            "size",
            $3zjNo.dictToJson($3zjNo.intToJson, v.size)
        ],
        [
            "color",
            $3zjNo.dictToJson($3zjNo.intToJson, v.color)
        ],
        [
            "pattern",
            $3zjNo.dictToJson($3zjNo.intToJson, v.pattern)
        ],
        [
            "material",
            $3zjNo.dictToJson($3zjNo.intToJson, v.material)
        ],
        [
            "availability",
            $3zjNo.dictToJson($3zjNo.intToJson, v.availability)
        ],
        [
            "price",
            $3zjNo.dictToJson($3zjNo.intToJson, v.price)
        ],
        [
            "tag",
            $3zjNo.dictToJson($3zjNo.intToJson, v.tag)
        ],
        [
            "fabric",
            $3zjNo.dictToJson($3zjNo.intToJson, v.fabric)
        ],
        [
            "sleeves",
            $3zjNo.dictToJson($3zjNo.intToJson, v.sleeves)
        ],
        [
            "colour",
            $3zjNo.dictToJson($3zjNo.intToJson, v.colour)
        ],
        [
            "neckline",
            $3zjNo.dictToJson($3zjNo.intToJson, v.neckline)
        ],
        [
            "occasion",
            $3zjNo.dictToJson($3zjNo.intToJson, v.occasion)
        ],
        [
            "type_",
            $3zjNo.dictToJson($3zjNo.intToJson, v.type_)
        ],
        [
            "technique",
            $3zjNo.dictToJson($3zjNo.intToJson, v.technique)
        ],
        [
            "style",
            $3zjNo.dictToJson($3zjNo.intToJson, v.style)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$30(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var size = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "size"), null));
    if (size.TAG === /* Ok */ 0) {
        var color = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "color"), null));
        if (color.TAG === /* Ok */ 0) {
            var pattern = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "pattern"), null));
            if (pattern.TAG === /* Ok */ 0) {
                var material = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "material"), null));
                if (material.TAG === /* Ok */ 0) {
                    var availability = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "availability"), null));
                    if (availability.TAG === /* Ok */ 0) {
                        var price = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "price"), null));
                        if (price.TAG === /* Ok */ 0) {
                            var tag = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "tag"), null));
                            if (tag.TAG === /* Ok */ 0) {
                                var fabric = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "fabric"), null));
                                if (fabric.TAG === /* Ok */ 0) {
                                    var sleeves = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "sleeves"), null));
                                    if (sleeves.TAG === /* Ok */ 0) {
                                        var colour = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "colour"), null));
                                        if (colour.TAG === /* Ok */ 0) {
                                            var neckline = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "neckline"), null));
                                            if (neckline.TAG === /* Ok */ 0) {
                                                var occasion = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "occasion"), null));
                                                if (occasion.TAG === /* Ok */ 0) {
                                                    var type_ = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "type_"), null));
                                                    if (type_.TAG === /* Ok */ 0) {
                                                        var technique = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "technique"), null));
                                                        if (technique.TAG === /* Ok */ 0) {
                                                            var style = $3zjNo.dictFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "style"), null));
                                                            if (style.TAG === /* Ok */ 0) return {
                                                                TAG: /* Ok */ 0,
                                                                _0: {
                                                                    size: size._0,
                                                                    color: color._0,
                                                                    pattern: pattern._0,
                                                                    material: material._0,
                                                                    availability: availability._0,
                                                                    price: price._0,
                                                                    tag: tag._0,
                                                                    fabric: fabric._0,
                                                                    sleeves: sleeves._0,
                                                                    colour: colour._0,
                                                                    neckline: neckline._0,
                                                                    occasion: occasion._0,
                                                                    type_: type_._0,
                                                                    technique: technique._0,
                                                                    style: style._0
                                                                }
                                                            };
                                                            var e = style._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".style" + e.path,
                                                                    message: e.message,
                                                                    value: e.value
                                                                }
                                                            };
                                                        }
                                                        var e$1 = technique._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".technique" + e$1.path,
                                                                message: e$1.message,
                                                                value: e$1.value
                                                            }
                                                        };
                                                    }
                                                    var e$2 = type_._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".type_" + e$2.path,
                                                            message: e$2.message,
                                                            value: e$2.value
                                                        }
                                                    };
                                                }
                                                var e$3 = occasion._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".occasion" + e$3.path,
                                                        message: e$3.message,
                                                        value: e$3.value
                                                    }
                                                };
                                            }
                                            var e$4 = neckline._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".neckline" + e$4.path,
                                                    message: e$4.message,
                                                    value: e$4.value
                                                }
                                            };
                                        }
                                        var e$5 = colour._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".colour" + e$5.path,
                                                message: e$5.message,
                                                value: e$5.value
                                            }
                                        };
                                    }
                                    var e$6 = sleeves._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".sleeves" + e$6.path,
                                            message: e$6.message,
                                            value: e$6.value
                                        }
                                    };
                                }
                                var e$7 = fabric._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".fabric" + e$7.path,
                                        message: e$7.message,
                                        value: e$7.value
                                    }
                                };
                            }
                            var e$8 = tag._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".tag" + e$8.path,
                                    message: e$8.message,
                                    value: e$8.value
                                }
                            };
                        }
                        var e$9 = price._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".price" + e$9.path,
                                message: e$9.message,
                                value: e$9.value
                            }
                        };
                    }
                    var e$10 = availability._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".availability" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = material._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".material" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            }
            var e$12 = pattern._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".pattern" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                }
            };
        }
        var e$13 = color._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".color" + e$13.path,
                message: e$13.message,
                value: e$13.value
            }
        };
    }
    var e$14 = size._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".size" + e$14.path,
            message: e$14.message,
            value: e$14.value
        }
    };
}
var $02d9048f3e76c404$var$Counts = {
    t_encode: $02d9048f3e76c404$var$t_encode$30,
    t_decode: $02d9048f3e76c404$var$t_decode$30
};
var $02d9048f3e76c404$export$9c2d185d31b92d37 = {
    t_encode: $02d9048f3e76c404$var$t_encode$29,
    t_decode: $02d9048f3e76c404$var$t_decode$29,
    empty: $02d9048f3e76c404$var$empty$1,
    Counts: $02d9048f3e76c404$var$Counts
};
function $02d9048f3e76c404$var$t_encode$31(v) {
    return $d3YYW.fromArray([
        [
            "isComplete",
            $3zjNo.boolToJson(v.isComplete)
        ],
        [
            "count",
            $3zjNo.intToJson(v.count)
        ],
        [
            "lastCompletedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastCompletedAt)
        ],
        [
            "hasSomeCreatedAtTimes",
            $3zjNo.boolToJson(v.hasSomeCreatedAtTimes)
        ],
        [
            "hasSomeBestSellerRanks",
            $3zjNo.boolToJson(v.hasSomeBestSellerRanks)
        ],
        [
            "hasSomeFeaturedRanks",
            $3zjNo.boolToJson(v.hasSomeFeaturedRanks)
        ],
        [
            "hasSomeDiscounts",
            $3zjNo.boolToJson(v.hasSomeDiscounts)
        ],
        [
            "hasSomeDiscountsInStock",
            $3zjNo.boolToJson(v.hasSomeDiscountsInStock)
        ],
        [
            "deletedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.deletedAt)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$31(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var isComplete = $3zjNo.boolFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "isComplete"), null));
    if (isComplete.TAG === /* Ok */ 0) {
        var count = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "count"), null));
        if (count.TAG === /* Ok */ 0) {
            var lastCompletedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastCompletedAt"), null));
            if (lastCompletedAt.TAG === /* Ok */ 0) {
                var hasSomeCreatedAtTimes = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "hasSomeCreatedAtTimes"), $3zjNo.boolFromJson), {
                    TAG: /* Ok */ 0,
                    _0: false
                });
                if (hasSomeCreatedAtTimes.TAG === /* Ok */ 0) {
                    var hasSomeBestSellerRanks = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "hasSomeBestSellerRanks"), $3zjNo.boolFromJson), {
                        TAG: /* Ok */ 0,
                        _0: false
                    });
                    if (hasSomeBestSellerRanks.TAG === /* Ok */ 0) {
                        var hasSomeFeaturedRanks = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "hasSomeFeaturedRanks"), $3zjNo.boolFromJson), {
                            TAG: /* Ok */ 0,
                            _0: false
                        });
                        if (hasSomeFeaturedRanks.TAG === /* Ok */ 0) {
                            var hasSomeDiscounts = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "hasSomeDiscounts"), $3zjNo.boolFromJson), {
                                TAG: /* Ok */ 0,
                                _0: false
                            });
                            if (hasSomeDiscounts.TAG === /* Ok */ 0) {
                                var hasSomeDiscountsInStock = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "hasSomeDiscountsInStock"), $3zjNo.boolFromJson), {
                                    TAG: /* Ok */ 0,
                                    _0: false
                                });
                                if (hasSomeDiscountsInStock.TAG === /* Ok */ 0) {
                                    var deletedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "deletedAt"), null));
                                    if (deletedAt.TAG === /* Ok */ 0) return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            isComplete: isComplete._0,
                                            count: count._0,
                                            lastCompletedAt: lastCompletedAt._0,
                                            hasSomeCreatedAtTimes: hasSomeCreatedAtTimes._0,
                                            hasSomeBestSellerRanks: hasSomeBestSellerRanks._0,
                                            hasSomeFeaturedRanks: hasSomeFeaturedRanks._0,
                                            hasSomeDiscounts: hasSomeDiscounts._0,
                                            hasSomeDiscountsInStock: hasSomeDiscountsInStock._0,
                                            deletedAt: deletedAt._0
                                        }
                                    };
                                    var e = deletedAt._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".deletedAt" + e.path,
                                            message: e.message,
                                            value: e.value
                                        }
                                    };
                                }
                                var e$1 = hasSomeDiscountsInStock._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".hasSomeDiscountsInStock" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                    }
                                };
                            }
                            var e$2 = hasSomeDiscounts._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".hasSomeDiscounts" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                }
                            };
                        }
                        var e$3 = hasSomeFeaturedRanks._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".hasSomeFeaturedRanks" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                            }
                        };
                    }
                    var e$4 = hasSomeBestSellerRanks._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".hasSomeBestSellerRanks" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = hasSomeCreatedAtTimes._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".hasSomeCreatedAtTimes" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            }
            var e$6 = lastCompletedAt._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".lastCompletedAt" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                }
            };
        }
        var e$7 = count._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".count" + e$7.path,
                message: e$7.message,
                value: e$7.value
            }
        };
    }
    var e$8 = isComplete._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".isComplete" + e$8.path,
            message: e$8.message,
            value: e$8.value
        }
    };
}
var $02d9048f3e76c404$var$codec$9 = [
    $02d9048f3e76c404$var$t_encode$31,
    $02d9048f3e76c404$var$t_decode$31
];
var $02d9048f3e76c404$var$SyncStatus = {
    t_encode: $02d9048f3e76c404$var$t_encode$31,
    t_decode: $02d9048f3e76c404$var$t_decode$31,
    codec: $02d9048f3e76c404$var$codec$9,
    toJson: $02d9048f3e76c404$var$t_encode$31,
    fromJson: $02d9048f3e76c404$var$t_decode$31
};
function $02d9048f3e76c404$var$t_encode$32(v) {
    return $d3YYW.fromArray([
        [
            "id",
            $iv6Yc._1($hG39s.CategoryId.t_encode, v.id)
        ],
        [
            "name",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.name)
        ],
        [
            "description",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.description)
        ],
        [
            "image",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$6, v.image)
        ],
        [
            "link",
            $3zjNo.optionToJson($3zjNo.stringToJson, v.link)
        ],
        [
            "productsCount",
            $3zjNo.optionToJson($3zjNo.intToJson, v.productsCount)
        ],
        [
            "defaultSortOrder",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$5, v.defaultSortOrder)
        ],
        [
            "firstImportedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.firstImportedAt)
        ],
        [
            "lastImportedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastImportedAt)
        ],
        [
            "lastModifiedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastModifiedAt)
        ],
        [
            "syncStatus",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$31, v.syncStatus)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$32(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var id = $iv6Yc._1($hG39s.CategoryId.t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var description = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "description"), null));
            if (description.TAG === /* Ok */ 0) {
                var image = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$6, $2whNH.getWithDefault($d3YYW.get(dict$1, "image"), null));
                if (image.TAG === /* Ok */ 0) {
                    var link = $3zjNo.optionFromJson($3zjNo.stringFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "link"), null));
                    if (link.TAG === /* Ok */ 0) {
                        var productsCount = $3zjNo.optionFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "productsCount"), null));
                        if (productsCount.TAG === /* Ok */ 0) {
                            var defaultSortOrder = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$5, $2whNH.getWithDefault($d3YYW.get(dict$1, "defaultSortOrder"), null));
                            if (defaultSortOrder.TAG === /* Ok */ 0) {
                                var firstImportedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "firstImportedAt"), null));
                                if (firstImportedAt.TAG === /* Ok */ 0) {
                                    var lastImportedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastImportedAt"), null));
                                    if (lastImportedAt.TAG === /* Ok */ 0) {
                                        var lastModifiedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastModifiedAt"), null));
                                        if (lastModifiedAt.TAG === /* Ok */ 0) {
                                            var syncStatus = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$31, $2whNH.getWithDefault($d3YYW.get(dict$1, "syncStatus"), null));
                                            if (syncStatus.TAG === /* Ok */ 0) return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    id: id._0,
                                                    name: name._0,
                                                    description: description._0,
                                                    image: image._0,
                                                    link: link._0,
                                                    productsCount: productsCount._0,
                                                    defaultSortOrder: defaultSortOrder._0,
                                                    firstImportedAt: firstImportedAt._0,
                                                    lastImportedAt: lastImportedAt._0,
                                                    lastModifiedAt: lastModifiedAt._0,
                                                    syncStatus: syncStatus._0
                                                }
                                            };
                                            var e = syncStatus._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".syncStatus" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = lastModifiedAt._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".lastModifiedAt" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = lastImportedAt._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".lastImportedAt" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = firstImportedAt._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".firstImportedAt" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = defaultSortOrder._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".defaultSortOrder" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = productsCount._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".productsCount" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = link._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".link" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = image._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".image" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = description._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".description" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
var $02d9048f3e76c404$var$codec$10 = [
    $02d9048f3e76c404$var$t_encode$32,
    $02d9048f3e76c404$var$t_decode$32
];
var $02d9048f3e76c404$export$3a8840c5b2ecf003 = {
    SyncStatus: $02d9048f3e76c404$var$SyncStatus,
    t_encode: $02d9048f3e76c404$var$t_encode$32,
    t_decode: $02d9048f3e76c404$var$t_decode$32,
    codec: $02d9048f3e76c404$var$codec$10,
    toJson: $02d9048f3e76c404$var$t_encode$32,
    fromJson: $02d9048f3e76c404$var$t_decode$32
};
function $02d9048f3e76c404$var$t_encode$33(v) {
    return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$32, v);
}
function $02d9048f3e76c404$var$t_decode$33(v) {
    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$32, v);
}
var $02d9048f3e76c404$var$codec$11 = [
    $02d9048f3e76c404$var$t_encode$33,
    $02d9048f3e76c404$var$t_decode$33
];
function $02d9048f3e76c404$var$t_encode$34(v) {
    return $d3YYW.fromArray([
        [
            "isComplete",
            $3zjNo.boolToJson(v.isComplete)
        ],
        [
            "count",
            $3zjNo.intToJson(v.count)
        ],
        [
            "lastCompletedAt",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.lastCompletedAt)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$34(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var isComplete = $3zjNo.boolFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "isComplete"), null));
    if (isComplete.TAG === /* Ok */ 0) {
        var count = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "count"), null));
        if (count.TAG === /* Ok */ 0) {
            var lastCompletedAt = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "lastCompletedAt"), null));
            if (lastCompletedAt.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    isComplete: isComplete._0,
                    count: count._0,
                    lastCompletedAt: lastCompletedAt._0
                }
            };
            var e = lastCompletedAt._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".lastCompletedAt" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = count._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".count" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = isComplete._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".isComplete" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$var$codec$12 = [
    $02d9048f3e76c404$var$t_encode$34,
    $02d9048f3e76c404$var$t_decode$34
];
var $02d9048f3e76c404$var$SyncStatus$1 = {
    t_encode: $02d9048f3e76c404$var$t_encode$34,
    t_decode: $02d9048f3e76c404$var$t_decode$34,
    codec: $02d9048f3e76c404$var$codec$12,
    toJson: $02d9048f3e76c404$var$t_encode$34,
    fromJson: $02d9048f3e76c404$var$t_decode$34
};
function $02d9048f3e76c404$var$t_encode$35(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "syncStatus",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$34, v.syncStatus)
        ],
        [
            "categories",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$32, v.categories)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$35(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "page"), $cXHd0.t_decode), {
        TAG: /* Ok */ 0,
        _0: $cXHd0.$$default
    });
    if (page.TAG === /* Ok */ 0) {
        var syncStatus = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$34, $2whNH.getWithDefault($d3YYW.get(dict$1, "syncStatus"), null));
        if (syncStatus.TAG === /* Ok */ 0) {
            var categories = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "categories"), $02d9048f3e76c404$var$t_decode$33), {
                TAG: /* Ok */ 0,
                _0: []
            });
            if (categories.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    page: page._0,
                    syncStatus: syncStatus._0,
                    categories: categories._0
                }
            };
            var e = categories._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".categories" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = syncStatus._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".syncStatus" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var $02d9048f3e76c404$var$codec$13 = [
    $02d9048f3e76c404$var$t_encode$35,
    $02d9048f3e76c404$var$t_decode$35
];
var $02d9048f3e76c404$var$Page$2 = {
    t_encode: $02d9048f3e76c404$var$t_encode$35,
    t_decode: $02d9048f3e76c404$var$t_decode$35,
    codec: $02d9048f3e76c404$var$codec$13,
    toJson: $02d9048f3e76c404$var$t_encode$35,
    fromJson: $02d9048f3e76c404$var$t_decode$35
};
var $02d9048f3e76c404$export$e1e795cef0e670e6 = {
    t_encode: $02d9048f3e76c404$var$t_encode$33,
    t_decode: $02d9048f3e76c404$var$t_decode$33,
    toJson: $02d9048f3e76c404$var$t_encode$33,
    fromJson: $02d9048f3e76c404$var$t_decode$33,
    codec: $02d9048f3e76c404$var$codec$11,
    SyncStatus: $02d9048f3e76c404$var$SyncStatus$1,
    Page: $02d9048f3e76c404$var$Page$2
};
function $02d9048f3e76c404$var$t_encode$36(v) {
    return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$22, v);
}
function $02d9048f3e76c404$var$t_decode$36(v) {
    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$22, v);
}
var $02d9048f3e76c404$var$codec$14 = [
    $02d9048f3e76c404$var$t_encode$36,
    $02d9048f3e76c404$var$t_decode$36
];
function $02d9048f3e76c404$var$t_encode$37(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "products",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$22, v.products)
        ],
        [
            "availableFilters",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$29, v.availableFilters)
        ],
        [
            "counts",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$30, v.counts)
        ],
        [
            "total",
            $3zjNo.optionToJson($3zjNo.intToJson, v.total)
        ],
        [
            "syncStatus",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$31, v.syncStatus)
        ],
        [
            "defaultSortOrder",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$5, v.defaultSortOrder)
        ],
        [
            "availableSorts",
            $3zjNo.optionToJson(function(param) {
                return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$5, param);
            }, v.availableSorts)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$37(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "page"), $cXHd0.t_decode), {
        TAG: /* Ok */ 0,
        _0: $cXHd0.$$default
    });
    if (page.TAG === /* Ok */ 0) {
        var products = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "products"), $02d9048f3e76c404$var$t_decode$36), {
            TAG: /* Ok */ 0,
            _0: []
        });
        if (products.TAG === /* Ok */ 0) {
            var availableFilters = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$29, $2whNH.getWithDefault($d3YYW.get(dict$1, "availableFilters"), null));
            if (availableFilters.TAG === /* Ok */ 0) {
                var counts = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$30, $2whNH.getWithDefault($d3YYW.get(dict$1, "counts"), null));
                if (counts.TAG === /* Ok */ 0) {
                    var total = $3zjNo.optionFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "total"), null));
                    if (total.TAG === /* Ok */ 0) {
                        var syncStatus = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$31, $2whNH.getWithDefault($d3YYW.get(dict$1, "syncStatus"), null));
                        if (syncStatus.TAG === /* Ok */ 0) {
                            var defaultSortOrder = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$5, $2whNH.getWithDefault($d3YYW.get(dict$1, "defaultSortOrder"), null));
                            if (defaultSortOrder.TAG === /* Ok */ 0) {
                                var availableSorts = $3zjNo.optionFromJson(function(param) {
                                    return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$5, param);
                                }, $2whNH.getWithDefault($d3YYW.get(dict$1, "availableSorts"), null));
                                if (availableSorts.TAG === /* Ok */ 0) return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        page: page._0,
                                        products: products._0,
                                        availableFilters: availableFilters._0,
                                        counts: counts._0,
                                        total: total._0,
                                        syncStatus: syncStatus._0,
                                        defaultSortOrder: defaultSortOrder._0,
                                        availableSorts: availableSorts._0
                                    }
                                };
                                var e = availableSorts._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".availableSorts" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = defaultSortOrder._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".defaultSortOrder" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = syncStatus._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".syncStatus" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = total._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".total" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = counts._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".counts" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = availableFilters._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".availableFilters" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = products._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".products" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
var $02d9048f3e76c404$var$codec$15 = [
    $02d9048f3e76c404$var$t_encode$37,
    $02d9048f3e76c404$var$t_decode$37
];
var $02d9048f3e76c404$var$empty_page = {
    previous: undefined,
    next: undefined,
    offset: undefined,
    limit: undefined
};
var $02d9048f3e76c404$var$empty_products = [];
var $02d9048f3e76c404$var$empty$2 = {
    page: $02d9048f3e76c404$var$empty_page,
    products: $02d9048f3e76c404$var$empty_products,
    availableFilters: undefined,
    counts: undefined,
    total: undefined,
    syncStatus: undefined,
    defaultSortOrder: undefined,
    availableSorts: undefined
};
var $02d9048f3e76c404$var$Page$3 = {
    t_encode: $02d9048f3e76c404$var$t_encode$37,
    t_decode: $02d9048f3e76c404$var$t_decode$37,
    codec: $02d9048f3e76c404$var$codec$15,
    toJson: $02d9048f3e76c404$var$t_encode$37,
    fromJson: $02d9048f3e76c404$var$t_decode$37,
    empty: $02d9048f3e76c404$var$empty$2
};
function $02d9048f3e76c404$var$t_encode$38(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "products",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$22, v.products)
        ],
        [
            "filters",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$28, v.filters)
        ],
        [
            "total",
            $3zjNo.optionToJson($3zjNo.intToJson, v.total)
        ],
        [
            "syncStatus",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$31, v.syncStatus)
        ],
        [
            "defaultSortOrder",
            $3zjNo.optionToJson($02d9048f3e76c404$var$t_encode$5, v.defaultSortOrder)
        ],
        [
            "availableSorts",
            $3zjNo.optionToJson(function(param) {
                return $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$5, param);
            }, v.availableSorts)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$38(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "page"), $cXHd0.t_decode), {
        TAG: /* Ok */ 0,
        _0: $cXHd0.$$default
    });
    if (page.TAG === /* Ok */ 0) {
        var products = $2whNH.getWithDefault($2whNH.map($d3YYW.get(dict$1, "products"), $02d9048f3e76c404$var$t_decode$36), {
            TAG: /* Ok */ 0,
            _0: []
        });
        if (products.TAG === /* Ok */ 0) {
            var filters = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$28, $2whNH.getWithDefault($d3YYW.get(dict$1, "filters"), null));
            if (filters.TAG === /* Ok */ 0) {
                var total = $3zjNo.optionFromJson($3zjNo.intFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "total"), null));
                if (total.TAG === /* Ok */ 0) {
                    var syncStatus = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$31, $2whNH.getWithDefault($d3YYW.get(dict$1, "syncStatus"), null));
                    if (syncStatus.TAG === /* Ok */ 0) {
                        var defaultSortOrder = $3zjNo.optionFromJson($02d9048f3e76c404$var$t_decode$5, $2whNH.getWithDefault($d3YYW.get(dict$1, "defaultSortOrder"), null));
                        if (defaultSortOrder.TAG === /* Ok */ 0) {
                            var availableSorts = $3zjNo.optionFromJson(function(param) {
                                return $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$5, param);
                            }, $2whNH.getWithDefault($d3YYW.get(dict$1, "availableSorts"), null));
                            if (availableSorts.TAG === /* Ok */ 0) return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    page: page._0,
                                    products: products._0,
                                    filters: filters._0,
                                    total: total._0,
                                    syncStatus: syncStatus._0,
                                    defaultSortOrder: defaultSortOrder._0,
                                    availableSorts: availableSorts._0
                                }
                            };
                            var e = availableSorts._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".availableSorts" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = defaultSortOrder._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".defaultSortOrder" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = syncStatus._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".syncStatus" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = total._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".total" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = filters._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".filters" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = products._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".products" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
var $02d9048f3e76c404$var$codec$16 = [
    $02d9048f3e76c404$var$t_encode$38,
    $02d9048f3e76c404$var$t_decode$38
];
var $02d9048f3e76c404$var$empty_page$1 = {
    previous: undefined,
    next: undefined,
    offset: undefined,
    limit: undefined
};
var $02d9048f3e76c404$var$empty_products$1 = [];
var $02d9048f3e76c404$var$empty$3 = {
    page: $02d9048f3e76c404$var$empty_page$1,
    products: $02d9048f3e76c404$var$empty_products$1,
    filters: undefined,
    total: undefined,
    syncStatus: undefined,
    defaultSortOrder: undefined,
    availableSorts: undefined
};
var $02d9048f3e76c404$var$Page2 = {
    t_encode: $02d9048f3e76c404$var$t_encode$38,
    t_decode: $02d9048f3e76c404$var$t_decode$38,
    codec: $02d9048f3e76c404$var$codec$16,
    toJson: $02d9048f3e76c404$var$t_encode$38,
    fromJson: $02d9048f3e76c404$var$t_decode$38,
    empty: $02d9048f3e76c404$var$empty$3
};
var $02d9048f3e76c404$export$92e44ea1079b9ec6 = {
    Sort: undefined,
    t_encode: $02d9048f3e76c404$var$t_encode$36,
    t_decode: $02d9048f3e76c404$var$t_decode$36,
    codec: $02d9048f3e76c404$var$codec$14,
    toJson: $02d9048f3e76c404$var$t_encode$36,
    fromJson: $02d9048f3e76c404$var$t_decode$36,
    Page: $02d9048f3e76c404$var$Page$3,
    Page2: $02d9048f3e76c404$var$Page2
};
function $02d9048f3e76c404$var$kind_encode(v) {
    switch(v){
        case /* MultiLineTextField */ 0:
            return [
                "MultiLineTextField"
            ];
        case /* SingleLineTextField */ 1:
            return [
                "SingleLineTextField"
            ];
        case /* DecimalField */ 2:
            return [
                "DecimalField"
            ];
        case /* IntegerField */ 3:
            return [
                "IntegerField"
            ];
        case /* Dimension */ 4:
            return [
                "Dimension"
            ];
        case /* Date */ 5:
            return [
                "Date"
            ];
        case /* DateTime */ 6:
            return [
                "DateTime"
            ];
        case /* Color */ 7:
            return [
                "Color"
            ];
        case /* Boolean */ 8:
            return [
                "Boolean"
            ];
        case /* Json */ 9:
            return [
                "Json"
            ];
        case /* Money */ 10:
            return [
                "Money"
            ];
        case /* Volume */ 11:
            return [
                "Volume"
            ];
        case /* Weight */ 12:
            return [
                "Weight"
            ];
        case /* Url */ 13:
            return [
                "Url"
            ];
        case /* Rating */ 14:
            return [
                "Rating"
            ];
        case /* FileReference */ 15:
            return [
                "FileReference"
            ];
        case /* ListColor */ 16:
            return [
                "ListColor"
            ];
        case /* ListDimension */ 17:
            return [
                "ListDimension"
            ];
        case /* ListLink */ 18:
            return [
                "ListLink"
            ];
        case /* ListRating */ 19:
            return [
                "ListRating"
            ];
        case /* ListSingleLineTextField */ 20:
            return [
                "ListSingleLineTextField"
            ];
        case /* ListUrl */ 21:
            return [
                "ListUrl"
            ];
        case /* ListVolume */ 22:
            return [
                "ListVolume"
            ];
        case /* ListWeight */ 23:
            return [
                "ListWeight"
            ];
        case /* ListNumberDecimal */ 24:
            return [
                "ListNumberDecimal"
            ];
        case /* ListNumberInteger */ 25:
            return [
                "ListNumberInteger"
            ];
        case /* ListProductReference */ 26:
            return [
                "ListProductReference"
            ];
        case /* Unsupported */ 27:
            return [
                "Unsupported"
            ];
    }
}
function $02d9048f3e76c404$var$kind_decode(v) {
    var jsonArr = $1ArWc.classify(v);
    if (typeof jsonArr === "number") return $3zjNo.error(undefined, "Not a variant", v);
    if (jsonArr.TAG !== /* JSONArray */ 3) return $3zjNo.error(undefined, "Not a variant", v);
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) return $3zjNo.error(undefined, "Expected variant, found empty array", v);
    var tagged = $69lAE.map($1ArWc.classify, jsonArr$1);
    var match = $i7mYY.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) switch(match._0){
        case "Boolean":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Boolean */ 8
            };
        case "Color":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Color */ 7
            };
        case "Date":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Date */ 5
            };
        case "DateTime":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* DateTime */ 6
            };
        case "DecimalField":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* DecimalField */ 2
            };
        case "Dimension":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Dimension */ 4
            };
        case "FileReference":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* FileReference */ 15
            };
        case "IntegerField":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* IntegerField */ 3
            };
        case "Json":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Json */ 9
            };
        case "ListColor":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListColor */ 16
            };
        case "ListDimension":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListDimension */ 17
            };
        case "ListLink":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListLink */ 18
            };
        case "ListNumberDecimal":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListNumberDecimal */ 24
            };
        case "ListNumberInteger":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListNumberInteger */ 25
            };
        case "ListProductReference":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListProductReference */ 26
            };
        case "ListRating":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListRating */ 19
            };
        case "ListSingleLineTextField":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListSingleLineTextField */ 20
            };
        case "ListUrl":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListUrl */ 21
            };
        case "ListVolume":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListVolume */ 22
            };
        case "ListWeight":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* ListWeight */ 23
            };
        case "Money":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Money */ 10
            };
        case "MultiLineTextField":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* MultiLineTextField */ 0
            };
        case "Rating":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Rating */ 14
            };
        case "SingleLineTextField":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* SingleLineTextField */ 1
            };
        case "Unsupported":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Unsupported */ 27
            };
        case "Url":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Url */ 13
            };
        case "Volume":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Volume */ 11
            };
        case "Weight":
            if (tagged.length !== 1) return $3zjNo.error(undefined, "Invalid number of arguments to variant constructor", v);
            else return {
                TAG: /* Ok */ 0,
                _0: /* Weight */ 12
            };
        default:
    }
    return $3zjNo.error(undefined, "Invalid variant constructor", $i7mYY.getExn(jsonArr$1, 0));
}
function $02d9048f3e76c404$var$t_encode$39(v) {
    return $d3YYW.fromArray([
        [
            "key",
            $3zjNo.stringToJson(v.key)
        ],
        [
            "kind",
            $02d9048f3e76c404$var$kind_encode(v.kind)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$39(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var key = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "key"), null));
    if (key.TAG === /* Ok */ 0) {
        var kind = $02d9048f3e76c404$var$kind_decode($2whNH.getWithDefault($d3YYW.get(dict$1, "kind"), null));
        if (kind.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                key: key._0,
                kind: kind._0
            }
        };
        var e = kind._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".kind" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = key._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".key" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$var$codec$17 = [
    $02d9048f3e76c404$var$t_encode$39,
    $02d9048f3e76c404$var$t_decode$39
];
var $02d9048f3e76c404$export$c474c9ca2817f484 = {
    kind_encode: $02d9048f3e76c404$var$kind_encode,
    kind_decode: $02d9048f3e76c404$var$kind_decode,
    t_encode: $02d9048f3e76c404$var$t_encode$39,
    t_decode: $02d9048f3e76c404$var$t_decode$39,
    codec: $02d9048f3e76c404$var$codec$17,
    toJson: $02d9048f3e76c404$var$t_encode$39,
    fromJson: $02d9048f3e76c404$var$t_decode$39
};
function $02d9048f3e76c404$var$t_encode$40(v) {
    return $d3YYW.fromArray([
        [
            "page",
            $iv6Yc._1($cXHd0.t_encode, v.page)
        ],
        [
            "fields",
            $3zjNo.arrayToJson($02d9048f3e76c404$var$t_encode$39, v.fields)
        ]
    ]);
}
function $02d9048f3e76c404$var$t_decode$40(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var page = $iv6Yc._1($cXHd0.t_decode, $2whNH.getWithDefault($d3YYW.get(dict$1, "page"), null));
    if (page.TAG === /* Ok */ 0) {
        var fields = $3zjNo.arrayFromJson($02d9048f3e76c404$var$t_decode$39, $2whNH.getWithDefault($d3YYW.get(dict$1, "fields"), null));
        if (fields.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                page: page._0,
                fields: fields._0
            }
        };
        var e = fields._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".fields" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $02d9048f3e76c404$var$codec$18 = [
    $02d9048f3e76c404$var$t_encode$40,
    $02d9048f3e76c404$var$t_decode$40
];
var $02d9048f3e76c404$var$Page$4 = {
    t_encode: $02d9048f3e76c404$var$t_encode$40,
    t_decode: $02d9048f3e76c404$var$t_decode$40,
    codec: $02d9048f3e76c404$var$codec$18,
    toJson: $02d9048f3e76c404$var$t_encode$40,
    fromJson: $02d9048f3e76c404$var$t_decode$40
};
var $02d9048f3e76c404$export$6ffd3d1839ca7b87 = {
    Page: $02d9048f3e76c404$var$Page$4
};
var $02d9048f3e76c404$export$d5b7a8bf56ee1fe2 = $02d9048f3e76c404$export$cc42ff7b6c615091;
var $02d9048f3e76c404$export$7ae2d2a8b28a8cb8 = $02d9048f3e76c404$export$bb5e712207166a02;
 /* StoreId-ApiTypes Not a pure module */ 
});
parcelRegister("cXHd0", function(module, exports) {

$parcel$export(module.exports, "$$default", function () { return $96fc831a7861801c$export$aa541d093b11ace2; });
$parcel$export(module.exports, "t_encode", function () { return $96fc831a7861801c$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "t_decode", function () { return $96fc831a7861801c$export$bb5e712207166a02; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $96fc831a7861801c$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "previous",
            $jVmMx.Encode.nullable(param.previous, $jVmMx.Encode.string)
        ],
        [
            "next",
            $jVmMx.Encode.nullable(param.next, $jVmMx.Encode.string)
        ],
        [
            "offset",
            $jVmMx.Encode.nullable(param.offset, $jVmMx.Encode.$$int)
        ],
        [
            "limit",
            $jVmMx.Encode.nullable(param.limit, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $96fc831a7861801c$export$7ae2d2a8b28a8cb8 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "previous", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "next", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("offset", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("limit", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(previous, next, offset, limit) {
    return {
        previous: previous,
        next: next,
        offset: offset,
        limit: limit
    };
});
var $96fc831a7861801c$var$include = $doJJK.Make({
    toJson: $96fc831a7861801c$export$d5b7a8bf56ee1fe2,
    fromJson: $96fc831a7861801c$export$7ae2d2a8b28a8cb8
});
var $96fc831a7861801c$export$aa541d093b11ace2 = {
    previous: undefined,
    next: undefined,
    offset: undefined,
    limit: undefined
};
var $96fc831a7861801c$export$cc42ff7b6c615091 = $96fc831a7861801c$var$include.t_encode;
var $96fc831a7861801c$export$bb5e712207166a02 = $96fc831a7861801c$var$include.t_decode;
var $96fc831a7861801c$export$1c37c01eba8ed446 = $96fc831a7861801c$var$include.codec;
 /* fromJson Not a pure module */ 
});


parcelRegister("dkuGO", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $9b44f2e7a4828464$export$2f872c0f2117be69; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");
function $9b44f2e7a4828464$export$2f872c0f2117be69(json, decoder) {
    var decoded = $iv6Yc._1(decoder, json);
    if (decoded.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: decoded._0
    };
    var error = decoded._0;
    return {
        TAG: /* Error */ 1,
        _0: $i7mYY.keep([
            error.message,
            error.path
        ], function(e) {
            return e.trim() !== "";
        }).join(" at ")
    };
}
 /* No side effect */ 
});

parcelRegister("juPKE", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $e318f670803752f5$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
var $e318f670803752f5$export$b8b56b47d6b8a156 = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "suggestedCurrency", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "availableCurrencies", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string)), function(suggestedCurrency, availableCurrencies) {
    return {
        suggestedCurrency: suggestedCurrency,
        availableCurrencies: availableCurrencies
    };
});
var $e318f670803752f5$export$d014287f9035bdf6 = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "suggestedCountry", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "availableCountries", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string)), function(suggestedCountry, availableCountries) {
    return {
        suggestedCountry: suggestedCountry,
        availableCountries: availableCountries
    };
});
var $e318f670803752f5$export$46ffc5b8e0e156e9 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Currencies", $e318f670803752f5$export$b8b56b47d6b8a156, function(c) {
    return {
        TAG: /* Currencies */ 1,
        _0: c
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Countries", $e318f670803752f5$export$d014287f9035bdf6, function(i) {
        return {
            TAG: /* Countries */ 0,
            _0: i
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "NotSupported",
            /* NotSupported */ 0
        ]
    ])
]);
var $e318f670803752f5$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "choices", $iv6Yc._1($jVmMx.Decode.option, $e318f670803752f5$export$46ffc5b8e0e156e9)), function(choices) {
    return {
        choices: choices
    };
});
 /* currencyOptions_fromJson Not a pure module */ 
});

parcelRegister("9XHIv", function(module, exports) {

$parcel$export(module.exports, "useParseMarket", function () { return $740b88ff9da68360$export$f23d3a1f4a90cf33; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $8E2YL = parcelRequire("8E2YL");
function $740b88ff9da68360$export$f23d3a1f4a90cf33(country, currency, language) {
    var match = $8E2YL.use(undefined);
    var isAnimus = $7bjme.equal(match.config.accountId, "nVCcJkO2M") && $7bjme.equal(country, "DE");
    return [
        isAnimus ? undefined : country,
        isAnimus ? undefined : currency,
        isAnimus ? undefined : language
    ];
}
 /* ConfigurationProvider-Showside Not a pure module */ 
});

parcelRegister("gXxeV", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $c58bf0c389d33075$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $8u0V4 = parcelRequire("8u0V4");

var $9bmXk = parcelRequire("9bmXk");

var $bZsVp = parcelRequire("bZsVp");

var $9XHIv = parcelRequire("9XHIv");
var $c58bf0c389d33075$export$db178c719d158eb3 = {
    contents: undefined
};
function $c58bf0c389d33075$export$1f96ae73734a86cc(market, language, storeId, smartnavApiHost, hideOutOfStock, $$fetch, productId) {
    var match = $8u0V4.getValues(market);
    var match$1 = $9XHIv.useParseMarket(match.country, match.currency, language);
    var currency = match$1[1];
    var country = match$1[0];
    var newKey = storeId !== undefined ? smartnavApiHost + "/api/get_products?product_ids=" + productId + (hideOutOfStock ? "&in_stock=true" : "") + ("&store_id=" + storeId) + $2whNH.mapWithDefault(country, "", function(country) {
        return "&country=" + country;
    }) + $2whNH.mapWithDefault(currency, "", function(currency) {
        return "&currency=" + currency;
    }) + $2whNH.mapWithDefault(match$1[2], "", function(language) {
        return "&language=" + language;
    }) : undefined;
    var findExistingReusableKey = function findExistingReusableKey(param) {
        var match = $c58bf0c389d33075$export$db178c719d158eb3.contents;
        if (match === undefined) return;
        var foundInLast = $loT9g.undefined_to_opt($2whNH.getWithDefault(match[1].data, []).find(function(p) {
            return p.id === productId;
        })) !== undefined;
        if (foundInLast) return match[0];
    };
    var match$2 = findExistingReusableKey(undefined);
    var key = productId === "" ? undefined : match$2 !== undefined ? match$2 : newKey;
    var match$3 = $2gEz2.useSWR(undefined, undefined, undefined, false, $9bmXk.fromOption(key), $iv6Yc.__1($$fetch));
    var isValidating = match$3.isValidating;
    var data = match$3.data;
    var error = match$3.error;
    if (key !== undefined) $c58bf0c389d33075$export$db178c719d158eb3.contents = [
        key,
        {
            data: data,
            error: error,
            isValidating: isValidating
        }
    ];
    var findPartialData = function findPartialData(param) {
        var scraped = $bZsVp.getProductById(smartnavApiHost, currency, country, productId);
        return $2whNH.orElse($2whNH.map(scraped, function(product) {
            return [
                product
            ];
        }), data);
    };
    return {
        data: findPartialData(undefined),
        error: error,
        isValidating: isValidating
    };
}
 /* SWR Not a pure module */ 
});

parcelRegister("c06xW", function(module, exports) {

$parcel$export(module.exports, "Page", function () { return $8bca9018b2048489$export$6955bcca4cd3539f; });
$parcel$export(module.exports, "$$Array", function () { return $8bca9018b2048489$export$c6a7207250233e55; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $f9ONQ = parcelRequire("f9ONQ");

var $7KlbQ = parcelRequire("7KlbQ");

var $dkuGO = parcelRequire("dkuGO");
var $8bca9018b2048489$var$empty_products = [];
var $8bca9018b2048489$var$empty_page = {
    previous: undefined,
    next: undefined,
    offset: undefined,
    limit: undefined
};
var $8bca9018b2048489$var$empty = {
    products: $8bca9018b2048489$var$empty_products,
    page: $8bca9018b2048489$var$empty_page,
    filters: undefined,
    availableSorts: undefined,
    defaultSortOrder: undefined,
    total: undefined,
    syncStatus: undefined
};
function $8bca9018b2048489$var$fromJson(appliedFilters, hideOutOfStock, categoryId, storeId, json) {
    var page = $dkuGO.decode(json, $f9ONQ.Products.Page2.fromJson);
    if (page.TAG !== /* Ok */ 0) return {
        TAG: /* Error */ 1,
        _0: page._0
    };
    var page$1 = page._0;
    var products = $i7mYY.keepMap($i7mYY.map(page$1.products, function(__x) {
        return $7KlbQ.tryParseFromDTO(appliedFilters, hideOutOfStock, categoryId, storeId, __x);
    }), function(a) {
        return a;
    });
    return {
        TAG: /* Ok */ 0,
        _0: {
            products: products,
            page: page$1.page,
            filters: page$1.filters,
            availableSorts: page$1.availableSorts,
            defaultSortOrder: page$1.defaultSortOrder,
            total: page$1.total,
            syncStatus: page$1.syncStatus
        }
    };
}
var $8bca9018b2048489$export$6955bcca4cd3539f = {
    empty: $8bca9018b2048489$var$empty,
    fromJson: $8bca9018b2048489$var$fromJson
};
function $8bca9018b2048489$var$fromJson$1(hideOutOfStock, categoryId, storeId, json) {
    var products = $dkuGO.decode(json, $f9ONQ.Products.fromJson);
    if (products.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: $i7mYY.keepMap($i7mYY.map(products._0, function(product) {
            return $7KlbQ.tryParseFromDTO(undefined, hideOutOfStock, categoryId, storeId, product);
        }), function(a) {
            return a;
        })
    };
    else return {
        TAG: /* Error */ 1,
        _0: products._0
    };
}
var $8bca9018b2048489$export$c6a7207250233e55 = {
    fromJson: $8bca9018b2048489$var$fromJson$1
};
function $8bca9018b2048489$export$7ae2d2a8b28a8cb8(hideOutOfStock, categoryId, storeId, json) {
    var product = $dkuGO.decode(json, $f9ONQ.Product.fromJson);
    if (product.TAG === /* Ok */ 0) return $2whNH.mapWithDefault($7KlbQ.tryParseFromDTO(undefined, hideOutOfStock, categoryId, storeId, product._0), {
        TAG: /* Error */ 1,
        _0: "Don't know how to parse this product"
    }, function(product) {
        return {
            TAG: /* Ok */ 0,
            _0: product
        };
    });
    else return {
        TAG: /* Error */ 1,
        _0: product._0
    };
}
 /* Store-ApiTypes Not a pure module */ 
});


parcelRegister("tUpyX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $059e77a876c84c60$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $bygWp = parcelRequire("bygWp");

var $gCzsf = parcelRequire("gCzsf");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");
function $059e77a876c84c60$var$Link(Props) {
    var children = Props.children;
    var href = Props.href;
    var title = Props.title;
    var fwdRef = Props.fwdRef;
    var disabledOpt = Props.disabled;
    var unstyledOpt = Props.unstyled;
    var underlineOpt = Props.underline;
    var accentOpt = Props.accent;
    var classNameOpt = Props.className;
    var textSizeOpt = Props.textSize;
    var style = Props.style;
    var role = Props.role;
    var ariaLive = Props.ariaLive;
    var ariaLabel = Props.ariaLabel;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var data = Props.data;
    var dataTestId = Props.dataTestId;
    var dataCount = Props.dataCount;
    var dataDisabled = Props.dataDisabled;
    var onClick = Props.onClick;
    var onMouseOverOpt = Props.onMouseOver;
    var onMouseLeaveOpt = Props.onMouseLeave;
    var tabIndexOpt = Props.tabIndex;
    var icon = Props.icon;
    var disabled = disabledOpt !== undefined ? disabledOpt : false;
    var unstyled = unstyledOpt !== undefined ? unstyledOpt : false;
    var underline = underlineOpt !== undefined ? underlineOpt : false;
    var accent = accentOpt !== undefined ? accentOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var textSize = textSizeOpt !== undefined ? textSizeOpt : /* Xl */ 2;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var onMouseOver = onMouseOverOpt !== undefined ? onMouseOverOpt : function onMouseOver(param) {};
    var onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : function onMouseLeave(param) {};
    var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : 0;
    $aSJcu.use(undefined);
    var match = $9pMGg.use(undefined);
    var redirectToLink = match.redirectToLink;
    var href$1 = $2whNH.map(href, $bygWp.maybeMakeRelativeUrl);
    var role$1 = role !== undefined ? role : href$1 !== undefined ? "link" : "button";
    var tmp;
    if (unstyled) tmp = "";
    else switch(textSize){
        case /* Base */ 0:
            tmp = $ezf3v.prefix("text-base");
            break;
        case /* Lg */ 1:
            tmp = $ezf3v.prefix("text-lg");
            break;
        case /* Xl */ 2:
            tmp = $ezf3v.prefix("text-xl");
            break;
    }
    var className$1 = $1TRFX.make([
        unstyled ? "" : $ezf3v.prefix("inline-block whitespace-nowrap dark-hover darker-active cursor-pointer"),
        unstyled ? "" : accent ? $ezf3v.prefix("!text-accent") : $ezf3v.prefix("!text-primary"),
        tmp,
        unstyled ? "" : underline ? $ezf3v.prefix("underline") : $ezf3v.prefix("!no-underline hover:underline"),
        $2whNH.isSome(icon) ? $ezf3v.prefix("flex") : "",
        $ezf3v.prefix("font-button"),
        className
    ]);
    var onClick$1 = function onClick$1(e) {
        e.preventDefault();
        $2whNH.forEach(onClick, function(cb) {
            $iv6Yc._1(cb, e);
        });
        if (href$1 !== undefined && !disabled) return $iv6Yc._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, href$1);
    };
    var tmp$1 = {
        className: className$1,
        draggable: false,
        role: role$1,
        tabIndex: tabIndex,
        onClick: onClick$1,
        onMouseLeave: onMouseLeave,
        onMouseOver: onMouseOver
    };
    if (fwdRef !== undefined) tmp$1.ref = $loT9g.valFromOption(fwdRef);
    if (ariaLabel !== undefined) tmp$1["aria-label"] = $loT9g.valFromOption(ariaLabel);
    if (style !== undefined) tmp$1.style = $loT9g.valFromOption(style);
    if (title !== undefined) tmp$1.title = $loT9g.valFromOption(title);
    if (data !== undefined) tmp$1.data = $loT9g.valFromOption(data);
    if (href$1 !== undefined) tmp$1.href = $loT9g.valFromOption(href$1);
    var tmp$2 = {
        children: /*#__PURE__*/ $g85JO.createElement("a", tmp$1, $2whNH.mapWithDefault(icon, null, function(icon) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("mr-2")
            }, icon);
        }), children)
    };
    if (dataDisabled !== undefined) tmp$2.dataDisabled = $loT9g.valFromOption(dataDisabled);
    if (dataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(dataTestId);
    if (dataCount !== undefined) tmp$2.dataCount = $loT9g.valFromOption(dataCount);
    if (ariaLive !== undefined) tmp$2.ariaLive = $loT9g.valFromOption(ariaLive);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$2);
}
$059e77a876c84c60$var$Link.displayName = "Link";
var $059e77a876c84c60$export$dd44f18ab656f3bb = $059e77a876c84c60$var$Link;
 /* react Not a pure module */ 
});

parcelRegister("dMhWy", function(module, exports) {

$parcel$export(module.exports, "useFavorites", function () { return $a07dad45ca0c5362$export$5d6d07171bf99999; });
$parcel$export(module.exports, "useRecentlyAdded", function () { return $a07dad45ca0c5362$export$b265d9d22e0fafb7; });
$parcel$export(module.exports, "useFavoritesLink", function () { return $a07dad45ca0c5362$export$d35899afbce7b08d; });
$parcel$export(module.exports, "ToggleButton", function () { return $a07dad45ca0c5362$export$d2b052e7b4be1756; });
$parcel$export(module.exports, "OpenButton", function () { return $a07dad45ca0c5362$export$3a4c6d3406a95fae; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $bG38u = parcelRequire("bG38u");

var $7wIsS = parcelRequire("7wIsS");

var $3QSSt = parcelRequire("3QSSt");

var $gYqk6 = parcelRequire("gYqk6");

var $27XcH = parcelRequire("27XcH");

var $dAJXq = parcelRequire("dAJXq");

var $2jMpY = parcelRequire("2jMpY");

var $hBcYV = parcelRequire("hBcYV");

var $jmDU9 = parcelRequire("jmDU9");

var $aJ48X = parcelRequire("aJ48X");

var $6Y4PS = parcelRequire("6Y4PS");

var $aSJcu = parcelRequire("aSJcu");

var $6jWwC = parcelRequire("6jWwC");

var $9pMGg = parcelRequire("9pMGg");

var $iCVlB = parcelRequire("iCVlB");

var $edu9N = parcelRequire("edu9N");

var $8E2YL = parcelRequire("8E2YL");

var $6EwcS = parcelRequire("6EwcS");
function $a07dad45ca0c5362$export$5d6d07171bf99999(param) {
    var sourceLocalStorage = $6EwcS.use(undefined).favorites;
    var sourceSwymit = $jmDU9.use(undefined);
    var match = sourceSwymit.supported;
    var match$1 = sourceLocalStorage.enabled;
    var source = match ? /* SourceSwymit */ 1 : match$1 ? /* SourceLocalStorage */ 0 : /* SourceNoop */ 2;
    switch(source){
        case /* SourceLocalStorage */ 0:
            var count = sourceLocalStorage.count;
            var enabled = sourceLocalStorage.enabled;
            var handleAdd = function handleAdd(product) {
                return $iv6Yc._1(sourceLocalStorage.add, {
                    TAG: /* Product */ 0,
                    _0: product
                });
            };
            var handleRemove = function handleRemove(product) {
                return $iv6Yc._1(sourceLocalStorage.remove, {
                    TAG: /* Product */ 0,
                    _0: product
                });
            };
            var isAdded = function isAdded(product) {
                return $iv6Yc._1(sourceLocalStorage.isAdded, {
                    TAG: /* Product */ 0,
                    _0: product
                });
            };
            return {
                source: /* SourceLocalStorage */ 0,
                enabled: enabled,
                add: handleAdd,
                remove: handleRemove,
                isAdded: isAdded,
                count: count
            };
        case /* SourceSwymit */ 1:
            var count$1 = sourceSwymit.count;
            var enabled$1 = sourceSwymit.loaded;
            var handleAdd$1 = function handleAdd$1(product) {
                return $iv6Yc._1(sourceSwymit.add, product.link);
            };
            var handleRemove$1 = function handleRemove$1(product) {
                return $iv6Yc._1(sourceSwymit.remove, product.link);
            };
            var isAdded$1 = function isAdded$1(product) {
                return $iv6Yc._1(sourceSwymit.isAdded, product.firstVariant.id);
            };
            return {
                source: /* SourceSwymit */ 1,
                enabled: enabled$1,
                add: handleAdd$1,
                remove: handleRemove$1,
                isAdded: isAdded$1,
                count: count$1
            };
        case /* SourceNoop */ 2:
            var add = function add(param) {
                return Promise.resolve(undefined);
            };
            var remove = function remove(param) {
                return Promise.resolve(undefined);
            };
            var isAdded$2 = function isAdded$2(param) {
                return Promise.resolve(false);
            };
            return {
                source: /* SourceNoop */ 2,
                enabled: false,
                add: add,
                remove: remove,
                isAdded: isAdded$2,
                count: 0
            };
    }
}
function $a07dad45ca0c5362$export$b265d9d22e0fafb7(param) {
    var match = $6EwcS.use(undefined).favorites;
    var enabled = match.enabled;
    var value = match.value;
    var previous = $3QSSt.usePreviousDistinct(value);
    var newAddedValue = $g85JO.useMemo(function() {
        if (!enabled) return;
        var hasAdded = value.length > previous.length;
        return $2whNH.flatMap($i7mYY.get(value, 0), function(value) {
            if (value.TAG === /* Product */ 0 && hasAdded) return value._0;
        });
    }, [
        value.length,
        previous.length
    ]);
    var match$1 = $g85JO.useState(function() {
        return newAddedValue;
    });
    var setNewAdded = match$1[1];
    $g85JO.useEffect(function() {
        if (!enabled) return;
        $iv6Yc._1(setNewAdded, function(param) {
            return newAddedValue;
        });
        var timeoutId = setTimeout(function(param) {
            $iv6Yc._1(setNewAdded, function(param) {});
        }, 4000);
        return function(param) {
            clearTimeout(timeoutId);
        };
    }, [
        newAddedValue
    ]);
    return [
        match$1[0],
        setNewAdded
    ];
}
function $a07dad45ca0c5362$export$d35899afbce7b08d(param) {
    var bombayshirts = $iCVlB.useWishlistLink(undefined);
    var brighton = $6jWwC.useWishlistLink(undefined);
    return $2whNH.orElse(bombayshirts, brighton);
}
function $a07dad45ca0c5362$var$Favorites$RecentlyAddedPopup(Props) {
    var position = Props.position;
    var match = $9pMGg.use(undefined);
    var onFavoritesClick = match.onFavoritesClick;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var route = match$1.route;
    var match$2 = $8E2YL.use(undefined);
    var match$3 = match$2.config.settings;
    var pdpCTAButtonTextColor = match$3.pdpCTAButtonTextColor;
    var pdpCTAButtonBgColor = match$3.pdpCTAButtonBgColor;
    var match$4 = $a07dad45ca0c5362$export$b265d9d22e0fafb7(undefined);
    var setNewAdded = match$4[1];
    var newAdded = match$4[0];
    var renderHeader = function renderHeader(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("text-xl font-semibold flex-grow")
        }, "Saved to favorites!"), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0")
        }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                $iv6Yc._1(setNewAdded, function(param) {});
            },
            size: /* Normal */ 2,
            iconSize: /* Small */ 3,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {}),
            dataTestId: "favorites-close-button",
            className: $ezf3v.prefix("-mt-4 -mr-4")
        })));
    };
    var renderProductCard = function renderProductCard(product) {
        return /*#__PURE__*/ $g85JO.createElement($6Y4PS.make, {
            product: product,
            shape: /* Square */ 1,
            imageFitStrategy: /* Cover */ 1,
            padding: false,
            onClick: function onClick(param, param$1) {
                var pdpRoute;
                var exit = 0;
                if (typeof route === "number") exit = 1;
                else switch(route.TAG | 0){
                    case /* Home */ 0:
                        exit = 1;
                        break;
                    case /* ListPage */ 1:
                        var listPageType = route._0.listPageType;
                        var exit$1 = 0;
                        if (typeof listPageType === "number" || listPageType.TAG !== /* Category */ 0) exit$1 = 2;
                        else {
                            var categoryId = listPageType._0;
                            pdpRoute = {
                                TAG: /* PDP */ 2,
                                _0: {
                                    categoryId: categoryId,
                                    productCategoryId: categoryId,
                                    productId: product.id,
                                    variantId: undefined,
                                    zoomedPhotoIndex: undefined
                                }
                            };
                        }
                        if (exit$1 === 2) pdpRoute = {
                            TAG: /* PDP */ 2,
                            _0: {
                                categoryId: undefined,
                                productCategoryId: undefined,
                                productId: product.id,
                                variantId: undefined,
                                zoomedPhotoIndex: undefined
                            }
                        };
                        break;
                    case /* PDP */ 2:
                    case /* QuickView */ 3:
                        pdpRoute = route;
                        break;
                }
                if (exit === 1) pdpRoute = {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: undefined,
                        productCategoryId: undefined,
                        productId: product.id,
                        variantId: undefined,
                        zoomedPhotoIndex: undefined
                    }
                };
                $iv6Yc._3(goTo, undefined, undefined, pdpRoute);
            }
        });
    };
    var renderFooter = function renderFooter(param) {
        return /*#__PURE__*/ $g85JO.createElement($edu9N.make, {
            size: /* Md */ 2,
            label: "View all Favorites",
            style: {
                backgroundColor: pdpCTAButtonBgColor,
                color: pdpCTAButtonTextColor
            },
            onClick: function onClick(param) {
                $iv6Yc._1(setNewAdded, function(param) {});
                $iv6Yc._1(onFavoritesClick, undefined);
            },
            primary: true,
            dataTestId: "favorites-see-all-button"
        });
    };
    return /*#__PURE__*/ $g85JO.createElement($bG38u.make, {
        position: position,
        show: $2whNH.isSome(newAdded),
        className: $ezf3v.prefix("p-8"),
        dataTestId: "favorites-popup",
        children: null
    }, renderHeader(undefined), newAdded !== undefined ? renderProductCard(newAdded) : null, renderFooter(undefined));
}
$a07dad45ca0c5362$var$Favorites$RecentlyAddedPopup.displayName = "Favorites.RecentlyAddedPopup";
var $a07dad45ca0c5362$export$c3b4aff26e467d6b = {
    make: $a07dad45ca0c5362$var$Favorites$RecentlyAddedPopup
};
function $a07dad45ca0c5362$var$Favorites$ToggleButton(Props) {
    var product = Props.product;
    var atOpt = Props.at;
    var tabIndex = Props.tabIndex;
    var at = atOpt !== undefined ? atOpt : /* ProductCard */ 0;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $a07dad45ca0c5362$export$5d6d07171bf99999(undefined);
    var isAdded = match$1.isAdded;
    var remove = match$1.remove;
    var add = match$1.add;
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setSelected = match$2[1];
    var selected = match$2[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(isAdded, product).then(function(isAdded) {
            $iv6Yc._1(setSelected, function(param) {
                return isAdded;
            });
        });
    }, [
        product.id,
        match$1.count
    ]);
    var handleClickAsync = $g85JO.useCallback(function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (selected) return $iv6Yc._1(remove, product).then(function(param) {
            $iv6Yc._1(setSelected, function(param) {
                return false;
            });
        });
        else return $iv6Yc._1(add, product).then(function(param) {
            $iv6Yc._1(setSelected, function(param) {
                return true;
            });
        });
    }, [
        selected,
        product.id
    ]);
    if (!match$1.enabled) return null;
    var tmp;
    switch(at){
        case /* ProductCard */ 0:
            tmp = /* Small */ 3;
            break;
        case /* PDP */ 1:
            tmp = /* Large */ 1;
            break;
        case /* PDPSticky */ 2:
            tmp = /* Largest */ 0;
            break;
    }
    var tmp$1 = {
        onClickAsync: handleClickAsync,
        clear: isMobile,
        rounded: at === /* ProductCard */ 0,
        relative: false,
        size: tmp,
        iconSize: isMobile ? /* Smallest */ 4 : /* Small */ 3,
        icon: selected ? /*#__PURE__*/ $g85JO.createElement($aJ48X.make, {}) : /*#__PURE__*/ $g85JO.createElement($gYqk6.make, {}),
        title: selected ? "Remove from favorites" : "Add to favorites",
        dataTestId: "favorites-toggle-button",
        iconClassName: $ezf3v.prefix("-mb-0.5"),
        className: $ezf3v.prefix(at !== 0 ? "border border-primary" : isMobile ? "" : "absolute top-4 right-4")
    };
    if (tabIndex !== undefined) tmp$1.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp$1);
}
$a07dad45ca0c5362$var$Favorites$ToggleButton.displayName = "Favorites.ToggleButton";
var $a07dad45ca0c5362$export$d2b052e7b4be1756 = {
    make: $a07dad45ca0c5362$var$Favorites$ToggleButton
};
function $a07dad45ca0c5362$var$Favorites$OpenButton(Props) {
    var atOpt = Props.at;
    var at = atOpt !== undefined ? atOpt : /* Navbar */ 0;
    var match = $9pMGg.use(undefined);
    var onFavoritesClick = match.onFavoritesClick;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $a07dad45ca0c5362$export$5d6d07171bf99999(undefined);
    var partial_arg = 1;
    var partial_arg$1 = 99;
    var badge = $2whNH.flatMap($2whNH.keep(match$2.count, function(i) {
        return i > 0;
    }), function(param) {
        return $2jMpY.fromInt(partial_arg$1, partial_arg, param);
    });
    var tmp;
    if (at) {
        var tmp$1 = {
            onClick: function onClick(param) {
                $iv6Yc._1(onFavoritesClick, undefined);
            },
            shadow: true,
            icon: /*#__PURE__*/ $g85JO.createElement($gYqk6.make, {}),
            title: "Favorites",
            dataTestId: "favorites-pdp-button",
            iconClassName: $ezf3v.prefix("-mb-0.5"),
            className: $ezf3v.prefix("mr-2 -top-px pointer-events-auto")
        };
        if (badge !== undefined) tmp$1.badge = $loT9g.valFromOption(badge);
        tmp = /*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp$1);
    } else {
        var tmp$2 = {
            label: "Favorites",
            children: /*#__PURE__*/ $g85JO.createElement($gYqk6.make, {}),
            onClick: function onClick(param) {
                $iv6Yc._1(onFavoritesClick, undefined);
            },
            pixelAdjustments: "-3px -3px -3px -3px",
            position: /* Fixed */ 1,
            dataTestId: "favorites-navbar-button"
        };
        if (badge !== undefined) tmp$2.badge = $loT9g.valFromOption(badge);
        tmp = /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$2);
    }
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, tmp, /*#__PURE__*/ $g85JO.createElement($a07dad45ca0c5362$var$Favorites$RecentlyAddedPopup, {
        position: at ? isMobile ? {
            top: {
                TAG: /* Ratio */ 1,
                _0: 1.2
            },
            left: {
                TAG: /* Px */ 0,
                _0: 10
            },
            bottom: /* Auto */ 0,
            right: {
                TAG: /* Px */ 0,
                _0: 10
            }
        } : {
            top: {
                TAG: /* Ratio */ 1,
                _0: 1.2
            },
            left: /* Auto */ 0,
            bottom: /* Auto */ 0,
            right: {
                TAG: /* Px */ 0,
                _0: 10
            }
        } : isMobile ? {
            top: /* Auto */ 0,
            left: {
                TAG: /* Px */ 0,
                _0: 10
            },
            bottom: {
                TAG: /* Ratio */ 1,
                _0: 1.1
            },
            right: {
                TAG: /* Px */ 0,
                _0: 10
            }
        } : {
            top: {
                TAG: /* Ratio */ 1,
                _0: 1.0
            },
            left: /* Auto */ 0,
            bottom: /* Auto */ 0,
            right: {
                TAG: /* Px */ 0,
                _0: 90
            }
        }
    }));
}
$a07dad45ca0c5362$var$Favorites$OpenButton.displayName = "Favorites.OpenButton";
var $a07dad45ca0c5362$export$3a4c6d3406a95fae = {
    make: $a07dad45ca0c5362$var$Favorites$OpenButton
};
 /* react Not a pure module */ 
});
parcelRegister("bG38u", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $88060cb47110fc4b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");
function $88060cb47110fc4b$var$Popup(Props) {
    var position = Props.position;
    var showOpt = Props.show;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var children = Props.children;
    var show = showOpt !== undefined ? showOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var px = position.bottom;
    var tmp;
    tmp = typeof px === "number" ? undefined : px.TAG === /* Px */ 0 ? $ezf3v.intToPx(px._0) : $ezf3v.floatToPercentage(px._0 * 100);
    var px$1 = position.left;
    var tmp$1;
    tmp$1 = typeof px$1 === "number" ? undefined : px$1.TAG === /* Px */ 0 ? $ezf3v.intToPx(px$1._0) : $ezf3v.floatToPercentage(px$1._0 * 100);
    var px$2 = position.right;
    var tmp$2;
    tmp$2 = typeof px$2 === "number" ? undefined : px$2.TAG === /* Px */ 0 ? $ezf3v.intToPx(px$2._0) : $ezf3v.floatToPercentage(px$2._0 * 100);
    var px$3 = position.top;
    var tmp$3;
    tmp$3 = typeof px$3 === "number" ? undefined : px$3.TAG === /* Px */ 0 ? $ezf3v.intToPx(px$3._0) : $ezf3v.floatToPercentage(px$3._0 * 100);
    var match = position.left;
    var match$1 = position.right;
    var tmp$4;
    tmp$4 = typeof match === "number" || !(match.TAG === /* Px */ 0 && !(typeof match$1 === "number" || match$1.TAG !== /* Px */ 0)) ? "100%" : "auto";
    var tmp$5 = {
        maxWidth: "370px",
        width: tmp$4
    };
    if (tmp !== undefined) tmp$5.bottom = tmp;
    if (tmp$1 !== undefined) tmp$5.left = tmp$1;
    if (tmp$2 !== undefined) tmp$5.right = tmp$2;
    if (tmp$3 !== undefined) tmp$5.top = tmp$3;
    var style = tmp$5;
    if (!show) return null;
    var tmp$6 = {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("bg-main absolute rounded-lg shadow-xl flex flex-col space-y-4 pointer-events-auto ring-1 ring-black ring-opacity-5"),
                className
            ]),
            style: style
        }, children)
    };
    if (dataTestId !== undefined) tmp$6.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$6);
}
$88060cb47110fc4b$var$Popup.displayName = "Popup";
var $88060cb47110fc4b$export$dd44f18ab656f3bb = $88060cb47110fc4b$var$Popup;
 /* react Not a pure module */ 
});

parcelRegister("gYqk6", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c5b6ab346934b32b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $c5b6ab346934b32b$var$IconHeart(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        style: {
            height: "16px",
            width: "18px"
        },
        height: "16",
        width: "18",
        fill: "none",
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M16.1232 1.56352C18.2243 3.3644 18.3243 6.56597 16.4567 8.50024L9.98691 15.1702C9.78681 15.3703 9.52001 15.4703 9.21986 15.4703C8.95307 15.4703 8.68627 15.3703 8.48617 15.1702L2.01635 8.50024C0.148771 6.56597 0.248819 3.3644 2.34984 1.56352C3.15024 0.863182 4.15072 0.529686 5.15121 0.529686C6.38515 0.529686 7.65243 1.06328 8.58622 1.99707L9.25321 2.69741L9.88686 1.99707C10.8206 1.06328 12.0879 0.529686 13.3219 0.529686C14.3224 0.529686 15.3228 0.863182 16.1232 1.56352ZM15.2895 7.39971C16.39 6.26582 16.6235 4.09809 15.0894 2.79746C13.7554 1.63022 11.9212 2.23052 11.0541 3.13096L9.25321 4.99853L7.41899 3.13096C6.5519 2.19717 4.71767 1.63022 3.38368 2.79746C1.8496 4.09809 2.1164 6.26582 3.18359 7.39971L9.25321 13.6361L15.2895 7.39971Z",
        fill: "currentColor"
    }));
}
$c5b6ab346934b32b$var$IconHeart.displayName = "IconHeart";
var $c5b6ab346934b32b$export$dd44f18ab656f3bb = $c5b6ab346934b32b$var$IconHeart;
 /* react Not a pure module */ 
});

parcelRegister("dAJXq", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9e52495f261a1f01$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $dzvJv = parcelRequire("dzvJv");

var $gCzsf = parcelRequire("gCzsf");

var $dtaxl = parcelRequire("dtaxl");
function $9e52495f261a1f01$var$NavbarItem(Props) {
    var label = Props.label;
    var children = Props.children;
    var showOpt = Props.show;
    var showLabelOpt = Props.showLabel;
    var onClick = Props.onClick;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var classNameOpt = Props.className;
    var href = Props.href;
    var pixelAdjustmentsOpt = Props.pixelAdjustments;
    var disabledOpt = Props.disabled;
    var hideOnDisableOpt = Props.hideOnDisable;
    var badge = Props.badge;
    var customStyle = Props.customStyle;
    var dataTestId = Props.dataTestId;
    var themeOpt = Props.theme;
    var badgeDataTestId = Props.badgeDataTestId;
    var show = showOpt !== undefined ? showOpt : true;
    var showLabel = showLabelOpt !== undefined ? showLabelOpt : false;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var pixelAdjustments = pixelAdjustmentsOpt !== undefined ? pixelAdjustmentsOpt : "0 0 0 0";
    var disabled = disabledOpt !== undefined ? disabledOpt : false;
    var hideOnDisable = hideOnDisableOpt !== undefined ? hideOnDisableOpt : false;
    var theme = themeOpt !== undefined ? themeOpt : "transparent";
    var onClick$1 = disabled ? undefined : onClick;
    var href$1 = disabled ? undefined : href;
    var className$1 = $1TRFX.make([
        className,
        disabled && hideOnDisable ? $ezf3v.prefix("opacity-0") : disabled ? $ezf3v.prefix("opacity-25") : $ezf3v.prefix("cursor-pointer"),
        $ezf3v.prefix("text-inherit text-sm flex-col no-underline relative flex items-center justify-center no-touch-highlight"),
        $ezf3v.prefix("w-12 h-12")
    ]);
    var adjustedStyle = {
        margin: pixelAdjustments
    };
    var tmp = {
        className: $ezf3v.prefix("top-px right-px")
    };
    if (badge !== undefined) tmp.text = badge;
    if (badgeDataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(badgeDataTestId);
    var badge$1 = /*#__PURE__*/ $g85JO.createElement($dzvJv.make, tmp);
    var bgColor = theme === "light" ? "bg-white" : theme === "transparent" ? "opacity-0" : "bg-black bg-opacity-50";
    var textColor = theme === "dark" ? "text-white" : "";
    var content = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute top-1/2 left-1/2 w-12 h-12 transform -translate-x-1/2 -translate-y-1/2 rounded-full",
            bgColor
        ]))
    }), /*#__PURE__*/ $g85JO.createElement($dtaxl.make, {
        kind: "navbar-item",
        className: $ezf3v.prefix($1TRFX.make([
            "flex-shrink-0 relative flex items-center justify-center w-12 h-12",
            textColor
        ])),
        style: adjustedStyle,
        children: null
    }, badge$1, children));
    var render;
    if (href$1 !== undefined) {
        var tmp$1 = {
            children: content,
            href: href$1,
            unstyled: true,
            className: className$1,
            openLinkInNewTab: openLinkInNewTab,
            dataDisabled: disabled
        };
        var tmp$2 = showLabel ? undefined : label;
        if (tmp$2 !== undefined) tmp$1.title = $loT9g.valFromOption(tmp$2);
        if (customStyle !== undefined) tmp$1.style = $loT9g.valFromOption(customStyle);
        if (dataTestId !== undefined) tmp$1.dataTestId = $loT9g.valFromOption(dataTestId);
        if (onClick$1 !== undefined) tmp$1.onClick = $loT9g.valFromOption(onClick$1);
        render = /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp$1);
    } else {
        var tmp$3 = {
            className: className$1,
            title: label
        };
        var tmp$4 = onClick$1 !== undefined ? "link" : undefined;
        if (tmp$4 !== undefined) tmp$3.role = $loT9g.valFromOption(tmp$4);
        var tmp$5 = onClick$1 !== undefined ? 0 : undefined;
        if (tmp$5 !== undefined) tmp$3.tabIndex = $loT9g.valFromOption(tmp$5);
        if (onClick$1 !== undefined) tmp$3.onClick = $loT9g.valFromOption(onClick$1);
        var tmp$6 = {
            dataDisabled: disabled,
            children: /*#__PURE__*/ $g85JO.createElement("div", tmp$3, content)
        };
        if (dataTestId !== undefined) tmp$6.dataTestId = $loT9g.valFromOption(dataTestId);
        render = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$6);
    }
    if (show) return render;
    else return null;
}
$9e52495f261a1f01$var$NavbarItem.displayName = "NavbarItem";
var $9e52495f261a1f01$export$dd44f18ab656f3bb = $9e52495f261a1f01$var$NavbarItem;
 /* react Not a pure module */ 
});
parcelRegister("dtaxl", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9ce6282d6c29bb17$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $5alaa = parcelRequire("5alaa");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $kQxJU = parcelRequire("kQxJU");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
var $9ce6282d6c29bb17$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(undefined);
var $9ce6282d6c29bb17$var$provider = $9ce6282d6c29bb17$export$a078c61943f9dbbe.Provider;
function $9ce6282d6c29bb17$var$EditorLayerItem$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($9ce6282d6c29bb17$var$provider, {
        value: value,
        children: children
    });
}
$9ce6282d6c29bb17$var$EditorLayerItem$Provider.displayName = "EditorLayerItem.Provider";
var $9ce6282d6c29bb17$export$2881499e37b75b9a = {
    provider: $9ce6282d6c29bb17$var$provider,
    make: $9ce6282d6c29bb17$var$EditorLayerItem$Provider
};
function $9ce6282d6c29bb17$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($9ce6282d6c29bb17$export$a078c61943f9dbbe);
}
function $9ce6282d6c29bb17$var$EditorLayerItem$Internal(Props) {
    var tabIndex = Props.tabIndex;
    var kind = Props.kind;
    var role = Props.role;
    var data = Props.data;
    var ariaLabel = Props.ariaLabel;
    var fwdRef = Props.fwdRef;
    var canInspectChildrenOpt = Props.canInspectChildren;
    var className = Props.className;
    var style = Props.style;
    var children = Props.children;
    var id = Props.id;
    var category = Props.category;
    var nodeId = Props.nodeId;
    var canInspectChildren = canInspectChildrenOpt !== undefined ? canInspectChildrenOpt : true;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $g85JO.useState(function() {
        return [];
    });
    var setChildrenIds = match$1[1];
    var childrenIds = match$1[0];
    var match$2 = $g85JO.useState(function() {
        return $2whNH.getWithDefault(id, $5alaa.random_int(10000, 99999).toString());
    });
    var id$1 = match$2[0];
    var parentCtx = $g85JO.useContext($9ce6282d6c29bb17$export$a078c61943f9dbbe);
    var theme = $g85JO.useMemo(function() {
        var path = category !== undefined ? $1xf0g.getCategoryPathById(config.categories, category.id) : [];
        var pathContainsConfigEmbed = $i7mYY.some(path, function(category) {
            var match = $1xf0g.ExternalConnection.getConnection(category);
            if (match !== undefined && !(typeof match === "number" || match.TAG !== /* ConfigEmbed */ 1)) return true;
            else return false;
        });
        if (pathContainsConfigEmbed) return "purple";
    }, [
        category
    ]);
    var theme$1 = $2whNH.getWithDefault($2whNH.orElse(theme, $2whNH.map(parentCtx, function(ctx) {
        return ctx.theme;
    })), "blue");
    var ownContextValue = $2whNH.map(kind, function(kind) {
        return {
            id: id$1,
            canInspect: canInspectChildren,
            kind: kind,
            theme: theme$1,
            childrenIds: childrenIds,
            setChildrenIds: setChildrenIds
        };
    });
    $g85JO.useEffect(function() {
        $2whNH.forEach(parentCtx, function(param) {
            $iv6Yc._1(param.setChildrenIds, function(ids) {
                return $i7mYY.concat(ids, [
                    id$1
                ]);
            });
        });
        return function(param) {
            $2whNH.forEach(parentCtx, function(param) {
                $iv6Yc._1(param.setChildrenIds, function(ids) {
                    return $i7mYY.keep(ids, function(id) {
                        return id !== id;
                    });
                });
            });
        };
    }, [
        id$1
    ]);
    var canInspect = $2whNH.mapWithDefault(parentCtx, true, function(contextValue) {
        return contextValue.canInspect;
    });
    return $2whNH.mapWithDefault($2whNH.keep(kind, function(param) {
        return canInspect;
    }), children, function(kind) {
        var tmp = {
            className: $1TRFX.make($i7mYY.keepMap([
                "sn-inspectable-widget",
                className
            ], function(a) {
                return a;
            })),
            id: id$1
        };
        if (fwdRef !== undefined) tmp.ref = $loT9g.valFromOption(fwdRef);
        if (ariaLabel !== undefined) tmp["aria-label"] = $loT9g.valFromOption(ariaLabel);
        if (role !== undefined) tmp.role = $loT9g.valFromOption(role);
        if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
        if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
        if (data !== undefined) tmp.data = $loT9g.valFromOption(data);
        return /*#__PURE__*/ $g85JO.createElement($9ce6282d6c29bb17$var$EditorLayerItem$Provider, {
            value: ownContextValue,
            children: /*#__PURE__*/ $g85JO.createElement($kQxJU.make, {
                props: {
                    "data-id": id$1,
                    "data-kind": kind,
                    "data-node-id": nodeId,
                    "data-parent-id": $2whNH.map(parentCtx, function(contextValue) {
                        return contextValue.id;
                    }),
                    "data-children-ids": childrenIds.join(","),
                    "data-siblings-ids": $2whNH.map(parentCtx, function(contextValue) {
                        return contextValue.childrenIds.join(",");
                    }),
                    "data-theme": theme$1
                },
                children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children)
            })
        });
    });
}
$9ce6282d6c29bb17$var$EditorLayerItem$Internal.displayName = "EditorLayerItem.Internal";
var $9ce6282d6c29bb17$export$81742925a72ee8f2 = {
    make: $9ce6282d6c29bb17$var$EditorLayerItem$Internal
};
function $9ce6282d6c29bb17$var$EditorLayerItem(Props) {
    var tabIndex = Props.tabIndex;
    var kind = Props.kind;
    var id = Props.id;
    var nodeId = Props.nodeId;
    var data = Props.data;
    var role = Props.role;
    var ariaLabel = Props.ariaLabel;
    var fwdRef = Props.fwdRef;
    var canInspectChildrenOpt = Props.canInspectChildren;
    var className = Props.className;
    var style = Props.style;
    var category = Props.category;
    var childrenOpt = Props.children;
    var canInspectChildren = canInspectChildrenOpt !== undefined ? canInspectChildrenOpt : true;
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    if (previewMode === 0) {
        var tmp = {
            canInspectChildren: canInspectChildren,
            children: children
        };
        if (tabIndex !== undefined) tmp.tabIndex = tabIndex;
        if (kind !== undefined) tmp.kind = $loT9g.valFromOption(kind);
        if (role !== undefined) tmp.role = $loT9g.valFromOption(role);
        var tmp$1 = $2whNH.orElse(data, id);
        if (tmp$1 !== undefined) tmp.data = $loT9g.valFromOption(tmp$1);
        if (ariaLabel !== undefined) tmp.ariaLabel = $loT9g.valFromOption(ariaLabel);
        if (fwdRef !== undefined) tmp.fwdRef = $loT9g.valFromOption(fwdRef);
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
        if (id !== undefined) tmp.id = $loT9g.valFromOption(id);
        if (category !== undefined) tmp.category = $loT9g.valFromOption(category);
        if (nodeId !== undefined) tmp.nodeId = $loT9g.valFromOption(nodeId);
        return /*#__PURE__*/ $g85JO.createElement($9ce6282d6c29bb17$var$EditorLayerItem$Internal, tmp);
    }
    var tmp$2 = {};
    if (fwdRef !== undefined) tmp$2.ref = $loT9g.valFromOption(fwdRef);
    if (ariaLabel !== undefined) tmp$2["aria-label"] = $loT9g.valFromOption(ariaLabel);
    if (className !== undefined) tmp$2.className = $loT9g.valFromOption(className);
    if (id !== undefined) tmp$2.id = $loT9g.valFromOption(id);
    if (role !== undefined) tmp$2.role = $loT9g.valFromOption(role);
    if (style !== undefined) tmp$2.style = $loT9g.valFromOption(style);
    if (tabIndex !== undefined) tmp$2.tabIndex = $loT9g.valFromOption(tabIndex);
    var tmp$3 = $2whNH.orElse(data, id);
    if (tmp$3 !== undefined) tmp$2.data = $loT9g.valFromOption(tmp$3);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp$2, children);
}
$9ce6282d6c29bb17$var$EditorLayerItem.displayName = "EditorLayerItem";
var $9ce6282d6c29bb17$export$dd44f18ab656f3bb = $9ce6282d6c29bb17$var$EditorLayerItem;
 /* context Not a pure module */ 
});


parcelRegister("aJ48X", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $7cf152242a5d0c3c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $7cf152242a5d0c3c$var$IconHeartFilled(Props) {
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        style: {
            height: "16px",
            width: "18px"
        },
        height: "16",
        width: "18",
        fill: "none",
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M15.75 8.46875L9.71875 14.7188C9.3125 15.125 8.65625 15.125 8.28125 14.7188L2.21875 8.46875C0.46875 6.65625 0.5625 3.65625 2.53125 1.96875C4.21875 0.5 6.8125 0.78125 8.375 2.375L9 3.03125L9.59375 2.375C11.1562 0.78125 13.7188 0.5 15.4688 1.96875C17.4062 3.65625 17.5 6.65625 15.75 8.46875Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M16.1232 1.56352C18.2243 3.3644 18.3243 6.56597 16.4567 8.50024L9.98691 15.1702C9.78681 15.3703 9.52001 15.4703 9.21986 15.4703C8.95307 15.4703 8.68627 15.3703 8.48617 15.1702L2.01635 8.50024C0.148771 6.56597 0.248819 3.3644 2.34984 1.56352C3.15024 0.863182 4.15072 0.529686 5.15121 0.529686C6.38515 0.529686 7.65243 1.06328 8.58622 1.99707L9.25321 2.69741L9.88686 1.99707C10.8206 1.06328 12.0879 0.529686 13.3219 0.529686C14.3224 0.529686 15.3228 0.863182 16.1232 1.56352ZM15.2895 7.39971C16.39 6.26582 16.6235 4.09809 15.0894 2.79746C13.7554 1.63022 11.9212 2.23052 11.0541 3.13096L9.25321 4.99853L7.41899 3.13096C6.5519 2.19717 4.71767 1.63022 3.38368 2.79746C1.8496 4.09809 2.1164 6.26582 3.18359 7.39971L9.25321 13.6361L15.2895 7.39971Z",
        fill: "currentColor"
    }));
}
$7cf152242a5d0c3c$var$IconHeartFilled.displayName = "IconHeartFilled";
var $7cf152242a5d0c3c$export$dd44f18ab656f3bb = $7cf152242a5d0c3c$var$IconHeartFilled;
 /* react Not a pure module */ 
});

parcelRegister("6Y4PS", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $512c18f8c680108c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $8L1B1 = parcelRequire("8L1B1");

var $fUtdg = parcelRequire("fUtdg");

var $5av24 = parcelRequire("5av24");

var $8zoQU = parcelRequire("8zoQU");
function $512c18f8c680108c$var$ProductListItem$ListItemButton(Props) {
    var className = Props.className;
    var children = Props.children;
    var blockOpt = Props.block;
    var style = Props.style;
    var hasTextOpt = Props.hasText;
    var enableActiveStateOpt = Props.enableActiveState;
    var onClickOpt = Props.onClick;
    var block = blockOpt !== undefined ? blockOpt : false;
    var hasText = hasTextOpt !== undefined ? hasTextOpt : false;
    var enableActiveState = enableActiveStateOpt !== undefined ? enableActiveStateOpt : true;
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(e) {};
    var display = block ? "block" : "inline-block";
    var display$1 = hasText ? display : $1TRFX.make([
        display,
        "leading-0"
    ]);
    var className$1 = $1TRFX.make([
        $ezf3v.prefix(display$1),
        $ezf3v.prefix("cursor-pointer select-none"),
        enableActiveState ? $ezf3v.prefix("dark-hover darker-active") : "",
        $2whNH.getWithDefault(className, "")
    ]);
    var tmp = {
        className: className$1,
        onClick: onClick
    };
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, children);
}
$512c18f8c680108c$var$ProductListItem$ListItemButton.displayName = "ProductListItem.ListItemButton";
var $512c18f8c680108c$export$b3f67a2d87d5d23e = {
    make: $512c18f8c680108c$var$ProductListItem$ListItemButton
};
function $512c18f8c680108c$var$ProductListItem(Props) {
    var isSelectedOpt = Props.isSelected;
    var product = Props.product;
    var variant = Props.variant;
    var productPriceStyle = Props.productPriceStyle;
    var shape = Props.shape;
    var imageFitStrategy = Props.imageFitStrategy;
    var titleLineClampOpt = Props.titleLineClamp;
    var flushedOpt = Props.flushed;
    var paddingOpt = Props.padding;
    var hideOutOfStockOpt = Props.hideOutOfStock;
    var heightOpt = Props.height;
    var imageSize = Props.imageSize;
    var onClick = Props.onClick;
    var classNameOpt = Props.className;
    var enableDataTestIdOpt = Props.enableDataTestId;
    var displayVariantByOpt = Props.displayVariantBy;
    var children = Props.children;
    var titleClassNameOpt = Props.titleClassName;
    var isSelected = isSelectedOpt !== undefined ? isSelectedOpt : false;
    var titleLineClamp = titleLineClampOpt !== undefined ? titleLineClampOpt : 3;
    var flushed = flushedOpt !== undefined ? flushedOpt : true;
    var padding = paddingOpt !== undefined ? paddingOpt : true;
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var height = heightOpt !== undefined ? heightOpt : "auto";
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var enableDataTestId = enableDataTestIdOpt !== undefined ? enableDataTestIdOpt : true;
    var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */ 0;
    var titleClassName = titleClassNameOpt !== undefined ? titleClassNameOpt : "";
    var store = $8L1B1.use(undefined);
    var variant$1 = $2whNH.getWithDefault(variant, $7KlbQ.getVariantBySelector(product, displayVariantBy));
    var aspectRatioCn = typeof shape === "number" ? shape !== 2 ? shape !== 3 ? imageSize !== undefined ? "" : "aspect-ratio-square" : imageSize !== undefined ? "" : "aspect-ratio-2/3" : imageSize !== undefined ? "" : "aspect-ratio-4/3" : imageSize !== undefined ? "" : "aspect-ratio-square";
    var containerGridCols = imageSize !== undefined ? undefined : shape === 3 ? "grid-cols-4" : "grid-cols-3";
    var detailsColSpan = imageSize !== undefined ? "" : shape === 3 ? "col-span-3" : "col-span-2";
    var imageStyle = imageSize !== undefined ? {
        height: $ezf3v.intToPx(imageSize[1]),
        width: $ezf3v.intToPx(imageSize[0])
    } : undefined;
    var reviewSummary = product.reviewSummary;
    var heightCn = height === "full" ? "h-full" : "";
    return $2whNH.mapWithDefault($7KlbQ.Media.getImage(variant$1.media), null, function(image) {
        var tmp = {
            className: $ezf3v.prefix($1TRFX.make([
                "inline-block relative flex-shrink-0 rounded-custom overflow-hidden self-center",
                "w-full h-0",
                "bg-placeholder",
                aspectRatioCn
            ]))
        };
        if (imageStyle !== undefined) tmp.style = $loT9g.valFromOption(imageStyle);
        var tmp$1 = {
            at: /* PLP */ 1,
            product: product,
            variant: variant$1
        };
        if (productPriceStyle !== undefined) tmp$1.style = $loT9g.valFromOption(productPriceStyle);
        var tmp$2 = {
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "flex-grow",
                    heightCn
                ])),
                onClick: function onClick1(param) {
                    $iv6Yc._2(onClick, product, variant$1);
                }
            }, /*#__PURE__*/ $g85JO.createElement($512c18f8c680108c$var$ProductListItem$ListItemButton, {
                className: $1TRFX.make([
                    $ezf3v.prefix("group-2"),
                    $2whNH.mapWithDefault(containerGridCols, $ezf3v.prefix("flex"), function(gridCols) {
                        return $ezf3v.prefix($1TRFX.make([
                            "grid",
                            gridCols
                        ]));
                    }),
                    $2whNH.mapWithDefault(containerGridCols, $ezf3v.prefix("space-x-4"), function(param) {
                        return $ezf3v.prefix("gap-4");
                    }),
                    $ezf3v.prefix("rounded-custom"),
                    $ezf3v.prefix("border-0.5 border-solid"),
                    isSelected ? $ezf3v.prefix("border-accent") : $ezf3v.prefix("border-transparent"),
                    flushed && padding ? $ezf3v.prefix("-mx-2.5") : "",
                    padding ? $ezf3v.prefix("p-2.5") : "",
                    $ezf3v.prefix(heightCn),
                    className
                ]),
                children: null,
                shadow: false,
                block: true,
                hasText: true,
                enableActiveState: false
            }, /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                src: image.url,
                fit: imageFitStrategy,
                alt: product.name,
                priority: 0
            })), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    detailsColSpan,
                    "inline-flex flex-col self-center space-y-2"
                ]))
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "text-secondary text-lg",
                    titleClassName
                ]))
            }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
                lines: titleLineClamp,
                dataTestId: "product-listitem-title",
                children: $7KlbQ.getDisplayName(store, variant$1, product)
            })), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex hide-on-empty")
            }, /*#__PURE__*/ $g85JO.createElement($8zoQU.Minimal.make, {
                hideOutOfStock: hideOutOfStock,
                product: product,
                mainImage: image.url
            }), reviewSummary !== undefined ? /*#__PURE__*/ $g85JO.createElement($fUtdg.Summary.make, {
                at: /* PLP */ 1,
                summary: reviewSummary
            }) : null), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("truncate mt-1")
            }, /*#__PURE__*/ $g85JO.createElement($8lNXy.make, tmp$1)), $2whNH.getWithDefault(children, null))))
        };
        var tmp$3 = enableDataTestId ? "product-listitem-test-id" : undefined;
        if (tmp$3 !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(tmp$3);
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$2);
    });
}
$512c18f8c680108c$var$ProductListItem.displayName = "ProductListItem";
var $512c18f8c680108c$export$dd44f18ab656f3bb = $512c18f8c680108c$var$ProductListItem;
 /* react Not a pure module */ 
});
parcelRegister("8lNXy", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $614709d34118cedf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $58Tj9 = parcelRequire("58Tj9");

var $3qnJm = parcelRequire("3qnJm");

var $7KlbQ = parcelRequire("7KlbQ");

var $gwEzd = parcelRequire("gwEzd");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $cTjaa = parcelRequire("cTjaa");

var $k0ukS = parcelRequire("k0ukS");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");

var $1nuZE = parcelRequire("1nuZE");
function $614709d34118cedf$var$ProductPrice$DiscountedPercentage(Props) {
    var classNameOpt = Props.className;
    var sizeOpt = Props.size;
    var parsedPrice = Props.parsedPrice;
    var parsedCompareAtPrice = Props.parsedCompareAtPrice;
    var containerRef = Props.containerRef;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var size = sizeOpt !== undefined ? sizeOpt : /* Base */ 0;
    var containerBoundsWidth = $2whNH.mapWithDefault($cTjaa.useResizeObserver(undefined, containerRef), 99999, function(size) {
        return size.width;
    });
    var discountedPercentage;
    if (parsedPrice !== undefined && parsedCompareAtPrice !== undefined) {
        var actualCompareAtPrice = Math.max(parsedPrice.value, parsedCompareAtPrice.value);
        var actualPrice = Math.min(parsedPrice.value, parsedCompareAtPrice.value);
        var savings = actualPrice - actualCompareAtPrice;
        discountedPercentage = Math.round(savings / Math.max(actualCompareAtPrice, 1.0) * 100);
    } else discountedPercentage = undefined;
    var format = function format(percentage) {
        if (size) return "SAVE " + Math.abs(percentage).toString() + "%";
        else return "" + percentage.toString() + "%";
    };
    var willShowDiscountPercentage = containerBoundsWidth > 100;
    if (discountedPercentage !== undefined && discountedPercentage < 0.0 && willShowDiscountPercentage) return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-hidden": true,
        className: $1TRFX.make([
            $k0ukS.toString("product-card__discount-badge"),
            size ? $ezf3v.prefix("inline-block px-2 py-1 border border-product-discount-main text-product-discount-main text-lg") : $ezf3v.prefix("inline px-1 py-0.5 bg-product-discount-main text-product-discount-label rounded-custom text-base"),
            className
        ])
    }, format(discountedPercentage));
    else return null;
}
$614709d34118cedf$var$ProductPrice$DiscountedPercentage.displayName = "ProductPrice.DiscountedPercentage";
var $614709d34118cedf$export$e07837d483632189 = {
    make: $614709d34118cedf$var$ProductPrice$DiscountedPercentage
};
function $614709d34118cedf$var$ProductPrice$Labels(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var at = Props.at;
    var kind = Props.kind;
    var alignOpt = Props.align;
    var className = Props.className;
    var align = alignOpt !== undefined ? alignOpt : /* Right */ 1;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var pdpConfig = $1nuZE.use(undefined);
    var labels = $i7mYY.keepMap($i7mYY.map($i7mYY.keep($i7mYY.keep(pdpConfig.priceLabels, function(label) {
        if (label.showAs === /* Suffix */ 1 && kind === /* Suffix */ 1) return true;
        else if (label.showAs === /* Prefix */ 0) return kind === /* Prefix */ 0;
        else return false;
    }), function(suffix) {
        if (suffix.visibleInProductCard) return true;
        else return at === /* PDP */ 0;
    }), function(suffix) {
        return $fOz3p.Content.renderContent(undefined, className, product, variant, config, suffix.content);
    }), function(a) {
        return a;
    });
    var textAlignCn = align ? "text-right" : "text-left";
    if (labels.length !== 0) return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix(textAlignCn)
    }, $i7mYY.mapWithIndex(labels, function(i, label) {
        if (kind) return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-product-price-suffix",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "font-normal",
                    "leading-normal",
                    "text-secondary",
                    textAlignCn
                ]))
            }, label),
            key: String(i)
        });
        else return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-product-price-prefix",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "font-normal",
                    "leading-normal",
                    "text-secondary",
                    textAlignCn
                ]))
            }, label),
            key: String(i)
        });
    }));
    else return null;
}
$614709d34118cedf$var$ProductPrice$Labels.displayName = "ProductPrice.Labels";
var $614709d34118cedf$export$c9ed62821215deda = {
    make: $614709d34118cedf$var$ProductPrice$Labels
};
function $614709d34118cedf$export$2060d2db72cce88f(multiplier, currency) {
    return {
        value: currency.value * multiplier,
        currency: currency.currency,
        symbol: currency.symbol
    };
}
function $614709d34118cedf$export$ae87ccff59aa574(multiplier, hideOutOfStock, product) {
    var allVariantPrices = $i7mYY.map($i7mYY.keep($7KlbQ.getAllVariants(product), function(variant) {
        if (variant.availability !== /* OutOfStock */ 0) return true;
        else return !hideOutOfStock;
    }), function(variant) {
        return variant.price;
    });
    var formatRange = function formatRange(prices) {
        var prices$1 = $i7mYY.map($58Tj9.stableSortBy($i7mYY.map($i7mYY.keepMap($i7mYY.map(prices, $gwEzd.parse), function(parsed) {
            return parsed;
        }), function(param) {
            return $614709d34118cedf$export$2060d2db72cce88f(multiplier, param);
        }), function(a, b) {
            if (a.value > b.value) return -1;
            else if (a.value === b.value) return 0;
            else return 1;
        }), $gwEzd.format);
        var largestPrice = $i7mYY.get(prices$1, 0);
        var lowestPrice = $i7mYY.get(prices$1, prices$1.length - 1 | 0);
        if (largestPrice !== undefined && lowestPrice !== undefined && largestPrice !== lowestPrice) return "" + lowestPrice + "-" + largestPrice + "";
    };
    var rangePrice = formatRange($i7mYY.keepMap(allVariantPrices, function(price) {
        if (typeof price === "number") return;
        else if (price.TAG === /* Regular */ 0) return price._0;
        else return price._0.price;
    }));
    var rangeCompareAtPrice = formatRange($i7mYY.keepMap(allVariantPrices, function(price) {
        if (typeof price === "number" || price.TAG === /* Regular */ 0) return;
        else return price._0.regularPrice;
    }));
    return [
        rangePrice,
        rangeCompareAtPrice
    ];
}
function $614709d34118cedf$export$a6dacf08e16ce434(multiplierOpt, hideOutOfStock, product, variant, style) {
    var multiplier = multiplierOpt !== undefined ? multiplierOpt : 1;
    var match = $7KlbQ.Variant.getVariantPrices(variant);
    var compareAtPrice = match[0];
    var price = $2whNH.getWithDefault(match[1], compareAtPrice);
    var match$1 = $614709d34118cedf$export$ae87ccff59aa574(multiplier, hideOutOfStock, product);
    var rangePrice = match$1[0];
    var style$1 = style && rangePrice === undefined ? /* Default */ 0 : style;
    if (style$1) return [
        {
            TAG: /* String */ 1,
            _0: rangePrice
        },
        {
            TAG: /* String */ 1,
            _0: match$1[1]
        }
    ];
    else return [
        {
            TAG: /* Parsed */ 0,
            _0: $2whNH.map($gwEzd.parse(price), function(param) {
                return $614709d34118cedf$export$2060d2db72cce88f(multiplier, param);
            })
        },
        {
            TAG: /* Parsed */ 0,
            _0: $2whNH.map($gwEzd.parse(compareAtPrice), function(param) {
                return $614709d34118cedf$export$2060d2db72cce88f(multiplier, param);
            })
        }
    ];
}
function $614709d34118cedf$export$f8c4200a2f7a8e6c(price, compareAtPrice) {
    if (price.TAG === /* Parsed */ 0) {
        var price$1 = price._0;
        if (price$1 === undefined) return;
        if (compareAtPrice.TAG !== /* Parsed */ 0) return;
        var compareAtPrice$1 = compareAtPrice._0;
        if (compareAtPrice$1 !== undefined) return "current price: " + $gwEzd.format(price$1) + ", original price: " + $gwEzd.format(compareAtPrice$1) + "";
        else return "current price: " + $gwEzd.format(price$1) + "";
    }
    var price$2 = price._0;
    if (price$2 === undefined) return;
    if (compareAtPrice.TAG === /* Parsed */ 0) return;
    var compareAtPrice$2 = compareAtPrice._0;
    if (compareAtPrice$2 !== undefined) return "current price: " + price$2 + ", original price: " + compareAtPrice$2 + "";
    else return "current price: " + price$2 + "";
}
function $614709d34118cedf$var$ProductPrice(Props) {
    var at = Props.at;
    var product = Props.product;
    var variant = Props.variant;
    var sizeOpt = Props.size;
    var style = Props.style;
    var priceBlockStylableClassName = Props.priceBlockStylableClassName;
    var priceStylableClassName = Props.priceStylableClassName;
    var salePriceStylableClassName = Props.salePriceStylableClassName;
    var alignOpt = Props.align;
    var marginTopOpt = Props.marginTop;
    var showMaxPriceOpt = Props.showMaxPrice;
    var labelsEnabledOpt = Props.labelsEnabled;
    var showDiscountedPercentageOpt = Props.showDiscountedPercentage;
    var minPriceFirstOpt = Props.minPriceFirst;
    var multilineOpt = Props.multiline;
    var textColor = Props.textColor;
    var boldOpt = Props.bold;
    var multiplierOpt = Props.multiplier;
    var size = sizeOpt !== undefined ? sizeOpt : /* Md */ 1;
    var align = alignOpt !== undefined ? alignOpt : /* Left */ 0;
    var marginTop = marginTopOpt !== undefined ? marginTopOpt : true;
    var showMaxPrice = showMaxPriceOpt !== undefined ? showMaxPriceOpt : true;
    var labelsEnabled = labelsEnabledOpt !== undefined ? labelsEnabledOpt : true;
    var showDiscountedPercentage = showDiscountedPercentageOpt !== undefined ? showDiscountedPercentageOpt : true;
    var minPriceFirst = minPriceFirstOpt !== undefined ? minPriceFirstOpt : true;
    var multiline = multilineOpt !== undefined ? multilineOpt : false;
    var bold = boldOpt !== undefined ? boldOpt : true;
    var multiplier = multiplierOpt !== undefined ? multiplierOpt : 1;
    var match = $3qnJm.use(undefined);
    var pendingFields = match.pendingFields;
    var formProduct = match.product;
    var match$1 = $8E2YL.use(undefined);
    var pendingFieldsNum = $2whNH.mapWithDefault(pendingFields, 0, function(prim) {
        return prim.length;
    });
    var ref = $g85JO.useRef(null);
    var style$1 = $2whNH.getWithDefault($2whNH.keep($2whNH.map($8E2YL.use(undefined).config.transitiveAccount, function(account) {
        return account.productPriceStyle;
    }), function(style) {
        if (style && pendingFieldsNum <= 0) return $7bjme.notequal(product.id, $2whNH.map(formProduct, function(product) {
            return product.id;
        }));
        else return true;
    }), /* Default */ 0);
    var style$2 = style !== undefined && pendingFields === undefined ? style : style$1;
    var match$2 = $614709d34118cedf$export$a6dacf08e16ce434(multiplier, match$1.config.settings.hideOutOfStock, product, variant, style$2);
    var displayCompareAtPrice = match$2[1];
    var displayPrice = match$2[0];
    var priceStr;
    priceStr = displayPrice.TAG === /* Parsed */ 0 ? $2whNH.mapWithDefault(displayPrice._0, "", $gwEzd.format) : $2whNH.getWithDefault(displayPrice._0, "");
    var compareAtPriceStr;
    compareAtPriceStr = displayCompareAtPrice.TAG === /* Parsed */ 0 ? $2whNH.mapWithDefault(displayCompareAtPrice._0, "", $gwEzd.format) : $2whNH.getWithDefault(displayCompareAtPrice._0, "");
    var sizeClassName1;
    switch(size){
        case /* Xl */ 0:
            sizeClassName1 = "text-2xl";
            break;
        case /* Md */ 1:
            sizeClassName1 = "text-xl";
            break;
        case /* Sm */ 2:
            sizeClassName1 = "text-lg";
            break;
    }
    var sizeClassName2;
    switch(size){
        case /* Xl */ 0:
            sizeClassName2 = "text-lg";
            break;
        case /* Md */ 1:
        case /* Sm */ 2:
            sizeClassName2 = "text-base";
            break;
    }
    var selfAlignCn = align ? "self-end" : "self-start";
    var renderPrice = function renderPrice(param) {
        var tmp = {
            children: priceStr
        };
        if (priceStylableClassName !== undefined) tmp.className = $loT9g.valFromOption(priceStylableClassName);
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-product-price",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    bold ? "font-semibold" : "",
                    "inline-flex space-x-2",
                    selfAlignCn,
                    sizeClassName1,
                    $2whNH.getWithDefault(textColor, "text-primary")
                ]))
            }, labelsEnabled ? /*#__PURE__*/ $g85JO.createElement($614709d34118cedf$var$ProductPrice$Labels, {
                product: product,
                variant: variant,
                at: at,
                kind: /* Prefix */ 0,
                align: align,
                className: $ezf3v.prefix(sizeClassName1)
            }) : null, /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-hidden": true
            }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, tmp)))
        });
    };
    var renderCompareAtPrice = function renderCompareAtPrice(param) {
        var tmp = {
            children: compareAtPriceStr
        };
        if (salePriceStylableClassName !== undefined) tmp.className = $loT9g.valFromOption(salePriceStylableClassName);
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-product-sale-price",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-hidden": true,
                className: $ezf3v.prefix($1TRFX.make([
                    "inline-block line-through",
                    bold ? "font-medium" : "",
                    sizeClassName2,
                    $2whNH.getWithDefault(textColor, "text-tertiary")
                ]))
            }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, tmp))
        });
    };
    var discountedPercentage;
    discountedPercentage = displayPrice.TAG === /* Parsed */ 0 && displayCompareAtPrice.TAG === /* Parsed */ 0 && showDiscountedPercentage ? /*#__PURE__*/ $g85JO.createElement($614709d34118cedf$var$ProductPrice$DiscountedPercentage, {
        className: $ezf3v.prefix(sizeClassName2),
        parsedPrice: displayPrice._0,
        parsedCompareAtPrice: displayCompareAtPrice._0,
        containerRef: ref
    }) : null;
    var firstRow = showMaxPrice && priceStr !== compareAtPriceStr ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "inline-flex text-left justify-end flex-wrap",
            multiline && align === /* Left */ 0 ? "items-start" : "items-end",
            multiline ? minPriceFirst ? "flex-col-reverse space-y-reverse" : "flex-col" : minPriceFirst ? "flex-row-reverse space-x-reverse" : "flex-row",
            multiline ? "space-y-2" : "space-x-2"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex items-center justify-center space-x-2")
    }, renderCompareAtPrice(undefined), discountedPercentage), renderPrice(undefined)) : renderPrice(undefined);
    var tmp = {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix($1TRFX.make([
            "flex flex-col space-y-2",
            marginTop ? "mt-2" : ""
        ]))
    };
    var tmp$1 = $614709d34118cedf$export$f8c4200a2f7a8e6c(displayPrice, displayCompareAtPrice);
    if (tmp$1 !== undefined) tmp["aria-label"] = $loT9g.valFromOption(tmp$1);
    var tmp$2 = {
        children: firstRow
    };
    if (priceBlockStylableClassName !== undefined) tmp$2.className = $loT9g.valFromOption(priceBlockStylableClassName);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, tmp$2), labelsEnabled ? /*#__PURE__*/ $g85JO.createElement($614709d34118cedf$var$ProductPrice$Labels, {
        product: product,
        variant: variant,
        at: at,
        kind: /* Suffix */ 1,
        align: align,
        className: $ezf3v.prefix(sizeClassName2)
    }) : null);
}
$614709d34118cedf$var$ProductPrice.displayName = "ProductPrice";
var $614709d34118cedf$export$dd44f18ab656f3bb = $614709d34118cedf$var$ProductPrice;
 /* react Not a pure module */ 
});
parcelRegister("k0ukS", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $e90b56c86c02578d$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "make", function () { return $e90b56c86c02578d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $iCVlB = parcelRequire("iCVlB");
function $e90b56c86c02578d$export$f84e8e69fd4488a5(cn) {
    return "maker-nav maker-nav--" + cn;
}
function $e90b56c86c02578d$var$StylableElement(Props) {
    var className = Props.className;
    var children = Props.children;
    var experimentalStylingEnabled = $iCVlB.useIsBombay(undefined);
    if (className !== undefined && experimentalStylingEnabled) return /*#__PURE__*/ $g85JO.createElement("span", {
        className: "maker-nav maker-nav--" + className
    }, children);
    else return children;
}
$e90b56c86c02578d$var$StylableElement.displayName = "StylableElement";
var $e90b56c86c02578d$export$dd44f18ab656f3bb = $e90b56c86c02578d$var$StylableElement;
 /* react Not a pure module */ 
});

parcelRegister("fOz3p", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $b836b78ab04d6613$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "empty", function () { return $b836b78ab04d6613$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "makeDefault", function () { return $b836b78ab04d6613$export$2dc08c6664577951; });
$parcel$export(module.exports, "isVisible", function () { return $b836b78ab04d6613$export$795910f5f15a9633; });
$parcel$export(module.exports, "filterInvisibleSections", function () { return $b836b78ab04d6613$export$490728da142deb1f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $gwEzd = parcelRequire("gwEzd");

var $dI6Jg = parcelRequire("dI6Jg");

var $jAQD1 = parcelRequire("jAQD1");

var $dzlIC = parcelRequire("dzlIC");

var $5CE1l = parcelRequire("5CE1l");

var $hQWQG = parcelRequire("hQWQG");

var $gZfyt = parcelRequire("gZfyt");
var $b836b78ab04d6613$var$DynamicSource = {};
var $b836b78ab04d6613$var$$$Image = {};
var $b836b78ab04d6613$var$Table = {};
function $b836b78ab04d6613$var$getId(t) {
    return t._0.id;
}
function $b836b78ab04d6613$var$getDynamicSource(t) {
    if (t.TAG === /* DynamicSource */ 0) return t._0.source;
}
function $b836b78ab04d6613$var$getImageSource(t) {
    if (t.TAG === /* Image */ 2) return t._0.source;
}
function $b836b78ab04d6613$var$getImageAltTextSource(t) {
    if (t.TAG === /* Image */ 2) return t._0.altText;
}
function $b836b78ab04d6613$var$renderText(isRichText, isPreWrapped, className, style, product, variant, string) {
    if (isRichText) return /*#__PURE__*/ $g85JO.createElement($gZfyt.make, {
        tag: /* P */ 1,
        style: style,
        className: $1TRFX.make([
            $ezf3v.prefix("m-0 select-text"),
            isPreWrapped ? $ezf3v.prefix("whitespace-pre-wrap") : "",
            className
        ]),
        children: string.replace(/\\\r/g, "\r").replace(/\\\n/g, "\n").replace(/\\\t/g, "	").replace(/\$\{product\.id\}/g, product.id).replace(/\$\{variant\.id\}/g, $2whNH.mapWithDefault(variant, "", function(variant) {
            return variant.id;
        })),
        key: $7KlbQ.getKey(variant, product)
    });
    else return /*#__PURE__*/ $g85JO.createElement("p", {
        key: $7KlbQ.getKey(variant, product),
        className: $1TRFX.make([
            $ezf3v.prefix("select-text"),
            isPreWrapped ? $ezf3v.prefix("whitespace-pre-wrap") : "",
            className
        ]),
        style: style
    }, string);
}
function $b836b78ab04d6613$var$renderTextList(isRichText, isPreWrapped, className, style, product, variant, list) {
    return /*#__PURE__*/ $g85JO.createElement("p", undefined, /*#__PURE__*/ $g85JO.createElement("ul", undefined, $i7mYY.mapWithIndex(list, function(i, text) {
        return /*#__PURE__*/ $g85JO.createElement("li", {
            key: String(i)
        }, $b836b78ab04d6613$var$renderText(isRichText, isPreWrapped, className, style, product, variant, text));
    })));
}
function $b836b78ab04d6613$var$resolveMetaData(field, product, variant) {
    var variant$1 = $2whNH.getWithDefault(variant, product.firstVariant);
    return $2whNH.flatMap($7KlbQ.Metadata.getMetadataValue(product, variant$1, field), function(metadata) {
        var exit = 0;
        if (typeof metadata === "number") return;
        switch(metadata.TAG | 0){
            case /* DecimalField */ 2:
                var arg = metadata._0.toString();
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* IntegerField */ 3:
                var arg$1 = metadata._0.toString();
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$1);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* Boolean */ 8:
                var arg$2 = $2Ng4w.string_of_bool(metadata._0);
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$2);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* Json */ 9:
                var arg$3 = JSON.stringify(metadata._0);
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$3);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* Money */ 10:
                var money = metadata._0;
                var arg$4 = $2whNH.mapWithDefault($gwEzd.parse(money.currencyCode + money.amount), "", $gwEzd.format);
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$4);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* Dimension */ 4:
            case /* Volume */ 11:
            case /* Weight */ 12:
                exit = 2;
                break;
            case /* MultiLineTextField */ 0:
            case /* SingleLineTextField */ 1:
            case /* Date */ 5:
            case /* DateTime */ 6:
            case /* Color */ 7:
            case /* Url */ 13:
            case /* Rating */ 14:
                exit = 1;
                break;
            case /* FileReference */ 15:
                var fileType = metadata._0;
                var arg$5;
                arg$5 = fileType.TAG === /* TypeImage */ 0 ? fileType._0.url : $2whNH.getWithDefault(fileType._0.poster, "");
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$5);
                                    };
                                };
                            };
                        };
                    };
                };
            case /* Audio */ 16:
                var match = metadata._0;
                var thumbnailUrl = match.thumbnailUrl;
                var contentUrl = match.contentUrl;
                var name = match.name;
                return function(isRichText, isPreWrapped, className, style, product, variant) {
                    return /*#__PURE__*/ $g85JO.createElement($dI6Jg.make, {
                        contentUrl: contentUrl,
                        thumbnailUrl: thumbnailUrl,
                        name: name
                    });
                };
            case /* ListColor */ 17:
            case /* ListSingleLineTextField */ 21:
            case /* ListUrl */ 22:
                exit = 3;
                break;
            default:
                return;
        }
        switch(exit){
            case 1:
                var string = metadata._0;
                if (!$7KlbQ.Metadata.isEmpty(string)) return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, string);
                                    };
                                };
                            };
                        };
                    };
                };
                else return;
            case 2:
                var physicalQuantity = metadata._0;
                var arg$6 = physicalQuantity.value.toString() + " " + physicalQuantity.unitName;
                return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, arg$6);
                                    };
                                };
                            };
                        };
                    };
                };
            case 3:
                var list = metadata._0;
                if (!$7KlbQ.Metadata.isEmptyList(list)) return function(param) {
                    return function(param$1) {
                        var func = function func(param$2, param$3, param$4, param$5, param$6) {
                            return $b836b78ab04d6613$var$renderTextList(param, param$1, param$2, param$3, param$4, param$5, param$6);
                        };
                        return function(param) {
                            var func$1 = $iv6Yc._1(func, param);
                            return function(param) {
                                var func$2 = $iv6Yc._1(func$1, param);
                                return function(param) {
                                    var func$3 = $iv6Yc._1(func$2, param);
                                    return function(param) {
                                        return $iv6Yc._2(func$3, param, list);
                                    };
                                };
                            };
                        };
                    };
                };
                else return;
        }
    });
}
function $b836b78ab04d6613$var$resolveProductData(dataType, product, variant) {
    var result;
    switch(dataType){
        case /* ProductTitle */ 0:
            result = product.name;
            break;
        case /* ProductDescription */ 1:
            result = $2whNH.orElse($2whNH.flatMap(variant, function(v) {
                return v.description;
            }), product.description);
            break;
        case /* ProductPrice */ 2:
            result = $2whNH.map(variant, function(variant) {
                return $7KlbQ.Variant.getVariantPrices(variant)[0];
            });
            break;
        case /* ProductSalePrice */ 3:
            result = $2whNH.flatMap(variant, function(variant) {
                return $7KlbQ.Variant.getVariantPrices(variant)[1];
            });
            break;
        case /* ProductSKU */ 4:
            result = $2whNH.flatMap(variant, function(variant) {
                return variant.sku;
            });
            break;
        case /* ProductId */ 5:
            result = product.id;
            break;
        case /* VariantId */ 6:
            result = $2whNH.map(variant, function(v) {
                return v.id;
            });
            break;
    }
    return $2whNH.map($2whNH.keep(result, function(string) {
        return !$7KlbQ.Metadata.isEmpty(string);
    }), function(string) {
        return function(param) {
            return function(param$1) {
                var func = function func(param$2, param$3, param$4, param$5, param$6) {
                    return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                };
                return function(param) {
                    var func$1 = $iv6Yc._1(func, param);
                    return function(param) {
                        var func$2 = $iv6Yc._1(func$1, param);
                        return function(param) {
                            var func$3 = $iv6Yc._1(func$2, param);
                            return function(param) {
                                return $iv6Yc._2(func$3, param, string);
                            };
                        };
                    };
                };
            };
        };
    });
}
function $b836b78ab04d6613$var$getCustomLabelText(index, variant) {
    return $2whNH.flatMap(variant, function(variant) {
        return $i7mYY.get(variant.customLabels, index);
    });
}
function $b836b78ab04d6613$var$resolveCustomLabel(index, variant) {
    return $2whNH.map($2whNH.keep($2whNH.flatMap(variant, function(variant) {
        return $i7mYY.get(variant.customLabels, index);
    }), function(string) {
        return !$7KlbQ.Metadata.isEmpty(string);
    }), function(string) {
        return function(param) {
            return function(param$1) {
                var func = function func(param$2, param$3, param$4, param$5, param$6) {
                    return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                };
                return function(param) {
                    var func$1 = $iv6Yc._1(func, param);
                    return function(param) {
                        var func$2 = $iv6Yc._1(func$1, param);
                        return function(param) {
                            var func$3 = $iv6Yc._1(func$2, param);
                            return function(param) {
                                return $iv6Yc._2(func$3, param, string);
                            };
                        };
                    };
                };
            };
        };
    });
}
function $b836b78ab04d6613$var$resolveAvailability(availabilityContent, product, variant) {
    var outOfStockText = availabilityContent.outOfStockText;
    var inStockText = availabilityContent.inStockText;
    return $2whNH.map($2whNH.mapWithDefault(variant, $7KlbQ.isOutOfStock(product) ? outOfStockText : inStockText, function(variant) {
        var match = variant.availability;
        if (match) return inStockText;
        else return outOfStockText;
    }), function(string) {
        return function(param) {
            return function(param$1) {
                var func = function func(param$2, param$3, param$4, param$5, param$6) {
                    return $b836b78ab04d6613$var$renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
                };
                return function(param) {
                    var func$1 = $iv6Yc._1(func, param);
                    return function(param) {
                        var func$2 = $iv6Yc._1(func$1, param);
                        return function(param) {
                            var func$3 = $iv6Yc._1(func$2, param);
                            return function(param) {
                                return $iv6Yc._2(func$3, param, string);
                            };
                        };
                    };
                };
            };
        };
    });
}
function $b836b78ab04d6613$var$renderImage(src, alt) {
    if (src === undefined) return;
    var tmp = {
        className: $ezf3v.prefix("w-full"),
        src: src
    };
    if (alt !== undefined) tmp.alt = $loT9g.valFromOption(alt);
    return $loT9g.some(/*#__PURE__*/ $g85JO.createElement("img", tmp));
}
function $b836b78ab04d6613$var$renderContentFragment(id, element) {
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, {
        children: element,
        key: $iv6Yc._1($hQWQG.ContentId.toString, id)
    });
}
function $b836b78ab04d6613$var$renderEnhance(product, elementId, config) {
    return /*#__PURE__*/ $g85JO.createElement($jAQD1.make, {
        config: config,
        elementId: elementId,
        product: product
    });
}
function $b836b78ab04d6613$var$renderDynamicSource(style, classNameOpt, product, variant, data) {
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var field = data.source;
    var renderer;
    switch(field.TAG | 0){
        case /* ProductData */ 0:
            renderer = $b836b78ab04d6613$var$resolveProductData(field._0, product, variant);
            break;
        case /* MetaData */ 1:
            renderer = $b836b78ab04d6613$var$resolveMetaData(field._0, product, variant);
            break;
        case /* CustomLabel */ 2:
            renderer = $b836b78ab04d6613$var$resolveCustomLabel(field._0, variant);
            break;
        case /* Availability */ 3:
            renderer = $b836b78ab04d6613$var$resolveAvailability(field._0, product, variant);
            break;
    }
    return $2whNH.map($2whNH.map(renderer, function(fn) {
        return $iv6Yc._6(fn, data.isRichText, data.isPreWrapped, className, style, product, variant);
    }), function(element) {
        return $b836b78ab04d6613$var$renderContentFragment(data.id, element);
    });
}
function $b836b78ab04d6613$var$renderTable(classNameOpt, product, variant, style, rows) {
    var renderCellContent = function renderCellContent(cellContent) {
        if (cellContent.TAG === /* DynamicSource */ 0) return $b836b78ab04d6613$var$renderDynamicSource({}, undefined, product, variant, cellContent._0);
        var match = cellContent._0;
        return $loT9g.some($b836b78ab04d6613$var$renderContentFragment(match.id, $b836b78ab04d6613$var$renderText(match.isRichText, match.isPreWrapped, "", {}, product, variant, match.text)));
    };
    var renderRow = function renderRow(i, columns) {
        var columnContent = $i7mYY.map(columns, renderCellContent);
        var everyText = $i7mYY.every(columns, function(_type) {
            if (_type.TAG === /* DynamicSource */ 0) return false;
            else return true;
        });
        var someResolvedDynamicSource = $i7mYY.some2(columnContent, columns, function(content, _type) {
            if (_type.TAG === /* DynamicSource */ 0) return $2whNH.isSome(content);
            else return false;
        });
        var willRender = everyText || someResolvedDynamicSource;
        if (willRender) return $loT9g.some(style >= 2 ? /*#__PURE__*/ $g85JO.createElement("div", {
            key: String(i)
        }, $i7mYY.mapWithIndex($i7mYY.keepMap(columnContent, function(a) {
            return a;
        }), function(j, cell) {
            return /*#__PURE__*/ $g85JO.createElement("span", {
                key: String(i) + "-" + String(j),
                className: $ezf3v.prefix("inline-block mr-2")
            }, cell);
        })) : /*#__PURE__*/ $g85JO.createElement("tr", {
            key: String(i)
        }, $i7mYY.mapWithIndex($i7mYY.keepMap(columnContent, function(a) {
            if (style !== 1) return $loT9g.some($2whNH.getWithDefault(a, "-"));
            else return a;
        }), function(j, cell) {
            return /*#__PURE__*/ $g85JO.createElement("td", {
                key: String(i) + "-" + String(j),
                className: $ezf3v.prefix($1TRFX.make([
                    "p-4 border-collapse",
                    style !== 0 ? "" : "border border-tertiary"
                ]))
            }, cell);
        })));
    };
    var rows$1 = $i7mYY.keepMap($i7mYY.mapWithIndex(rows, renderRow), function(a) {
        return a;
    });
    if (rows$1.length !== 0) return $loT9g.some(/*#__PURE__*/ $g85JO.createElement("table", {
        className: $ezf3v.prefix($1TRFX.make([
            "w-full table-fixed border-collapse",
            style !== 0 ? "block" : "border border-tertiary"
        ]))
    }, style !== 1 ? rows$1 : /*#__PURE__*/ $g85JO.createElement("tbody", {
        className: $ezf3v.prefix("block overflow-auto px-6")
    }, rows$1)));
}
function $b836b78ab04d6613$var$renderJavaScript(id, product, variant, code) {
    var match = code.trim();
    if (match === "") return;
    else return $2whNH.map($2whNH.keep($dzlIC.triggerCustomFunctionReturningString(code, product, variant, "PDP content", undefined, undefined), function(string) {
        return string.trim() !== "";
    }), function(string) {
        return $b836b78ab04d6613$var$renderText(true, false, "", {}, product, variant, string);
    });
}
function $b836b78ab04d6613$var$renderContent(styleOpt, classNameOpt, product, variant, config, content) {
    var style = styleOpt !== undefined ? $loT9g.valFromOption(styleOpt) : {};
    var className = classNameOpt !== undefined ? classNameOpt : "";
    switch(content.TAG | 0){
        case /* DynamicSource */ 0:
            return $b836b78ab04d6613$var$renderDynamicSource(style, className, product, variant, content._0);
        case /* Text */ 1:
            var match = content._0;
            return $loT9g.some($b836b78ab04d6613$var$renderContentFragment(match.id, $b836b78ab04d6613$var$renderText(match.isRichText, match.isPreWrapped, className, style, product, variant, match.text)));
        case /* Image */ 2:
            var image = content._0;
            var field = image.source;
            var src;
            switch(field.TAG | 0){
                case /* URL */ 0:
                    src = field._0;
                    break;
                case /* MetaData */ 1:
                    src = $7KlbQ.Metadata.getMetadataAsText(product, $2whNH.getWithDefault(variant, product.firstVariant), field._0);
                    break;
                case /* CustomLabel */ 2:
                    src = $b836b78ab04d6613$var$getCustomLabelText(field._0, variant);
                    break;
            }
            var match$1 = image.altText;
            var altText;
            if (match$1 !== undefined) switch(match$1.TAG | 0){
                case /* Text */ 0:
                    altText = match$1._0;
                    break;
                case /* MetaData */ 1:
                    altText = $7KlbQ.Metadata.getMetadataAsText(product, $2whNH.getWithDefault(variant, product.firstVariant), match$1._0);
                    break;
                case /* CustomLabel */ 2:
                    altText = $b836b78ab04d6613$var$getCustomLabelText(match$1._0, variant);
                    break;
            }
            else altText = undefined;
            return $b836b78ab04d6613$var$renderImage(src, altText);
        case /* Enhance */ 3:
            return $loT9g.some($b836b78ab04d6613$var$renderEnhance(product, $iv6Yc._1($hQWQG.ContentId.toString, content._0.id), config));
        case /* Table */ 4:
            var match$2 = content._0;
            return $b836b78ab04d6613$var$renderTable(className, product, variant, match$2.style, match$2.cells);
        case /* JavaScript */ 5:
            var match$3 = content._0;
            return $b836b78ab04d6613$var$renderJavaScript($iv6Yc._1($hQWQG.ContentId.toString, match$3.id), product, variant, match$3.code);
    }
}
function $b836b78ab04d6613$var$renderContents(classNameOpt, product, variant, config, contents) {
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var partial_arg = className;
    return $i7mYY.keepMap($i7mYY.map(contents, function(param) {
        return $b836b78ab04d6613$var$renderContent(undefined, partial_arg, product, variant, config, param);
    }), function(a) {
        return a;
    });
}
var $b836b78ab04d6613$export$7c6e2c02157bb7d2 = {
    DynamicSource: $b836b78ab04d6613$var$DynamicSource,
    $$Image: $b836b78ab04d6613$var$$$Image,
    Table: $b836b78ab04d6613$var$Table,
    getId: $b836b78ab04d6613$var$getId,
    getDynamicSource: $b836b78ab04d6613$var$getDynamicSource,
    getImageSource: $b836b78ab04d6613$var$getImageSource,
    getImageAltTextSource: $b836b78ab04d6613$var$getImageAltTextSource,
    renderText: $b836b78ab04d6613$var$renderText,
    renderTextList: $b836b78ab04d6613$var$renderTextList,
    resolveMetaData: $b836b78ab04d6613$var$resolveMetaData,
    resolveProductData: $b836b78ab04d6613$var$resolveProductData,
    getCustomLabelText: $b836b78ab04d6613$var$getCustomLabelText,
    resolveCustomLabel: $b836b78ab04d6613$var$resolveCustomLabel,
    resolveAvailability: $b836b78ab04d6613$var$resolveAvailability,
    renderImage: $b836b78ab04d6613$var$renderImage,
    renderContentFragment: $b836b78ab04d6613$var$renderContentFragment,
    renderEnhance: $b836b78ab04d6613$var$renderEnhance,
    renderDynamicSource: $b836b78ab04d6613$var$renderDynamicSource,
    renderTable: $b836b78ab04d6613$var$renderTable,
    renderJavaScript: $b836b78ab04d6613$var$renderJavaScript,
    renderContent: $b836b78ab04d6613$var$renderContent,
    renderContents: $b836b78ab04d6613$var$renderContents
};
var $b836b78ab04d6613$export$3824c08153b44726 = {};
var $b836b78ab04d6613$export$77fc3e7c6375c538 = {};
var $b836b78ab04d6613$export$a66c12e18fc190b1 = {};
var $b836b78ab04d6613$var$empty_id = $iv6Yc._1($hQWQG.SectionId.fromString, "");
var $b836b78ab04d6613$var$empty_contents = [];
var $b836b78ab04d6613$var$empty = {
    id: $b836b78ab04d6613$var$empty_id,
    contents: $b836b78ab04d6613$var$empty_contents,
    title: "",
    visible: /* Hidden */ 1
};
var $b836b78ab04d6613$export$9586e2f332c8a6f5 = {
    empty: $b836b78ab04d6613$var$empty
};
var $b836b78ab04d6613$export$4ba25fc295a936e5 = {};
var $b836b78ab04d6613$var$empty_id$1 = $iv6Yc._1($hQWQG.SectionId.fromString, "");
var $b836b78ab04d6613$var$empty_content = {
    TAG: /* Text */ 1,
    _0: {
        id: $iv6Yc._1($hQWQG.ContentId.fromString, ""),
        text: "",
        isRichText: false,
        isPreWrapped: false
    }
};
var $b836b78ab04d6613$var$empty$1 = {
    id: $b836b78ab04d6613$var$empty_id$1,
    content: $b836b78ab04d6613$var$empty_content,
    title: "",
    visible: /* Hidden */ 1,
    backgroundColor: "#000000",
    textColor: "#ffffff"
};
var $b836b78ab04d6613$export$37acb3580601e69a = {
    empty: $b836b78ab04d6613$var$empty$1
};
var $b836b78ab04d6613$var$empty_summarySections = [];
var $b836b78ab04d6613$var$empty_detailedSections = [];
var $b836b78ab04d6613$var$empty_promoSections = [];
var $b836b78ab04d6613$var$empty_enhanceSections = [];
var $b836b78ab04d6613$var$empty_badges = [];
var $b836b78ab04d6613$var$empty_reviews = [];
var $b836b78ab04d6613$var$empty_priceLabels = [];
var $b836b78ab04d6613$export$6e22c362a0406a2c = {
    summarySections: $b836b78ab04d6613$var$empty_summarySections,
    detailedSections: $b836b78ab04d6613$var$empty_detailedSections,
    promoSection: $b836b78ab04d6613$var$empty,
    promoSections: $b836b78ab04d6613$var$empty_promoSections,
    enhanceSection: undefined,
    enhanceSections: $b836b78ab04d6613$var$empty_enhanceSections,
    badges: $b836b78ab04d6613$var$empty_badges,
    reviews: $b836b78ab04d6613$var$empty_reviews,
    priceLabels: $b836b78ab04d6613$var$empty_priceLabels
};
function $b836b78ab04d6613$export$2dc08c6664577951(settings, product, variant) {
    var description = $2whNH.orElse($2whNH.flatMap(variant, function(v) {
        return v.description;
    }), product.description);
    var shipping = settings.shipping;
    var detailedSections = [
        description !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "description"),
            contents: [
                {
                    TAG: /* Text */ 1,
                    _0: {
                        id: $iv6Yc._1($hQWQG.ContentId.fromString, "description-content"),
                        text: description,
                        isRichText: true,
                        isPreWrapped: false
                    }
                }
            ],
            accordionState: /* DefaultState */ 0,
            title: "Description",
            iconUrl: "",
            visible: /* Visible */ 0
        } : undefined,
        shipping !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "shipping"),
            contents: [
                {
                    TAG: /* Text */ 1,
                    _0: {
                        id: $iv6Yc._1($hQWQG.ContentId.fromString, "shipping-content"),
                        text: shipping,
                        isRichText: true,
                        isPreWrapped: false
                    }
                }
            ],
            accordionState: /* DefaultState */ 0,
            title: "Shipping & Returns",
            iconUrl: "",
            visible: /* Visible */ 0
        } : undefined
    ];
    var arrival = settings.arrival;
    var shippingShort = settings.shippingShort;
    var summarySections = [
        {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "availability"),
            content: {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "availability-content"),
                    text: variant !== undefined ? variant.availability ? "In Stock" : "Out of Stock" : $7KlbQ.isOutOfStock(product) ? "Out of Stock" : "In Stock",
                    isRichText: false,
                    isPreWrapped: false
                }
            },
            title: "Availability",
            iconUrl: "",
            visible: /* Visible */ 0
        },
        arrival !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "arrival"),
            content: {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "arrival-content"),
                    text: arrival,
                    isRichText: false,
                    isPreWrapped: false
                }
            },
            title: "arrival",
            iconUrl: "",
            visible: /* Visible */ 0
        } : undefined,
        shippingShort !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "shippingShort"),
            content: {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "shippingShort-content"),
                    text: shippingShort,
                    isRichText: false,
                    isPreWrapped: false
                }
            },
            title: "shippingShort",
            iconUrl: "",
            visible: /* Visible */ 0
        } : undefined
    ];
    var promoText = settings.pdpPromoText;
    var promoSection = promoText !== undefined ? {
        id: $iv6Yc._1($hQWQG.SectionId.fromString, "promo"),
        contents: [
            {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "promo-content"),
                    text: promoText,
                    isRichText: true,
                    isPreWrapped: false
                }
            }
        ],
        title: "promo",
        visible: /* Visible */ 0
    } : {
        id: $iv6Yc._1($hQWQG.SectionId.fromString, "promo"),
        contents: [
            {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "promo-content"),
                    text: "",
                    isRichText: true,
                    isPreWrapped: false
                }
            }
        ],
        title: "promo",
        visible: /* Hidden */ 1
    };
    var prefix = settings.pdpPricePrefixText;
    var suffix = settings.pdpPriceSuffixText;
    var priceLabels = [
        prefix !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "pricePrefix"),
            title: "pricePrefix",
            visible: /* Visible */ 0,
            visibleInProductCard: false,
            showAs: /* Prefix */ 0,
            content: {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "pricePrefix-content"),
                    text: prefix,
                    isRichText: false,
                    isPreWrapped: false
                }
            }
        } : undefined,
        suffix !== undefined ? {
            id: $iv6Yc._1($hQWQG.SectionId.fromString, "priceSuffix"),
            title: "priceSuffix",
            visible: /* Visible */ 0,
            visibleInProductCard: false,
            showAs: /* Suffix */ 1,
            content: {
                TAG: /* Text */ 1,
                _0: {
                    id: $iv6Yc._1($hQWQG.ContentId.fromString, "priceSuffix-content"),
                    text: suffix,
                    isRichText: false,
                    isPreWrapped: false
                }
            }
        } : undefined
    ];
    return {
        summarySections: $i7mYY.keepMap(summarySections, function(a) {
            return a;
        }),
        detailedSections: $i7mYY.keepMap(detailedSections, function(a) {
            return a;
        }),
        promoSection: promoSection,
        promoSections: [
            promoSection
        ],
        enhanceSection: undefined,
        enhanceSections: [],
        badges: [],
        reviews: [],
        priceLabels: $i7mYY.keepMap(priceLabels, function(a) {
            return a;
        })
    };
}
function $b836b78ab04d6613$export$795910f5f15a9633(product, variant, visible) {
    if (typeof visible === "number") return visible === 0;
    else if (variant !== undefined) return $5CE1l.matchesProduct(visible._0, product, variant);
    else return false;
}
function $b836b78ab04d6613$export$490728da142deb1f(sections, product, variant) {
    var match = sections.promoSections;
    return {
        summarySections: $i7mYY.keep(sections.summarySections, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        detailedSections: $i7mYY.keep(sections.detailedSections, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        promoSection: sections.promoSection,
        promoSections: match.length !== 0 ? $i7mYY.keep(sections.promoSections, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }) : $i7mYY.keep([
            sections.promoSection
        ], function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        enhanceSection: $2whNH.keep(sections.enhanceSection, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        enhanceSections: $i7mYY.keep(sections.enhanceSections, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        badges: $i7mYY.keep(sections.badges, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        reviews: $i7mYY.keep(sections.reviews, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        }),
        priceLabels: $i7mYY.keep(sections.priceLabels, function(param) {
            return $b836b78ab04d6613$export$795910f5f15a9633(product, variant, param.visible);
        })
    };
}
var $b836b78ab04d6613$export$bb6896aa5755c251;
var $b836b78ab04d6613$export$9bbe9bfd3294dd44;
 /* empty Not a pure module */ 
});
parcelRegister("dI6Jg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9fb49aab038711ab$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $55MCT = parcelRequire("55MCT");

var $b5aRK = parcelRequire("b5aRK");

var $5bEXW = parcelRequire("5bEXW");

var $5av24 = parcelRequire("5av24");
function $9fb49aab038711ab$var$AudioCard(Props) {
    var contentUrl = Props.contentUrl;
    var thumbnailUrl = Props.thumbnailUrl;
    var name = Props.name;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setIsPlaying = match[1];
    var isPlaying = match[0];
    var playerRef = $g85JO.useRef(null);
    $g85JO.useEffect(function() {
        var el = playerRef.current;
        if (!(el == null)) {
            el.addEventListener("play", function($$event) {
                $iv6Yc._1(setIsPlaying, function(param) {
                    return true;
                });
            });
            el.addEventListener("ended", function($$event) {
                $iv6Yc._1(setIsPlaying, function(param) {
                    return false;
                });
            });
            el.addEventListener("pause", function($$event) {
                $iv6Yc._1(setIsPlaying, function(param) {
                    return false;
                });
            });
            return function(param) {
                el.removeEventListener("play", function($$event) {
                    $iv6Yc._1(setIsPlaying, function(param) {
                        return true;
                    });
                });
                el.removeEventListener("ended", function($$event) {
                    $iv6Yc._1(setIsPlaying, function(param) {
                        return false;
                    });
                });
                el.removeEventListener("pause", function($$event) {
                    $iv6Yc._1(setIsPlaying, function(param) {
                        return false;
                    });
                });
            };
        }
    }, [
        playerRef.current
    ]);
    var togglePlay = function togglePlay(param) {
        var el = playerRef.current;
        if (!(el == null)) {
            if (isPlaying) {
                el.pause();
                return;
            } else {
                $i7mYY.forEach($i7mYY.keepMap($i7mYY.map(Array.prototype.slice.call(document.documentElement.querySelectorAll("audio")), $b5aRK.ofNode), function(a) {
                    return a;
                }), function(prim) {
                    prim.pause();
                });
                el.play();
                return;
            }
        }
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("cursor-pointer group"),
        style: {
            width: "100px"
        },
        onClick: togglePlay
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative mb-3")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "w-full relative overflow-hidden flex-grow-0",
            "aspect-ratio-square",
            "rounded-full"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute w-full h-full")
    }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
        src: thumbnailUrl,
        fit: /* Cover */ 1,
        alt: name,
        priority: 0
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300",
            isPlaying ? "opacity-100" : "opacity-0 group-hover:opacity-100"
        ]))
    }, isPlaying ? /*#__PURE__*/ $g85JO.createElement($7wIsS.UilPause.make, {
        className: $ezf3v.prefix("transform absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 text-white")
    }) : /*#__PURE__*/ $g85JO.createElement($7wIsS.UilPlay.make, {
        className: $ezf3v.prefix("transform absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 text-white")
    }))), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("opacity-0")
    }, /*#__PURE__*/ $g85JO.createElement("audio", {
        ref: $5bEXW.Ref.domRef(playerRef),
        src: contentUrl
    })))), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow-1 leading-normal relative text-lg text-center text-secondary")
    }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
        lines: 2,
        lineHeight: 21,
        children: name
    })));
}
$9fb49aab038711ab$var$AudioCard.displayName = "AudioCard";
var $9fb49aab038711ab$export$dd44f18ab656f3bb = $9fb49aab038711ab$var$AudioCard;
 /* react Not a pure module */ 
});
parcelRegister("5av24", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $3c35f54ae4a35be7$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");
function $3c35f54ae4a35be7$var$DynamicTruncate(Props) {
    var lines = Props.lines;
    var lineHeightOpt = Props.lineHeight;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var fwdRef = Props.fwdRef;
    var children = Props.children;
    var lineHeight = lineHeightOpt !== undefined ? lineHeightOpt : 0;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var tmp;
    switch(lines){
        case 1:
            tmp = "truncate-lines truncate-lines-1";
            break;
        case 2:
            tmp = "truncate-lines truncate-lines-2";
            break;
        case 3:
            tmp = "truncate-lines truncate-lines-3";
            break;
        case 4:
            tmp = "truncate-lines truncate-lines-4";
            break;
        case 6:
            tmp = "truncate-lines truncate-lines-6";
            break;
        case 8:
            tmp = "truncate-lines truncate-lines-8";
            break;
        case 5:
        case 7:
        case 9:
        case 10:
        case 11:
            tmp = "";
            break;
        case 12:
            tmp = "truncate-lines truncate-lines-12";
            break;
        default:
            tmp = "";
    }
    var className$1 = $1TRFX.make([
        $ezf3v.prefix(tmp),
        className
    ]);
    var tmp$1 = {
        className: className$1
    };
    if (fwdRef !== undefined) tmp$1.ref = $loT9g.valFromOption(fwdRef);
    var tmp$2 = lineHeight !== 0 ? {
        minHeight: $ezf3v.intToPx(Math.imul(lineHeight, lines))
    } : undefined;
    if (tmp$2 !== undefined) tmp$1.style = $loT9g.valFromOption(tmp$2);
    var tmp$3 = {
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp$1, children)
    };
    if (dataTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$3);
}
$3c35f54ae4a35be7$var$DynamicTruncate.displayName = "DynamicTruncate";
var $3c35f54ae4a35be7$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($3c35f54ae4a35be7$var$DynamicTruncate);
 /* make Not a pure module */ 
});


parcelRegister("jAQD1", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e43a3406e307d918$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $c1RlU = parcelRequire("c1RlU");
var $e43a3406e307d918$export$c0876b86ca620313 = {};
function $e43a3406e307d918$var$MakerPage(Props) {
    var config = Props.config;
    var elementId = Props.elementId;
    var product = Props.product;
    var user = $2whNH.flatMap(config.transitiveAccount, function(account) {
        return account.makerPagesSlug;
    });
    var index = "-host-only-" + elementId;
    var index$1 = product !== undefined ? index + "-" + product.id : index;
    if (user !== undefined) return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1RlU))), {
        user: user,
        index: index$1,
        key: index$1
    });
    else return null;
}
$e43a3406e307d918$var$MakerPage.displayName = "MakerPage";
var $e43a3406e307d918$export$dd44f18ab656f3bb = $e43a3406e307d918$var$MakerPage;
 /* react Not a pure module */ 
});
parcelRegister("c1RlU", function(module, exports) {

var $gfRPo = parcelRequire("gfRPo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8c1ef6b475c19e6f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $g85JO = parcelRequire("g85JO");
var $8c1ef6b475c19e6f$var$_react2 = $8c1ef6b475c19e6f$var$_interopRequireDefault($g85JO);

var $k9pnZ = parcelRequire("k9pnZ");
var $8c1ef6b475c19e6f$var$_propTypes2 = $8c1ef6b475c19e6f$var$_interopRequireDefault($k9pnZ);
function $8c1ef6b475c19e6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c1ef6b475c19e6f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8c1ef6b475c19e6f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8c1ef6b475c19e6f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $gfRPo._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8c1ef6b475c19e6f$var$isBrowser() {
    return typeof window !== "undefined";
}
var $8c1ef6b475c19e6f$var$MakerEnhance = function(_React$Component) {
    $8c1ef6b475c19e6f$var$_inherits(MakerEnhance, _React$Component);
    function MakerEnhance(props) {
        $8c1ef6b475c19e6f$var$_classCallCheck(this, MakerEnhance);
        var _this = $8c1ef6b475c19e6f$var$_possibleConstructorReturn(this, (MakerEnhance.__proto__ || Object.getPrototypeOf(MakerEnhance)).call(this, props));
        _this.state = {
            url: $8c1ef6b475c19e6f$var$isBrowser() && window.location.href
        };
        return _this;
    }
    $8c1ef6b475c19e6f$var$_createClass(MakerEnhance, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.addScript();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var urlUpdated = false;
                if ($8c1ef6b475c19e6f$var$isBrowser() && window.location.href !== this.state.url) {
                    this.updateUrl();
                    urlUpdated = true;
                }
                if (this.props.index !== prevProps.index || urlUpdated) this.run();
            }
        },
        {
            key: "updateUrl",
            value: function updateUrl() {
                this.setState({
                    url: $8c1ef6b475c19e6f$var$isBrowser() && window.location.href
                });
            }
        },
        {
            key: "addScript",
            value: function addScript() {
                if (!$8c1ef6b475c19e6f$var$isBrowser() || !this.props.user || window.MakerEmbeds) return this.run();
                var script = document.createElement("script");
                script.id = "maker-enhance-script";
                script.src = this.script;
                script.async = true;
                document.head.appendChild(script);
            }
        },
        {
            key: "run",
            value: function run() {
                if (!$8c1ef6b475c19e6f$var$isBrowser() || typeof (window.MakerEmbeds || {}).run !== "function") return;
                window.MakerEmbeds.run();
            }
        },
        {
            key: "render",
            value: function render() {
                var index = this.props.index || 0;
                return $8c1ef6b475c19e6f$var$_react2.default.createElement("div", {
                    className: "js-maker-enhance-wrapper"
                }, $8c1ef6b475c19e6f$var$_react2.default.createElement("script", {
                    src: this.script,
                    id: "maker-enhance-script",
                    async: true
                }), $8c1ef6b475c19e6f$var$_react2.default.createElement("div", {
                    id: "js-maker-static-enhance-v1-218c2d7d-62da-499e-9e74-93201e1b3d56-" + index,
                    className: "js-maker-enhance-static-mount",
                    style: {
                        height: "auto",
                        width: "100%"
                    },
                    "data-loading-height": this.props.loadingHeight
                }));
            }
        },
        {
            key: "script",
            get: function get() {
                return "https://app.maker.co/enhance/" + this.props.user + ".js";
            }
        }
    ]);
    return MakerEnhance;
}($8c1ef6b475c19e6f$var$_react2.default.Component);
module.exports.default = $8c1ef6b475c19e6f$var$MakerEnhance;
$8c1ef6b475c19e6f$var$MakerEnhance.propTypes = {
    user: $8c1ef6b475c19e6f$var$_propTypes2.default.string.isRequired,
    index: $8c1ef6b475c19e6f$var$_propTypes2.default.oneOfType([
        $8c1ef6b475c19e6f$var$_propTypes2.default.string,
        $8c1ef6b475c19e6f$var$_propTypes2.default.number
    ]),
    loadingHeight: $8c1ef6b475c19e6f$var$_propTypes2.default.number
};

});
parcelRegister("k9pnZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eab8570bd3c9a7fc$var$ReactIs, $eab8570bd3c9a7fc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lUN3Y"))();

});
parcelRegister("lUN3Y", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $d5Lrm = parcelRequire("d5Lrm");
function $ff44e2d8eb8e9a3d$var$emptyFunction() {}
function $ff44e2d8eb8e9a3d$var$emptyFunctionWithReset() {}
$ff44e2d8eb8e9a3d$var$emptyFunctionWithReset.resetWarningCache = $ff44e2d8eb8e9a3d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $d5Lrm) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ff44e2d8eb8e9a3d$var$emptyFunctionWithReset,
        resetWarningCache: $ff44e2d8eb8e9a3d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("d5Lrm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $98808aa1f37dd5ec$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $98808aa1f37dd5ec$var$ReactPropTypesSecret;

});





parcelRegister("dzlIC", function(module, exports) {

$parcel$export(module.exports, "getVariantId", function () { return $9e0f641fc3189600$export$d24c7e7f97b984d0; });
$parcel$export(module.exports, "prepareProduct", function () { return $9e0f641fc3189600$export$6f7da9b90f139d88; });
$parcel$export(module.exports, "triggerCustomFunction", function () { return $9e0f641fc3189600$export$26db2d6ea83e5f52; });
$parcel$export(module.exports, "triggerCustomFunctionReturningString", function () { return $9e0f641fc3189600$export$7ec4957016454036; });
$parcel$export(module.exports, "triggerCustomFunctionWithoutProducts", function () { return $9e0f641fc3189600$export$87bf85c6bcfca6c6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $75ZqT = parcelRequire("75ZqT");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $4RPwt = parcelRequire("4RPwt");

var $7KlbQ = parcelRequire("7KlbQ");

var $bBMv4 = parcelRequire("bBMv4");

var $4QdUt = parcelRequire("4QdUt");
function $9e0f641fc3189600$export$d24c7e7f97b984d0(product) {
    var idParts = product.id.split("_");
    return $i7mYY.get(idParts, idParts.length - 1 | 0);
}
function $9e0f641fc3189600$export$6f7da9b90f139d88(product) {
    var variantId = $9e0f641fc3189600$export$d24c7e7f97b984d0(product);
    var newrecord = $7bjme.obj_dup(product);
    newrecord.id = $2whNH.getWithDefault(variantId, product.id);
    return newrecord;
}
function $9e0f641fc3189600$export$b33b857ad1d9900e(name, exn) {
    var messagePrefix = 'Custom script "' + name + '" failed';
    var jsExn = $75ZqT.$$Error.fromRescript($4RPwt.Exn.unwrapJsError(exn));
    var rootCause = $75ZqT.$$Error.getRootCause(jsExn);
    var match = rootCause.message;
    var match$1 = rootCause.name;
    var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
    var message = $i7mYY.keepMap([
        messagePrefix,
        rootCauseMessage
    ], function(a) {
        return a;
    }).join(", ");
    console.error(messagePrefix, jsExn);
    return $4QdUt.critical3($75ZqT.$$Error.fromStringWithCause(message, jsExn), message, exn);
}
function $9e0f641fc3189600$export$26db2d6ea83e5f52(code, product, variant, quantityOpt, name, linkerParam, param) {
    var quantity = quantityOpt !== undefined ? quantityOpt : 1;
    var variant$1 = $2whNH.getWithDefault(variant, product.firstVariant);
    var legacyProduct = $9e0f641fc3189600$export$6f7da9b90f139d88($7KlbQ.toLegacyDTO(product, variant$1));
    try {
        var func = new Function("product", "quantity", "product2", "variant2", "linkerParam", code);
        return Promise.resolve(func(legacyProduct, quantity, product, variant$1, linkerParam));
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        return $9e0f641fc3189600$export$b33b857ad1d9900e(name, e).then(function(param) {
            return Promise.reject(e);
        });
    }
}
function $9e0f641fc3189600$export$7ec4957016454036(code, product, variant, name, linkerParam, param) {
    var variant$1 = $2whNH.getWithDefault(variant, product.firstVariant);
    var legacyProduct = $9e0f641fc3189600$export$6f7da9b90f139d88($7KlbQ.toLegacyDTO(product, variant$1));
    try {
        var func = new Function("product", "product2", "variant2", "linkerParam", code);
        return func(legacyProduct, product, variant$1, linkerParam);
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        $9e0f641fc3189600$export$b33b857ad1d9900e(name, e);
        return;
    }
}
function $9e0f641fc3189600$export$87bf85c6bcfca6c6(code, name, linkerParam, param) {
    try {
        var func = new Function("linkerParam", code);
        return Promise.resolve(func(linkerParam));
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        return $9e0f641fc3189600$export$b33b857ad1d9900e(name, e).then(function(param) {
            return Promise.reject(e);
        });
    }
}
 /* Rollbar Not a pure module */ 
});

parcelRegister("5CE1l", function(module, exports) {

$parcel$export(module.exports, "matchesProduct", function () { return $417f8b9e4fe25046$export$1cef8e24101f55d1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $7KlbQ = parcelRequire("7KlbQ");
function $417f8b9e4fe25046$export$10ef3d2ac5f88595(condition, string) {
    switch(condition.TAG | 0){
        case /* EqualsTo */ 0:
            return string === condition._0;
        case /* Contains */ 1:
            return string.includes(condition._0);
        case /* NotEqualsTo */ 2:
            return string !== condition._0;
    }
}
function $417f8b9e4fe25046$export$b41b8ac7c9a631fd(condition, $$float) {
    switch(condition.TAG | 0){
        case /* EqualsTo */ 0:
            return $$float === condition._0;
        case /* NotEqualsTo */ 1:
            return $$float !== condition._0;
        case /* GreaterThan */ 2:
            return $$float > condition._0;
        case /* GreaterThanOrEqualsTo */ 3:
            return $$float >= condition._0;
        case /* LessThan */ 4:
            return $$float < condition._0;
        case /* LessThanOrEqualsTo */ 5:
            return $$float <= condition._0;
    }
}
function $417f8b9e4fe25046$export$22e67a79f0d3e612(condition, $$int) {
    switch(condition.TAG | 0){
        case /* EqualsTo */ 0:
            return $$int === condition._0;
        case /* NotEqualsTo */ 1:
            return $$int !== condition._0;
        case /* GreaterThan */ 2:
            return $$int > condition._0;
        case /* GreaterThanOrEqualsTo */ 3:
            return $$int >= condition._0;
        case /* LessThan */ 4:
            return $$int < condition._0;
        case /* LessThanOrEqualsTo */ 5:
            return $$int <= condition._0;
    }
}
function $417f8b9e4fe25046$export$a9cae7eda108d73c(condition, array) {
    if (condition.TAG === /* Any */ 0) {
        var condition$1 = condition._0;
        return $i7mYY.some(array, function(param) {
            return $417f8b9e4fe25046$export$10ef3d2ac5f88595(condition$1, param);
        });
    }
    var condition$2 = condition._0;
    return !$i7mYY.some(array, function(param) {
        return $417f8b9e4fe25046$export$10ef3d2ac5f88595(condition$2, param);
    });
}
function $417f8b9e4fe25046$export$1cef8e24101f55d1(condition, product, variant) {
    switch(condition.TAG | 0){
        case /* ProductTags */ 0:
            return $417f8b9e4fe25046$export$a9cae7eda108d73c(condition._0.condition, product.tags);
        case /* ProductType */ 1:
            return $417f8b9e4fe25046$export$10ef3d2ac5f88595(condition._0.condition, product.productType);
        case /* CustomLabels */ 2:
            return $417f8b9e4fe25046$export$a9cae7eda108d73c(condition._0.condition, variant.customLabels);
        case /* ProductMetaData */ 3:
            var match = condition._0;
            return $417f8b9e4fe25046$export$10ef3d2ac5f88595(match.condition, $2whNH.getWithDefault($7KlbQ.Metadata.getMetadataAsText(product, variant, match.metadataKey), "undefined"));
        case /* ProductPrice */ 4:
            return $417f8b9e4fe25046$export$b41b8ac7c9a631fd(condition._0.condition, $7KlbQ.Variant.getRealProductPurchasePrice(variant));
        case /* ProductQuantity */ 5:
            return $417f8b9e4fe25046$export$22e67a79f0d3e612(condition._0.condition, $7KlbQ.Variant.getQuantity(variant));
        case /* CompoundRule */ 6:
            var match$1 = condition._0;
            var op = match$1.op;
            return $i7mYY.reduce($i7mYY.map(match$1.rules, function(rule) {
                return $417f8b9e4fe25046$export$1cef8e24101f55d1(rule, product, variant);
            }), op === /* And */ 0, function(acc, curr) {
                if (op) {
                    if (acc) return true;
                    else return curr;
                } else if (acc) return curr;
                else return false;
            });
    }
}
 /* Product-Showside Not a pure module */ 
});

parcelRegister("gZfyt", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c5de68c37c95eac8$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $loT9g = parcelRequire("loT9g");

var $5bEXW = parcelRequire("5bEXW");
function $c5de68c37c95eac8$export$2452cd012911ed3(elm, html) {
    elm.innerHTML = html;
    $i7mYY.forEach($i7mYY.keepMap($i7mYY.map(Array.prototype.slice.call(elm.querySelectorAll("script")), function(prim) {
        return prim;
    }), function(x) {
        return x;
    }), function(oldScriptEl) {
        var newScriptEl = document.createElement("script");
        $i7mYY.forEach(Array.prototype.slice.call(oldScriptEl.attributes), function(attr) {
            newScriptEl.setAttribute(attr.name, attr.value);
        });
        var scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        $loT9g.nullable_to_opt(oldScriptEl.parentNode).replaceChild(newScriptEl, oldScriptEl);
    });
}
function $c5de68c37c95eac8$var$HtmlWithUnsafeJavascriptExecution(Props) {
    var tagOpt = Props.tag;
    var style = Props.style;
    var className = Props.className;
    var children = Props.children;
    var tag = tagOpt !== undefined ? tagOpt : /* Div */ 0;
    var callback = $g85JO.useCallback(function(el) {
        if (!(el == null)) return $c5de68c37c95eac8$export$2452cd012911ed3(el, children);
    }, []);
    if (tag) {
        var tmp = {
            ref: $5bEXW.Ref.callbackDomRef(callback)
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
        return /*#__PURE__*/ $g85JO.createElement("p", tmp);
    }
    var tmp$1 = {
        ref: $5bEXW.Ref.callbackDomRef(callback)
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    if (style !== undefined) tmp$1.style = $loT9g.valFromOption(style);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp$1);
}
$c5de68c37c95eac8$var$HtmlWithUnsafeJavascriptExecution.displayName = "HtmlWithUnsafeJavascriptExecution";
var $c5de68c37c95eac8$export$dd44f18ab656f3bb = $c5de68c37c95eac8$var$HtmlWithUnsafeJavascriptExecution;
 /* react Not a pure module */ 
});


parcelRegister("1nuZE", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $100ffb1530270748$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $100ffb1530270748$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");
var $100ffb1530270748$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($fOz3p.empty);
var $100ffb1530270748$var$provider = $100ffb1530270748$export$a078c61943f9dbbe.Provider;
function $100ffb1530270748$var$ProductDetailsContext$Provider(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var children = Props.children;
    var match = $8E2YL.use(undefined).config;
    var pdpConfig = $2whNH.flatMap(match.transitiveAccount, function(account) {
        return account.pdpConfig;
    });
    var pdpConfig$1 = pdpConfig !== undefined ? $fOz3p.filterInvisibleSections(pdpConfig, product, variant) : $fOz3p.makeDefault(match.settings, product, variant);
    return /*#__PURE__*/ $g85JO.createElement($100ffb1530270748$var$provider, {
        value: pdpConfig$1,
        children: children
    });
}
$100ffb1530270748$var$ProductDetailsContext$Provider.displayName = "ProductDetailsContext.Provider";
var $100ffb1530270748$export$2881499e37b75b9a = {
    provider: $100ffb1530270748$var$provider,
    make: $100ffb1530270748$var$ProductDetailsContext$Provider
};
function $100ffb1530270748$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($100ffb1530270748$export$a078c61943f9dbbe);
}
 /* context Not a pure module */ 
});


parcelRegister("fUtdg", function(module, exports) {

$parcel$export(module.exports, "Summary", function () { return $b952bf12e83f9201$export$46453a0401d6cd1a; });
$parcel$export(module.exports, "make", function () { return $b952bf12e83f9201$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $bmQtV = parcelRequire("bmQtV");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");

var $1nuZE = parcelRequire("1nuZE");
function $b952bf12e83f9201$export$a44fda75a215095(countInt) {
    var count = countInt;
    if (count >= 1000000000.0) return (count / 1000000000.0).toFixed(2) + "B";
    else if (count >= 1000000.0) return (count / 1000000.0).toFixed(2) + "M";
    else if (count >= 1000.0) return (count / 1000.0).toFixed(2) + "k";
    else return countInt.toString();
}
function $b952bf12e83f9201$var$ProductReviews$Summary(Props) {
    var at = Props.at;
    var summary = Props.summary;
    var classNameOpt = Props.className;
    var countClassName = Props.countClassName;
    var largeCountOpt = Props.largeCount;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var largeCount = largeCountOpt !== undefined ? largeCountOpt : false;
    var match = $8E2YL.use(undefined);
    var transitiveAccount = match.config.transitiveAccount;
    var countEnabled = at ? $2whNH.mapWithDefault(transitiveAccount, true, function(account) {
        return account.showProductReviewsCountInPLP;
    }) : $2whNH.mapWithDefault(transitiveAccount, true, function(account) {
        return account.showProductReviewsCountInPDP;
    });
    var showProductReviews = $2whNH.mapWithDefault(transitiveAccount, true, function(account) {
        return account.showProductReviews;
    });
    var percentage = summary.average / 5.0 * 100.0;
    var style = {
        width: "" + percentage.toString() + "%"
    };
    var renderStars = function renderStars(activeOpt) {
        var active = activeOpt !== undefined ? activeOpt : false;
        var className = $ezf3v.prefix($1TRFX.make([
            active ? "text-yellow-400" : "text-primary opacity-10",
            "w-5 h-5"
        ]));
        return $i7mYY.makeBy(5, function(i) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: String(i),
                className: $ezf3v.prefix("inline-block")
            }, /*#__PURE__*/ $g85JO.createElement($bmQtV.make, {
                className: className
            }));
        });
    };
    var countClassName$1 = $2whNH.getWithDefault(countClassName, $ezf3v.prefix("text-secondary"));
    var match$1 = summary.count;
    var match$2 = summary.average;
    var exit = 0;
    if (match$1 !== 0) exit = 1;
    else {
        if (match$2 === 0.0) return null;
        exit = 1;
    }
    if (exit === 1) {
        if (!showProductReviews) return null;
        var match$3 = summary.count;
        var tmp;
        var exit$1 = 0;
        if (countEnabled && match$3 !== 0) tmp = /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-label": summary.count.toLocaleString() + " review" + (summary.count === 1 ? "" : "s"),
            className: $1TRFX.make([
                $ezf3v.prefix("text-sm"),
                countClassName$1
            ])
        }, "" + summary.average.toFixed(1) + " (" + $b952bf12e83f9201$export$a44fda75a215095(summary.count) + ")");
        else exit$1 = 2;
        if (exit$1 === 2) tmp = /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("text-sm"),
                countClassName$1
            ])
        }, summary.average.toFixed(2));
        return /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-label": "user reviews",
            className: $1TRFX.make([
                $ezf3v.prefix("flex gap-1"),
                className,
                $ezf3v.prefix(largeCount ? "flex-col items-end" : "items-center flex-wrap")
            ])
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-label": summary.average.toFixed(1) + " out of 5 stars.",
            className: $ezf3v.prefix("h-5 relative")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex h-full whitespace-nowrap")
        }, renderStars(false)), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex h-full overflow-hidden absolute whitespace-nowrap top-0"),
            style: style
        }, renderStars(true))), tmp);
    }
}
$b952bf12e83f9201$var$ProductReviews$Summary.displayName = "ProductReviews.Summary";
var $b952bf12e83f9201$export$46453a0401d6cd1a = {
    make: $b952bf12e83f9201$var$ProductReviews$Summary
};
function $b952bf12e83f9201$var$ProductReviews(Props) {
    var at = Props.at;
    var product = Props.product;
    var variant = Props.variant;
    var classNameOpt = Props.className;
    var countClassName = Props.countClassName;
    var largeCountOpt = Props.largeCount;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var largeCount = largeCountOpt !== undefined ? largeCountOpt : false;
    var pdpConfig = $1nuZE.use(undefined);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var reviews = $i7mYY.map($i7mYY.map(pdpConfig.reviews, function(reviews) {
        return reviews.content;
    }), function(param) {
        return $fOz3p.Content.renderContent(undefined, undefined, product, variant, config, param);
    });
    return $i7mYY.keepMap($i7mYY.concat([
        $2whNH.map(product.reviewSummary, function(summary) {
            var tmp = {
                at: at,
                summary: summary,
                className: className,
                largeCount: largeCount
            };
            if (countClassName !== undefined) tmp.countClassName = $loT9g.valFromOption(countClassName);
            return /*#__PURE__*/ $g85JO.createElement($b952bf12e83f9201$var$ProductReviews$Summary, tmp);
        })
    ], reviews), function(a) {
        return a;
    });
}
$b952bf12e83f9201$var$ProductReviews.displayName = "ProductReviews";
var $b952bf12e83f9201$export$dd44f18ab656f3bb = $b952bf12e83f9201$var$ProductReviews;
 /* react Not a pure module */ 
});
parcelRegister("bmQtV", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $846a758dc4352b4c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $846a758dc4352b4c$var$IconStar(Props) {
    var className = Props.className;
    var tmp = {
        enableBackground: "new 0 0 24 24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M22,10.1c0.1-0.5-0.3-1.1-0.8-1.1l-5.7-0.8L12.9,3c-0.1-0.2-0.2-0.3-0.4-0.4C12,2.3,11.4,2.5,11.1,3L8.6,8.2L2.9,9C2.6,9,2.4,9.1,2.3,9.3c-0.4,0.4-0.4,1,0,1.4l4.1,4l-1,5.7c0,0.2,0,0.4,0.1,0.6c0.3,0.5,0.9,0.7,1.4,0.4l5.1-2.7l5.1,2.7c0.1,0.1,0.3,0.1,0.5,0.1v0c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.6,0.8-1.2l-1-5.7l4.1-4C21.9,10.5,22,10.3,22,10.1z",
        fill: "currentColor"
    }));
}
$846a758dc4352b4c$var$IconStar.displayName = "IconStar";
var $846a758dc4352b4c$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($846a758dc4352b4c$var$IconStar);
 /* make Not a pure module */ 
});


parcelRegister("8zoQU", function(module, exports) {

$parcel$export(module.exports, "Minimal", function () { return $63d4deccb39feb0b$export$90db1b7aae137c8a; });
$parcel$export(module.exports, "Large", function () { return $63d4deccb39feb0b$export$be4ab1d2d0958286; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $64jD1 = parcelRequire("64jD1");

var $2ZaET = parcelRequire("2ZaET");

var $8E2YL = parcelRequire("8E2YL");
function $63d4deccb39feb0b$export$be2d582fb0e0afc4(kind) {
    if (kind) return "Style";
    else return "Color";
}
function $63d4deccb39feb0b$export$c57c960a6238b0f7(kind) {
    switch(kind){
        case "Color":
            return /* Color */ 0;
        case "Style":
            return /* Style */ 1;
        default:
            return /* Color */ 0;
    }
}
function $63d4deccb39feb0b$export$949d07264cb862a3(pluralOpt, kind) {
    var plural = pluralOpt !== undefined ? pluralOpt : false;
    if (kind) {
        if (plural) return "styles";
        else return "style";
    } else if (plural) return "colors";
    else return "color";
}
function $63d4deccb39feb0b$export$dbf35eabe8ed8ec8(hideOutOfStock, product, kind) {
    var name = kind ? "Style" : "Color";
    return $i7mYY.map($i7mYY.keepMap($i7mYY.map($7KlbQ.getOptionsByName(product, name), function(option) {
        return option.value;
    }), function(swatch) {
        return $i7mYY.getBy($i7mYY.keep($7KlbQ.getAllVariants(product), function(variant) {
            if (variant.availability !== /* OutOfStock */ 0) return true;
            else return !hideOutOfStock;
        }), function(variant) {
            return $7bjme.equal($7KlbQ.Variant.getOptionValue(variant, name), swatch);
        });
    }), function(variant) {
        return {
            kind: kind,
            variant: variant,
            value: $7KlbQ.Variant.getOptionValue(variant, name)
        };
    });
}
function $63d4deccb39feb0b$export$b8524893be0f6dac(hideOutOfStock, limitOpt, product) {
    var supportedSwatches = [
        /* Color */ 0
    ];
    return $i7mYY.reduce(supportedSwatches, [], function(acc, kind) {
        if (acc.length === 0) return $63d4deccb39feb0b$export$dbf35eabe8ed8ec8(hideOutOfStock, product, kind);
        else return acc;
    });
}
function $63d4deccb39feb0b$export$ee37e834aaad6f7e(limitOpt, input) {
    var limit$1 = limitOpt !== undefined ? limitOpt : 2;
    return $i7mYY.keepMap($i7mYY.mapWithIndex(input, function(index, media) {
        if (index > limit$1) return;
        else return media;
    }), function(a) {
        return a;
    });
}
function $63d4deccb39feb0b$var$ProductSwatches$Minimal(Props) {
    var hideOutOfStockOpt = Props.hideOutOfStock;
    var product = Props.product;
    var mainImage = Props.mainImage;
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var productSwatches = $63d4deccb39feb0b$export$b8524893be0f6dac(hideOutOfStock, undefined, product);
    var imageUrls = $i7mYY.map($63d4deccb39feb0b$export$ee37e834aaad6f7e(undefined, productSwatches), function(param) {
        var variant = param.variant;
        return [
            variant,
            $7KlbQ.getDisplaySwatchImage(product, variant)
        ];
    });
    var match = $i7mYY.get(productSwatches, 0);
    var optionName = match !== undefined && match.kind ? "Style" : "Color";
    var items = $i7mYY.mapWithIndex(imageUrls, function(i, param) {
        var imageUrl = param[1];
        var variant = param[0];
        var tmp = {
            key: String(i),
            className: $ezf3v.prefix($1TRFX.make([
                "w-6 h-6 relative overflow-hidden rounded-full border border-main ring-1",
                $7bjme.equal(imageUrl, mainImage) ? "ring-primary" : "ring-gray-200"
            ]))
        };
        var tmp$1 = $7KlbQ.Variant.getOptionValue(variant, optionName);
        if (tmp$1 !== undefined) tmp["aria-label"] = $loT9g.valFromOption(tmp$1);
        var tmp$2 = {
            src: imageUrl,
            fit: /* Cover */ 1,
            priority: 0
        };
        if (variant.name !== undefined) tmp$2.alt = $loT9g.valFromOption(variant.name);
        return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp$2));
    });
    var renderTruncationMarker = function renderTruncationMarker(param) {
        var truncatedCount = Math.max(productSwatches.length - imageUrls.length | 0, 0);
        var match = $i7mYY.get(productSwatches, 0);
        var label = match !== undefined ? $63d4deccb39feb0b$export$949d07264cb862a3(truncatedCount !== 1, match.kind) : $63d4deccb39feb0b$export$949d07264cb862a3(truncatedCount !== 1, /* Color */ 0);
        if (truncatedCount !== 0) return /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-label": "" + String(truncatedCount) + " more " + label + "",
            "aria-expanded": false
        }, "+" + truncatedCount.toString() + "");
        else return null;
    };
    var match$1 = productSwatches.length;
    if (match$1 === 0 || match$1 === 1) return null;
    var match$2 = $i7mYY.get(productSwatches, 0);
    var name = match$2 !== undefined ? $63d4deccb39feb0b$export$949d07264cb862a3(true, match$2.kind) : $63d4deccb39feb0b$export$949d07264cb862a3(true, /* Color */ 0);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-label": "product " + name,
        className: $ezf3v.prefix("flex-grow flex space-x-2 mt-2 items-center")
    }, items, renderTruncationMarker(undefined));
}
$63d4deccb39feb0b$var$ProductSwatches$Minimal.displayName = "ProductSwatches.Minimal";
var $63d4deccb39feb0b$export$90db1b7aae137c8a = {
    make: $63d4deccb39feb0b$var$ProductSwatches$Minimal
};
function $63d4deccb39feb0b$var$ProductSwatches$Large(Props) {
    var selectedVariant = Props.selectedVariant;
    var product = Props.product;
    var onChange = Props.onChange;
    var match = $8E2YL.use(undefined);
    var match$1 = match.config.settings;
    var productCardTitleLineTruncate = match$1.productCardTitleLineTruncate;
    var productSwatches = $63d4deccb39feb0b$export$b8524893be0f6dac(match$1.hideOutOfStock, undefined, product);
    var items = $i7mYY.map($63d4deccb39feb0b$export$ee37e834aaad6f7e(undefined, productSwatches), function(param) {
        var variant = param.variant;
        var onHover = function onHover(param) {
            $iv6Yc._1(onChange, variant);
        };
        var value = {
            TAG: /* ImageSwatch */ 0,
            _0: $7KlbQ.getDisplaySwatchImage(product, variant)
        };
        var selected = selectedVariant.id === variant.id;
        var label = $2whNH.getWithDefault(param.value, "");
        var handleClick = function handleClick(param) {
            $iv6Yc._1(onChange, variant);
        };
        return /*#__PURE__*/ $g85JO.createElement($64jD1.SwatchButton.make, {
            value: value,
            disabled: variant.availability === /* OutOfStock */ 0,
            selected: selected,
            label: label,
            size: productCardTitleLineTruncate === 1 ? /* Xs */ 0 : /* Sm */ 1,
            stopPropagation: false,
            onClick: handleClick,
            onHover: onHover,
            dataId: label,
            dataTestId: param.kind ? "product-card-style-button" : "product-card-color-button",
            alt: product.name,
            key: variant.id
        });
    });
    var truncated = productSwatches.length - items.length | 0;
    var renderTruncationMarker = function renderTruncationMarker(param) {
        var match = $i7mYY.get(productSwatches, 0);
        var name = match !== undefined ? $63d4deccb39feb0b$export$949d07264cb862a3(undefined, match.kind) : $63d4deccb39feb0b$export$949d07264cb862a3(undefined, /* Color */ 0);
        return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: truncated > 0,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-label": "" + String(truncated) + " more " + name + "" + (truncated === 1 ? "" : "s") + "",
                "aria-expanded": false,
                className: $ezf3v.prefix($1TRFX.make([
                    "text-base flex items-center justify-center text-tertiary",
                    productCardTitleLineTruncate === 1 ? "w-8 h-8" : "w-10 h-10"
                ]))
            }, "+" + String(truncated) + "")
        });
    };
    var match$2 = items.length;
    if (match$2 === 0 || match$2 === 1) return null;
    var match$3 = $i7mYY.get(productSwatches, 0);
    var name = match$3 !== undefined ? $63d4deccb39feb0b$export$949d07264cb862a3(true, match$3.kind) : $63d4deccb39feb0b$export$949d07264cb862a3(true, /* Color */ 0);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-label": "product " + name,
        className: $ezf3v.prefix("flex flex-wrap gap-2 items-center")
    }, items, renderTruncationMarker(undefined));
}
$63d4deccb39feb0b$var$ProductSwatches$Large.displayName = "ProductSwatches.Large";
var $63d4deccb39feb0b$export$be4ab1d2d0958286 = {
    make: $63d4deccb39feb0b$var$ProductSwatches$Large
};
 /* react Not a pure module */ 
});


parcelRegister("edu9N", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a599ac24494a71fd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $cVkRC = parcelRequire("cVkRC");

var $gCzsf = parcelRequire("gCzsf");

var $jBcRb = parcelRequire("jBcRb");

var $aSJcu = parcelRequire("aSJcu");
function $a599ac24494a71fd$var$ProductCardCTAButton(Props) {
    var sizeOpt = Props.size;
    var label = Props.label;
    var confirmation = Props.confirmation;
    var icon = Props.icon;
    var style = Props.style;
    var onClickOpt = Props.onClick;
    var disabledOpt = Props.disabled;
    var primaryOpt = Props.primary;
    var preventDefaultOpt = Props.preventDefault;
    var outlineOpt = Props.outline;
    var showConfirmationOpt = Props.showConfirmation;
    var wrapTextOpt = Props.wrapText;
    var controlledConfirmationOpt = Props.controlledConfirmation;
    var labelDataTestId = Props.labelDataTestId;
    var dataTestId = Props.dataTestId;
    var dataCount = Props.dataCount;
    var classNameOpt = Props.className;
    var onConfirmationEndOpt = Props.onConfirmationEnd;
    var tabIndex = Props.tabIndex;
    var size = sizeOpt !== undefined ? sizeOpt : /* Lg */ 1;
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(param) {};
    var disabled = disabledOpt !== undefined ? disabledOpt : false;
    var primary = primaryOpt !== undefined ? primaryOpt : false;
    var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
    var outline = outlineOpt !== undefined ? outlineOpt : true;
    var showConfirmation = showConfirmationOpt !== undefined ? showConfirmationOpt : false;
    var wrapText = wrapTextOpt !== undefined ? wrapTextOpt : false;
    var controlledConfirmation = controlledConfirmationOpt !== undefined ? controlledConfirmationOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var onConfirmationEnd = onConfirmationEndOpt !== undefined ? onConfirmationEndOpt : function onConfirmationEnd(param) {};
    $aSJcu.use(undefined);
    var match = $g85JO.useState(function() {
        if (disabled) return "disabled";
        else return "neutral";
    });
    var setStatus = match[1];
    var status = match[0];
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var setStatusTimeout = match$1.setTimeout;
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var setStatusAndConfirmationTimeout = match$2.setTimeout;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setStatus, function(status) {
            if (status === "neutral" || status === "disabled") {
                if (disabled) return "disabled";
                else return "neutral";
            } else return status;
        });
    }, [
        disabled
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setStatus, function(status) {
            if (showConfirmation && controlledConfirmation && status === "neutral") return "pending";
            else return status;
        });
    }, [
        showConfirmation
    ]);
    $g85JO.useEffect(function() {
        if (confirmation !== undefined && confirmation !== "") {
            setStatusTimeout(function(param) {
                $iv6Yc._1(setStatus, function(status) {
                    if (status === "pending" && (showConfirmation || !controlledConfirmation)) return "success";
                    else return status;
                });
            }, 1000);
            setStatusAndConfirmationTimeout(function(param) {
                $iv6Yc._1(setStatus, function(status) {
                    if (status === "success") return "neutral";
                    else return status;
                });
                $iv6Yc._1(onConfirmationEnd, undefined);
            }, 3000);
        }
    }, [
        status
    ]);
    var onClick$1 = function onClick$1(e) {
        if (preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }
        $iv6Yc._1(onClick, undefined);
        $iv6Yc._1(setStatus, function(status) {
            if (status === "neutral") return "pending";
            else return status;
        });
    };
    var tmp;
    switch(size){
        case /* Sm */ 0:
            tmp = "p-2 font-semibold rounded-custom";
            break;
        case /* Lg */ 1:
            tmp = "py-5 font-semibold";
            break;
        case /* Md */ 2:
            tmp = "p-5 font-medium";
            break;
        case /* Xl */ 3:
            tmp = "py-5 px-20 font-semibold";
            break;
    }
    var className$1 = $1TRFX.make([
        $ezf3v.prefix("relative"),
        $ezf3v.prefix("flex flex-grow items-center justify-center align-middle"),
        $ezf3v.prefix("text-center"),
        wrapText ? "" : $ezf3v.prefix("whitespace-nowrap"),
        $ezf3v.prefix("text-lg"),
        primary ? $ezf3v.prefix("bg-primary text-main") : $ezf3v.prefix("bg-main text-primary"),
        $ezf3v.prefix(tmp),
        $ezf3v.prefix("dark-hover"),
        className
    ]);
    var childrenCn = size !== 0 ? "flex items-center space-x-4" : "flex items-center space-x-3";
    var icon$1 = status === "success" ? $loT9g.some(/*#__PURE__*/ $g85JO.createElement($cVkRC.make, {
        className: $ezf3v.prefix(size !== 0 ? "w-5 h-5" : "w-4 h-4")
    })) : icon;
    var label$1 = status === "success" ? confirmation : label;
    var classMod = disabled ? $ezf3v.prefix("pointer-events-none") : "";
    var border = outline ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute inset-0 border border-solid rounded-inherit",
            primary ? "border-transparent" : "border-primary"
        ]))
    }) : null;
    var disabledOverlay = disabled ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 rounded-inherit opacity-50 bg-main")
    }) : null;
    var renderChildren = function renderChildren(param) {
        var tmp;
        if (label$1 !== undefined) {
            if (icon$1 !== undefined) {
                var tmp$1 = {
                    children: /*#__PURE__*/ $g85JO.createElement("div", undefined, label$1)
                };
                if (labelDataTestId !== undefined) tmp$1.dataTestId = $loT9g.valFromOption(labelDataTestId);
                tmp = /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix(childrenCn)
                }, /*#__PURE__*/ $g85JO.createElement("div", undefined, $loT9g.valFromOption(icon$1)), /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1));
            } else {
                var tmp$2 = {
                    children: /*#__PURE__*/ $g85JO.createElement("div", undefined, label$1)
                };
                if (labelDataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(labelDataTestId);
                tmp = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$2);
            }
        } else tmp = icon$1 !== undefined ? $loT9g.valFromOption(icon$1) : null;
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: disabled ? $ezf3v.prefix("opacity-75") : ""
        }, tmp);
    };
    var tmp$1 = {
        className: className$1
    };
    if (style !== undefined) tmp$1.style = $loT9g.valFromOption(style);
    var tmp$2 = {
        className: $1TRFX.make([
            classMod,
            $ezf3v.prefix("flex flex-grow")
        ]),
        onClick: onClick$1,
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp$1, renderChildren(undefined), border, disabledOverlay),
        hasText: true,
        disabled: disabled,
        dataId: primary ? "primary" : "secondary",
        ariaLive: "assertive"
    };
    var tmp$3 = size >= 3 ? {
        height: "70px"
    } : undefined;
    if (tmp$3 !== undefined) tmp$2.style = $loT9g.valFromOption(tmp$3);
    if (dataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(dataTestId);
    if (dataCount !== undefined) tmp$2.dataCount = $loT9g.valFromOption(dataCount);
    if (tabIndex !== undefined) tmp$2.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($jBcRb.make, tmp$2);
}
$a599ac24494a71fd$var$ProductCardCTAButton.displayName = "ProductCardCTAButton";
var $a599ac24494a71fd$export$dd44f18ab656f3bb = $a599ac24494a71fd$var$ProductCardCTAButton;
 /* react Not a pure module */ 
});
parcelRegister("cVkRC", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $968afe02ddd889a6$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $968afe02ddd889a6$var$IconCheck(Props) {
    var className = Props.className;
    var strokeWidthOpt = Props.strokeWidth;
    var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "2";
    var tmp = {
        height: "14",
        width: "18",
        viewBox: "-2 -2 20 16"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M15 1L5.375 10.625L1 6.25",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth
    }));
}
$968afe02ddd889a6$var$IconCheck.displayName = "IconCheck";
var $968afe02ddd889a6$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($968afe02ddd889a6$var$IconCheck);
 /* make Not a pure module */ 
});

parcelRegister("jBcRb", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e44b721916bb33cb$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $gCzsf = parcelRequire("gCzsf");
function $e44b721916bb33cb$var$QuickViewButton(Props) {
    var colorOpt = Props.color;
    var className = Props.className;
    var onClick = Props.onClick;
    var children = Props.children;
    var blockOpt = Props.block;
    var flexOpt = Props.flex;
    var style = Props.style;
    var hasTextOpt = Props.hasText;
    var disabled = Props.disabled;
    var href = Props.href;
    var openLinkInNewTab = Props.openLinkInNewTab;
    var fwdRef = Props.fwdRef;
    var title = Props.title;
    var dataId = Props.dataId;
    var dataTestId = Props.dataTestId;
    var dataCount = Props.dataCount;
    var ariaLive = Props.ariaLive;
    var tabIndex = Props.tabIndex;
    var color = colorOpt !== undefined ? colorOpt : /* Unstyled */ 3;
    var block = blockOpt !== undefined ? blockOpt : false;
    var flex = flexOpt !== undefined ? flexOpt : false;
    var hasText = hasTextOpt !== undefined ? hasTextOpt : false;
    var display = flex ? "flex" : "block";
    var display$1 = block ? display : "inline-" + display;
    var display$2 = hasText ? display$1 : $1TRFX.make([
        display$1,
        "leading-0"
    ]);
    var tmp;
    switch(color){
        case /* Dark */ 0:
            tmp = $ezf3v.prefix("bg-black bg-opacity-35 text-white dark-hover darker-active");
            break;
        case /* Light */ 1:
            tmp = $ezf3v.prefix("text-black bg-white dark-hover darker-active");
            break;
        case /* Clear */ 2:
            tmp = $ezf3v.prefix("text-white bg-transparent drop-shadow-sm filter");
            break;
        case /* Unstyled */ 3:
            tmp = "";
            break;
    }
    var className$1 = $1TRFX.make([
        $ezf3v.prefix(display$2),
        $ezf3v.prefix("cursor-pointer select-none"),
        tmp,
        $ezf3v.prefix("font-button"),
        $2whNH.getWithDefault(className, "")
    ]);
    var disabled$1 = $2whNH.getWithDefault(disabled, false);
    var href$1 = disabled$1 ? undefined : href;
    var onClick$1 = disabled$1 ? undefined : onClick;
    var tmp$1;
    if (href$1 !== undefined) {
        var tmp$2 = {
            children: children,
            href: href$1,
            unstyled: true,
            className: $1TRFX.make([
                $ezf3v.prefix("block no-underline"),
                className$1
            ]),
            role: "button"
        };
        if (title !== undefined) tmp$2.title = $loT9g.valFromOption(title);
        if (fwdRef !== undefined) tmp$2.fwdRef = $loT9g.valFromOption(fwdRef);
        if (style !== undefined) tmp$2.style = $loT9g.valFromOption(style);
        if (openLinkInNewTab !== undefined) tmp$2.openLinkInNewTab = $loT9g.valFromOption(openLinkInNewTab);
        if (dataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(dataTestId);
        if (disabled !== undefined) tmp$2.dataDisabled = $loT9g.valFromOption(disabled);
        if (onClick$1 !== undefined) tmp$2.onClick = $loT9g.valFromOption(onClick$1);
        if (tabIndex !== undefined) tmp$2.tabIndex = $loT9g.valFromOption(tabIndex);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp$2);
    } else {
        var tmp$3 = {
            className: className$1
        };
        if (fwdRef !== undefined) tmp$3.ref = $loT9g.valFromOption(fwdRef);
        var tmp$4 = onClick$1 !== undefined ? "button" : undefined;
        if (tmp$4 !== undefined) tmp$3.role = $loT9g.valFromOption(tmp$4);
        if (style !== undefined) tmp$3.style = $loT9g.valFromOption(style);
        var tmp$5 = tabIndex !== undefined ? tabIndex : onClick$1 !== undefined ? 0 : undefined;
        if (tmp$5 !== undefined) tmp$3.tabIndex = $loT9g.valFromOption(tmp$5);
        if (title !== undefined) tmp$3.title = $loT9g.valFromOption(title);
        if (onClick$1 !== undefined) tmp$3.onClick = $loT9g.valFromOption(onClick$1);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", tmp$3, children);
    }
    var tmp$6 = {
        children: tmp$1
    };
    if (disabled !== undefined) tmp$6.dataDisabled = $loT9g.valFromOption(disabled);
    if (dataTestId !== undefined) tmp$6.dataTestId = $loT9g.valFromOption(dataTestId);
    if (dataId !== undefined) tmp$6.dataId = dataId;
    if (dataCount !== undefined) tmp$6.dataCount = $loT9g.valFromOption(dataCount);
    if (ariaLive !== undefined) tmp$6.ariaLive = $loT9g.valFromOption(ariaLive);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$6);
}
$e44b721916bb33cb$var$QuickViewButton.displayName = "QuickViewButton";
var $e44b721916bb33cb$export$dd44f18ab656f3bb = $e44b721916bb33cb$var$QuickViewButton;
 /* react Not a pure module */ 
});



parcelRegister("gWwbb", function(module, exports) {
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    module.exports = {
        polyfill: polyfill
    };
})();

});

parcelRegister("hvzQE", function(module, exports) {

$parcel$export(module.exports, "isEnabled", function () { return $cbf1239d7e0f4830$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "useSidebarState", function () { return $cbf1239d7e0f4830$export$59dca65daeaf223; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $8E2YL = parcelRequire("8E2YL");
function $cbf1239d7e0f4830$export$3b029eb57ac4d562(category, settings, listPageType, isForcingPLP) {
    var keep = function keep(__x) {
        return $2whNH.keep(__x, function(param) {
            if (listPageType !== undefined && typeof listPageType === "number") return listPageType >= 2;
            else return true;
        });
    };
    var category$1 = keep(category);
    var index = keep(settings.indexNode);
    var canRenderCLPBar = settings.linksAsSidebar;
    var plpCheck1 = category$1 !== undefined ? $1xf0g.hasProducts(category$1) || $1xf0g.Link.isStoreCategoryLink(category$1) : false;
    var plpCheck2 = category$1 !== undefined ? !$1xf0g.hasSubCategories(category$1) || isForcingPLP : false;
    var plpCheck3 = category$1 !== undefined ? $1xf0g.ExternalConnection.isConnectedToStoreCategory(category$1) : false;
    var canRenderPLPBar = category$1 !== undefined ? settings.filtersEnabled && plpCheck1 && plpCheck2 && plpCheck3 : $2whNH.mapWithDefault($2whNH.keep(index, function(param) {
        return settings.filtersEnabled;
    }), false, function(indexNode) {
        return $2whNH.isSome($1xf0g.ExternalConnection.getStoreCategoryConnection(indexNode));
    });
    return [
        canRenderCLPBar,
        canRenderPLPBar
    ];
}
function $cbf1239d7e0f4830$export$59dca65daeaf223(param) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $hBcYV.useRouter(undefined);
    var match$3 = $g85JO.useState(function() {
        var match = config.settings.sidebarDesktopDefault;
        var match$1 = config.settings.sidebarMobileDefault;
        if (match) return !isMobile;
        else if (match$1) return isMobile;
        else return false;
    });
    var setIsSidebarOpen = match$3[1];
    $g85JO.useEffect(function() {
        var match = config.settings.sidebarDesktopDefault;
        var match$1 = config.settings.sidebarMobileDefault;
        var exit = 0;
        if (match && !isMobile) $iv6Yc._1(setIsSidebarOpen, function(param) {
            return true;
        });
        else exit = 1;
        if (exit === 1) {
            if (match$1 && isMobile) $iv6Yc._1(setIsSidebarOpen, function(param) {
                return true;
            });
        }
    }, [
        config.settings.sidebarMobileDefault,
        config.settings.sidebarDesktopDefault,
        isMobile,
        match$2.route
    ]);
    return [
        match$3[0],
        setIsSidebarOpen
    ];
}
 /* react Not a pure module */ 
});

parcelRegister("95jr3", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $69d3a821abf65ee1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gWwbb = parcelRequire("gWwbb");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $9EMq4 = parcelRequire("9EMq4");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $ej07s = parcelRequire("ej07s");

var $iJp5F = parcelRequire("iJp5F");
$gWwbb.polyfill();
var $69d3a821abf65ee1$export$5e725b8338a85d51 = function getTouchY(e) {
    return e.touches ? e.touches[0].clientY : 0;
};
var $69d3a821abf65ee1$export$66e76ce6d60c3fb = function getTouchY(e) {
    return e.touches ? e.touches[0].clientX : 0;
};
function $69d3a821abf65ee1$var$SimpleSlider(Props) {
    var slides = Props.slides;
    var slidesOffsetBefore = Props.slidesOffsetBefore;
    var slidesOffsetAfter = Props.slidesOffsetAfter;
    var slidesPerViewOpt = Props.slidesPerView;
    var shouldCenterOpt = Props.shouldCenter;
    var shouldShowScrollbarOpt = Props.shouldShowScrollbar;
    var shouldShowArrowsOpt = Props.shouldShowArrows;
    var verticallyCenterOpt = Props.verticallyCenter;
    var lockVerticalScrollWhenSwipingOpt = Props.lockVerticalScrollWhenSwiping;
    var classNameOpt = Props.className;
    var ulClassNameOpt = Props.ulClassName;
    var dataTestId = Props.dataTestId;
    var insetMargin = Props.insetMargin;
    var transformStyle = Props.transformStyle;
    var ariaLabel = Props.ariaLabel;
    var slideIndexOffsetOpt = Props.slideIndexOffset;
    var tabIndex = Props.tabIndex;
    var fwdRef = Props.fwdRef;
    var slideToIndexRef = Props.slideToIndexRef;
    var onMouseLeave = Props.onMouseLeave;
    var onMouseEnter = Props.onMouseEnter;
    var slidesPerView = slidesPerViewOpt !== undefined ? slidesPerViewOpt : "auto";
    var shouldCenter = shouldCenterOpt !== undefined ? shouldCenterOpt : false;
    var shouldShowScrollbar = shouldShowScrollbarOpt !== undefined ? shouldShowScrollbarOpt : false;
    var shouldShowArrows = shouldShowArrowsOpt !== undefined ? shouldShowArrowsOpt : true;
    var verticallyCenter = verticallyCenterOpt !== undefined ? verticallyCenterOpt : false;
    var lockVerticalScrollWhenSwiping = lockVerticalScrollWhenSwipingOpt !== undefined ? lockVerticalScrollWhenSwipingOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var ulClassName = ulClassNameOpt !== undefined ? ulClassNameOpt : "";
    var slideIndexOffset = slideIndexOffsetOpt !== undefined ? slideIndexOffsetOpt : 0;
    var scrollRef = $g85JO.useRef(null);
    var appliedRef = fwdRef !== undefined ? (0, $iXXhl.default)(scrollRef, fwdRef) : scrollRef;
    var scrollContainerRef = $g85JO.useRef(null);
    var match = $aSJcu.use(undefined);
    var windowWidth = match.windowSize.width;
    var containerWidth = $2whNH.getWithDefault($2whNH.map($9EMq4.useResizeObserver(scrollRef), function(size) {
        return size.width;
    }), 300.0);
    var lastTouchMoveY = $g85JO.useRef(0);
    var lastTouchMoveX = $g85JO.useRef(0);
    var isScrolling = $g85JO.useRef(undefined);
    var firstSlideRef = $g85JO.useRef(null);
    var lastSlideRef = $g85JO.useRef(null);
    var match$1 = $iJp5F.use(firstSlideRef, scrollRef, true, [
        1.0
    ], undefined, undefined, undefined, undefined);
    var match$2 = $iJp5F.use(lastSlideRef, scrollRef, true, [
        0.99
    ], undefined, undefined, undefined, undefined);
    $g85JO.useEffect(function() {
        performance.mark && performance.mark("SimpleSlider rendered");
    }, []);
    var match$3 = $ej07s.useDraggable(scrollRef);
    var extraWrapperCn = shouldCenter && slidesPerView === "auto" ? $ezf3v.prefix("flex justify-center") : "";
    var extraChildrenCn = shouldCenter ? slidesPerView === "auto" ? $ezf3v.prefix("w-auto inline-flex") : $ezf3v.prefix("justify-center") : "";
    var scrollbarCn = shouldShowScrollbar ? "" : $ezf3v.prefix("no-scrollbar");
    var slides$1 = $g85JO.useMemo(function() {
        return $i7mYY.mapWithIndex(slides, function(index, slide) {
            var paddingLeft = index === 0 ? $2whNH.map(slidesOffsetBefore, $ezf3v.intToPx) : undefined;
            var paddingRight = index === (slides.length - 1 | 0) ? $2whNH.map(slidesOffsetAfter, $ezf3v.intToPx) : undefined;
            var width = slidesPerView === "auto" ? "auto" : "calc(100% / " + slidesPerView + ")";
            var tmp = {
                width: width
            };
            if (paddingRight !== undefined) tmp.paddingRight = paddingRight;
            if (paddingLeft !== undefined) tmp.paddingLeft = paddingLeft;
            var style = tmp;
            var isFirst = index === 0;
            var isLast = index === (slides.length - 1 | 0);
            var ref = isFirst ? $loT9g.some($5bEXW.Ref.domRef(firstSlideRef)) : isLast ? $loT9g.some($5bEXW.Ref.domRef(lastSlideRef)) : undefined;
            var style$1 = Object.assign({}, style, $2whNH.mapWithDefault(transformStyle, {}, function(fn) {
                return $iv6Yc._1(fn, index);
            }));
            var tmp$1 = {
                key: String(index),
                className: $1TRFX.make([
                    verticallyCenter ? $ezf3v.prefix("self-center") : "",
                    "swiper-slide"
                ]),
                style: style$1
            };
            if (ref !== undefined) tmp$1.ref = $loT9g.valFromOption(ref);
            return /*#__PURE__*/ $g85JO.createElement("li", tmp$1, slide);
        });
    }, [
        slides
    ]);
    var onClickNext = function onClickNext(param) {
        $2whNH.forEach($loT9g.nullable_to_opt(scrollRef.current), function(element) {
            var scrollRight = element.scrollWidth - (element.scrollLeft + containerWidth);
            var scrollBy = scrollRight < containerWidth ? scrollRight : containerWidth;
            element.scrollBy({
                behavior: "smooth",
                left: scrollBy,
                top: 0.0
            });
        });
    };
    var onClickPrev = function onClickPrev(param) {
        $2whNH.forEach($loT9g.nullable_to_opt(scrollRef.current), function(element) {
            var scrollBy = $81N94.float_max(-1 * element.scrollLeft, -1 * containerWidth);
            element.scrollBy({
                behavior: "smooth",
                left: scrollBy,
                top: 0.0
            });
        });
    };
    var slideToIndex = function slideToIndex(index) {
        $2whNH.forEach($2whNH.flatMap($loT9g.nullable_to_opt(scrollContainerRef.current), function(element) {
            return $loT9g.nullable_to_opt(element.children.item(index + slideIndexOffset | 0));
        }), function(el) {
            $2whNH.forEach($2whNH.map(el, function(el) {
                return [
                    el.offsetLeft,
                    el.offsetWidth
                ];
            }), function(param) {
                var offsetWidth = param[1];
                var offsetLeft = param[0];
                var left = offsetWidth > windowWidth ? offsetLeft - 12 | 0 : offsetLeft + ((offsetWidth / 2 | 0) - (windowWidth / 2 | 0) | 0) | 0;
                $2whNH.forEach($loT9g.nullable_to_opt(scrollRef.current), function(__x) {
                    __x.scrollTo({
                        behavior: "smooth",
                        left: left,
                        top: 0.0
                    });
                });
            });
        });
    };
    $2whNH.forEach(slideToIndexRef, function(slideToIndexRef) {
        slideToIndexRef.current = slideToIndex;
    });
    var onTouchStart = function onTouchStart(e) {
        var pageX = $69d3a821abf65ee1$export$66e76ce6d60c3fb(e);
        var pageY = $69d3a821abf65ee1$export$5e725b8338a85d51(e);
        lastTouchMoveX.current = pageX;
        lastTouchMoveY.current = pageY;
    };
    var onTouchMove = function onTouchMove(e) {
        if (!(lockVerticalScrollWhenSwiping && isScrolling.current === undefined)) {
            if ($7bjme.equal(isScrolling.current, false)) {
                e.preventDefault();
                e.stopPropagation();
                return;
            } else return;
        }
        var pageX = $69d3a821abf65ee1$export$66e76ce6d60c3fb(e);
        var pageY = $69d3a821abf65ee1$export$5e725b8338a85d51(e);
        var diffX = pageX - lastTouchMoveX.current | 0;
        var diffY = pageY - lastTouchMoveY.current | 0;
        var isOnlyScrollingHorizontally = pageY === lastTouchMoveY.current;
        var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
        if (isOnlyScrollingHorizontally) {
            isScrolling.current = false;
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (!isSignificantMovement) return;
        var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
        if (touchAngle > 45.0) isScrolling.current = true;
        else {
            isScrolling.current = false;
            e.preventDefault();
            e.stopPropagation();
        }
    };
    var onTouchEnd = function onTouchEnd(param) {
        isScrolling.current = undefined;
    };
    var tmp = {
        className: $1TRFX.make([
            "swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-free-mode",
            className,
            extraWrapperCn
        ]),
        style: {
            zIndex: "0"
        }
    };
    if (onMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(onMouseEnter);
    if (onMouseLeave !== undefined) tmp.onMouseLeave = $loT9g.valFromOption(onMouseLeave);
    var tmp$1 = {
        ref: $5bEXW.Ref.domRef(appliedRef),
        className: $1TRFX.make([
            "swiper-wrapper",
            extraChildrenCn,
            $ezf3v.prefix($1TRFX.make([
                "overflow-x-auto overflow-y-hidden"
            ])),
            scrollbarCn
        ]),
        role: "navigation",
        onMouseDown: match$3.events.onMouseDown,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    if (ariaLabel !== undefined) tmp$1["aria-label"] = $loT9g.valFromOption(ariaLabel);
    if (tabIndex !== undefined) tmp$1.tabIndex = $loT9g.valFromOption(tabIndex);
    var tmp$2 = {
        transform: "translateZ(0)"
    };
    if (insetMargin !== undefined) tmp$2.margin = insetMargin;
    var tmp$3 = {
        children: /*#__PURE__*/ $g85JO.createElement("ul", {
            ref: $5bEXW.Ref.domRef(scrollContainerRef),
            className: $1TRFX.make([
                "swiper-wrapper",
                ulClassName
            ]),
            style: tmp$2
        }, slides$1)
    };
    if (dataTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement("div", tmp$1, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$3)), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: shouldShowArrows && !match$1.isIntersecting,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: "swiper-button-prev",
            onClick: onClickPrev
        })
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: shouldShowArrows && !match$2.isIntersecting,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: "swiper-button-next",
            onClick: onClickNext
        })
    }));
}
$69d3a821abf65ee1$var$SimpleSlider.displayName = "SimpleSlider";
var $69d3a821abf65ee1$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($69d3a821abf65ee1$var$SimpleSlider);
 /*  Not a pure module */ 
});
parcelRegister("ej07s", function(module, exports) {

$parcel$export(module.exports, "useDraggable", function () { return $a6a2eebc0e3e965d$export$df30c81f5aa01ff7; });

var $g85JO = parcelRequire("g85JO");
var $a6a2eebc0e3e965d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $g85JO.useLayoutEffect) : (0, $g85JO.useEffect);
function $a6a2eebc0e3e965d$export$df30c81f5aa01ff7(ref, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$decayRate = _ref.decayRate, decayRate = _ref$decayRate === void 0 ? 0.95 : _ref$decayRate, _ref$safeDisplacement = _ref.safeDisplacement, safeDisplacement = _ref$safeDisplacement === void 0 ? 10 : _ref$safeDisplacement, _ref$applyRubberBandE = _ref.applyRubberBandEffect, applyRubberBandEffect = _ref$applyRubberBandE === void 0 ? false : _ref$applyRubberBandE, _ref$activeMouseButto = _ref.activeMouseButton, activeMouseButton = _ref$activeMouseButto === void 0 ? "Left" : _ref$activeMouseButto;
    var internalState = (0, $g85JO.useRef)({
        isMouseDown: false,
        isDraggingX: false,
        isDraggingY: false,
        initialMouseX: 0,
        initialMouseY: 0,
        lastMouseX: 0,
        lastMouseY: 0,
        scrollSpeedX: 0,
        scrollSpeedY: 0,
        lastScrollX: 0,
        lastScrollY: 0
    });
    var isScrollableAlongX = false;
    var isScrollableAlongY = false;
    var maxHorizontalScroll = 0;
    var maxVerticalScroll = 0;
    var cursorStyleOfWrapperElement;
    var cursorStyleOfChildElements;
    var transformStyleOfChildElements;
    var transitionStyleOfChildElements;
    var timing = 1 / 60 * 1000; // period of most monitors (60fps)
    $a6a2eebc0e3e965d$var$useIsomorphicLayoutEffect(function() {
        isScrollableAlongX = window.getComputedStyle(ref.current).overflowX === "scroll";
        isScrollableAlongY = window.getComputedStyle(ref.current).overflowY === "scroll";
        maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
        maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
        cursorStyleOfWrapperElement = window.getComputedStyle(ref.current).cursor;
        cursorStyleOfChildElements = [];
        transformStyleOfChildElements = [];
        transitionStyleOfChildElements = [];
        ref.current.childNodes.forEach(function(child) {
            cursorStyleOfChildElements.push(window.getComputedStyle(child).cursor);
            transformStyleOfChildElements.push(window.getComputedStyle(child).transform === "none" ? "" : window.getComputedStyle(child).transform);
            transitionStyleOfChildElements.push(window.getComputedStyle(child).transition === "none" ? "" : window.getComputedStyle(child).transition);
        });
    }, []);
    var runScroll = function runScroll() {
        var dx = internalState.current.scrollSpeedX * timing;
        var dy = internalState.current.scrollSpeedY * timing;
        var offsetX = ref.current.scrollLeft + dx;
        var offsetY = ref.current.scrollTop + dy;
        ref.current.scrollLeft = offsetX; // eslint-disable-line no-param-reassign
        ref.current.scrollTop = offsetY; // eslint-disable-line no-param-reassign
        internalState.current.lastScrollX = offsetX;
        internalState.current.lastScrollY = offsetY;
    };
    var rubberBandCallback = function rubberBandCallback(e) {
        var dx = e.clientX - internalState.current.initialMouseX;
        var dy = e.clientY - internalState.current.initialMouseY;
        var _ref$current = ref.current, clientWidth = _ref$current.clientWidth, clientHeight = _ref$current.clientHeight;
        var displacementX = 0;
        var displacementY = 0;
        if (isScrollableAlongX && isScrollableAlongY) {
            displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1.0 + 0.5 * Math.abs(dx) / clientWidth);
            displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1.0 + 0.5 * Math.abs(dy) / clientHeight);
        } else if (isScrollableAlongX) displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1.0 + 0.5 * Math.abs(dx) / clientWidth);
        else if (isScrollableAlongY) displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1.0 + 0.5 * Math.abs(dy) / clientHeight);
        ref.current.childNodes.forEach(function(child) {
            child.style.transform = "translate3d(" + displacementX + "px, " + displacementY + "px, 0px)"; // eslint-disable-line no-param-reassign
            child.style.transition = "transform 0ms"; // eslint-disable-line no-param-reassign
        });
    };
    var recoverChildStyle = function recoverChildStyle() {
        ref.current.childNodes.forEach(function(child, i) {
            child.style.transform = transformStyleOfChildElements[i]; // eslint-disable-line no-param-reassign
            child.style.transition = transitionStyleOfChildElements[i]; // eslint-disable-line no-param-reassign
        });
    };
    var rubberBandAnimationTimer;
    var keepMovingX;
    var keepMovingY;
    var callbackMomentum = function callbackMomentum() {
        var minimumSpeedToTriggerMomentum = 0.05;
        keepMovingX = setInterval(function() {
            var lastScrollSpeedX = internalState.current.scrollSpeedX;
            var newScrollSpeedX = lastScrollSpeedX * decayRate;
            internalState.current.scrollSpeedX = newScrollSpeedX;
            var isAtLeft = ref.current.scrollLeft <= 0;
            var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll;
            var hasReachedHorizontalEdges = isAtLeft || isAtRight;
            runScroll();
            if (Math.abs(newScrollSpeedX) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedHorizontalEdges) {
                internalState.current.scrollSpeedX = 0;
                clearInterval(keepMovingX);
            }
        }, timing);
        keepMovingY = setInterval(function() {
            var lastScrollSpeedY = internalState.current.scrollSpeedY;
            var newScrollSpeedY = lastScrollSpeedY * decayRate;
            internalState.current.scrollSpeedY = newScrollSpeedY;
            var isAtTop = ref.current.scrollTop <= 0;
            var isAtBottom = ref.current.scrollTop >= maxVerticalScroll;
            var hasReachedVerticalEdges = isAtTop || isAtBottom;
            runScroll();
            if (Math.abs(newScrollSpeedY) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedVerticalEdges) {
                internalState.current.scrollSpeedY = 0;
                clearInterval(keepMovingY);
            }
        }, timing);
        internalState.current.isDraggingX = false;
        internalState.current.isDraggingY = false;
        if (applyRubberBandEffect) {
            var transitionDurationInMilliseconds = 250;
            ref.current.childNodes.forEach(function(child) {
                child.style.transform = "translate3d(0px, 0px, 0px)"; // eslint-disable-line no-param-reassign
                child.style.transition = "transform " + transitionDurationInMilliseconds + "ms"; // eslint-disable-line no-param-reassign
            });
            rubberBandAnimationTimer = setTimeout(recoverChildStyle, transitionDurationInMilliseconds);
        }
    };
    var preventClick = function preventClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // e.stopPropagation();
    };
    var getIsMousePressActive = function getIsMousePressActive(buttonsCode) {
        return activeMouseButton === "Left" && buttonsCode === 1 || activeMouseButton === "Middle" && buttonsCode === 4 || activeMouseButton === "Right" && buttonsCode === 2;
    };
    var onMouseDown = function onMouseDown(e) {
        var isMouseActive = getIsMousePressActive(e.buttons);
        if (!isMouseActive) return;
        internalState.current.isMouseDown = true;
        internalState.current.lastMouseX = e.clientX;
        internalState.current.lastMouseY = e.clientY;
        internalState.current.initialMouseX = e.clientX;
        internalState.current.initialMouseY = e.clientY;
    };
    var onMouseUp = function onMouseUp(e) {
        var isDragging = internalState.current.isDraggingX || internalState.current.isDraggingY;
        var dx = internalState.current.initialMouseX - e.clientX;
        var dy = internalState.current.initialMouseY - e.clientY;
        var isMotionIntentional = Math.abs(dx) > safeDisplacement || Math.abs(dy) > safeDisplacement;
        var isDraggingConfirmed = isDragging && isMotionIntentional;
        if (isDraggingConfirmed) ref.current.childNodes.forEach(function(child) {
            child.addEventListener("click", preventClick);
        });
        else ref.current.childNodes.forEach(function(child) {
            child.removeEventListener("click", preventClick);
        });
        internalState.current.isMouseDown = false;
        internalState.current.lastMouseX = 0;
        internalState.current.lastMouseY = 0;
        ref.current.style.cursor = cursorStyleOfWrapperElement; // eslint-disable-line no-param-reassign
        ref.current.childNodes.forEach(function(child, i) {
            child.style.cursor = cursorStyleOfChildElements[i]; // eslint-disable-line no-param-reassign
        });
        if (isDraggingConfirmed) callbackMomentum();
    };
    var onMouseMove = function onMouseMove(e) {
        if (!internalState.current.isMouseDown) return;
        e.preventDefault();
        var dx = internalState.current.lastMouseX - e.clientX;
        internalState.current.lastMouseX = e.clientX;
        internalState.current.scrollSpeedX = dx / timing;
        internalState.current.isDraggingX = true;
        var dy = internalState.current.lastMouseY - e.clientY;
        internalState.current.lastMouseY = e.clientY;
        internalState.current.scrollSpeedY = dy / timing;
        internalState.current.isDraggingY = true;
        ref.current.style.cursor = "grabbing"; // eslint-disable-line no-param-reassign
        ref.current.childNodes.forEach(function(child) {
            child.style.cursor = "grabbing"; // eslint-disable-line no-param-reassign
        });
        var isAtLeft = ref.current.scrollLeft <= 0 && isScrollableAlongX;
        var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll && isScrollableAlongX;
        var isAtTop = ref.current.scrollTop <= 0 && isScrollableAlongY;
        var isAtBottom = ref.current.scrollTop >= maxVerticalScroll && isScrollableAlongY;
        var isAtAnEdge = isAtLeft || isAtRight || isAtTop || isAtBottom;
        if (isAtAnEdge && applyRubberBandEffect) rubberBandCallback(e);
        runScroll();
    };
    var handleResize = function handleResize() {
        maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
        maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
    };
    (0, $g85JO.useEffect)(function() {
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("resize", handleResize);
            clearInterval(keepMovingX);
            clearInterval(keepMovingY);
            clearTimeout(rubberBandAnimationTimer);
        };
    }, []);
    return {
        events: {
            onMouseDown: onMouseDown
        }
    };
}

});


parcelRegister("dhngN", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9aaee9cab1b92469$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $eklj4 = parcelRequire("eklj4");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $kQvlq = parcelRequire("kQvlq");

var $fEMeF = parcelRequire("fEMeF");

var $16qP0 = parcelRequire("16qP0");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $dMhWy = parcelRequire("dMhWy");

var $6tZ3j = parcelRequire("6tZ3j");

var $hvzQE = parcelRequire("hvzQE");

var $gFKzh = parcelRequire("gFKzh");

var $dzlIC = parcelRequire("dzlIC");

var $46DBn = parcelRequire("46DBn");

var $hBcYV = parcelRequire("hBcYV");

var $8Eq46 = parcelRequire("8Eq46");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $lihS4 = parcelRequire("lihS4");

var $5BWWq = parcelRequire("5BWWq");

var $04dLg = parcelRequire("04dLg");

var $hm3Un = parcelRequire("hm3Un");
function $9aaee9cab1b92469$var$EntrypointCallbacks(Props) {
    var config = Props.config;
    var embedType = Props.embedType;
    var attributes = Props.attributes;
    var contextualRoot = Props.contextualRoot;
    var onOpeningDrawer = Props.onOpeningDrawer;
    var children = Props.children;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $hBcYV.useRouter(undefined);
    var listPageType = match$1.listPageType;
    var reset = match$1.reset;
    var goTo = match$1.goTo;
    var back = match$1.back;
    var route = match$1.route;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    var match$2 = $5BWWq.use(undefined);
    var externalOnOpenLink = match$2.onOpenLink;
    var match$3 = $16qP0.use(undefined);
    var smartnavApiHost = match$3.smartnavApiHost;
    var trackEvent = $gFKzh.use(embedType);
    var match$4 = $g85JO.useState(function() {});
    var setLastProductAddedToCart = match$4[1];
    var lastProductAddedToCart = match$4[0];
    var match$5 = $hvzQE.useSidebarState(undefined);
    var setIsSidebarOpen = match$5[1];
    var isSidebarOpen = match$5[0];
    var match$6 = $g85JO.useState(function() {
        return false;
    });
    var setIsMobileFiltersOpen = match$6[1];
    var isMobileFiltersOpen = match$6[0];
    var isMiniPDPVisible = $g85JO.useRef(false);
    var match$7 = $kQvlq.useSafeTimeout(undefined, undefined);
    var lastProductAddedToCartTimeout = match$7.setTimeout;
    var addToCart = $46DBn.useAddToCart(config.id, smartnavApiHost);
    var match$8 = $lihS4.useCart(undefined);
    var activeCategoryTitle = $2whNH.mapWithDefault(activeCategory, "", function(cat) {
        return cat.title;
    });
    var onAddToCart = $g85JO.useCallback(function(product) {
        return function(variant, quantity, category) {
            var tmp;
            tmp = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0.mediaId;
            $iv6Yc.app(trackEvent, [
                "product details:add to cart",
                undefined,
                undefined,
                product,
                variant,
                undefined,
                undefined,
                isMiniPDPVisible.current,
                tmp,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            $iv6Yc._4(addToCart, product, variant, category, quantity).then(function(input) {
                $iv6Yc._1(setLastProductAddedToCart, function(param) {
                    return variant;
                });
                lastProductAddedToCartTimeout(function(param) {
                    $iv6Yc._1(setLastProductAddedToCart, function(param) {});
                }, 3200);
                return Promise.resolve(input);
            });
            return $gFKzh.trackRetargeting(config.transitiveAccount, config.id, category !== undefined ? category : activeCategory, product, variant, isMobile, undefined, undefined, quantity, undefined, undefined, "add_to_cart");
        };
    }, [
        trackEvent,
        addToCart,
        setLastProductAddedToCart,
        lastProductAddedToCartTimeout,
        activeCategoryTitle,
        route
    ]);
    var toggleSidebar = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setIsSidebarOpen, function(previous) {
            if (previous === false) $iv6Yc.app(trackEvent, [
                "filter expanded",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return !previous;
        });
    }, []);
    var toggleFiltersPanel = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setIsMobileFiltersOpen, function(previous) {
            if (previous === false) $iv6Yc.app(trackEvent, [
                "filter expanded",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return !previous;
        });
    }, []);
    var handleHomeClicked = $g85JO.useCallback(function(param) {
        var firstCategoryId = $2whNH.map($i7mYY.get(config.categories, 0), function(param) {
            return param.id;
        });
        var match = config.settings.indexNode;
        var match$1 = config.settings.mkrBio;
        var destinationRoute = match !== undefined && match$1 !== undefined && firstCategoryId !== undefined && !match.visibleInMenuBar ? {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: firstCategoryId
                },
                viewPLP: false,
                filters: undefined,
                sort: undefined
            }
        } : {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* Index */ 0,
                filters: undefined,
                sort: undefined
            }
        };
        $iv6Yc._3(goTo, undefined, undefined, destinationRoute);
        $iv6Yc.app(trackEvent, [
            "open index",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    }, [
        goTo,
        trackEvent
    ]);
    var handlePureCategoryClick = function handlePureCategoryClick(clearIntentOpt, category) {
        var clearIntent = clearIntentOpt !== undefined ? clearIntentOpt : true;
        var match = category.categoryType;
        var exit = 0;
        if (typeof match === "number" || !(match.TAG === /* QuickView */ 2 && match._0.products.length !== 0)) exit = 1;
        else $iv6Yc.app(trackEvent, [
            "slider:promo",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        if (exit === 1) $iv6Yc.app(trackEvent, [
            "slider:category",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        $iv6Yc._3(goTo, clearIntent, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: category.id
                },
                viewPLP: false,
                filters: undefined,
                sort: undefined
            }
        });
    };
    var handleCategoryClick = $g85JO.useCallback(function(category) {
        var match = category.categoryType;
        var exit = 0;
        if (typeof match === "number" || !(match.TAG === /* QuickView */ 2 && match._0.products.length !== 0)) exit = 1;
        else $iv6Yc.app(trackEvent, [
            "slider:promo",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        if (exit === 1) $iv6Yc.app(trackEvent, [
            "slider:category",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        var match$1 = category.categoryType;
        var match$2 = $1xf0g.Link.getCardLink(category);
        var exit$1 = 0;
        var exit$2 = 0;
        if (match$2 !== undefined) {
            if (match$2.TAG === /* CustomAction */ 4) {
                var match$3 = match$2._0;
                $dzlIC.triggerCustomFunctionWithoutProducts(match$3.code, match$3.name, undefined, undefined);
                return;
            }
            exit$2 = 3;
        } else exit$2 = 3;
        if (exit$2 === 3) {
            if (typeof match$1 === "number") exit$1 = 2;
            else switch(match$1.TAG | 0){
                case /* Link */ 0:
                    if (match$2 !== undefined) {
                        if (match$2.TAG === /* URL */ 0) return;
                        exit$1 = 2;
                    }
                    break;
                case /* QuickView */ 2:
                    if ($1xf0g.hasProducts(category)) return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* QuickView */ 3,
                        _0: {
                            mediaId: category.id,
                            mediaParentId: undefined,
                            albumId: undefined,
                            productId: undefined,
                            relatedMediaProductIds: undefined,
                            relatedMediaCategoryId: undefined,
                            variantId: undefined,
                            panelClosed: undefined,
                            zoomedPhotoIndex: undefined,
                            time: undefined
                        }
                    });
                    exit$1 = 2;
                    break;
                case /* Index */ 3:
                    return $iv6Yc._1(handleHomeClicked, undefined);
                default:
                    exit$1 = 2;
            }
        }
        if (exit$1 === 2 && match$2 !== undefined) switch(match$2.TAG | 0){
            case /* URL */ 0:
                break;
            case /* Category */ 1:
                var match$4 = match$2._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* Category */ 0,
                            _0: match$4.categoryId
                        },
                        viewPLP: false,
                        filters: match$4.filters,
                        sort: undefined
                    }
                });
            case /* Product */ 2:
                var match$5 = match$2._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: $hBcYV.getListPageCategoryId(route),
                        productCategoryId: match$5.productCategoryId,
                        productId: match$5.productId,
                        variantId: match$5.variantId,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* StoreCategory */ 3:
                var match$6 = match$2._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* StoreCategory */ 2,
                            _0: {
                                categoryId: match$6.categoryId,
                                sourceNodeId: category.id
                            }
                        },
                        viewPLP: false,
                        filters: undefined,
                        sort: match$6.sortBy
                    }
                });
        }
        $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: category.id
                },
                viewPLP: false,
                filters: undefined,
                sort: undefined
            }
        });
    }, [
        listPageType,
        handleHomeClicked,
        trackEvent
    ]);
    var handleQuickViewClick = $g85JO.useCallback(function(parentCategory) {
        return function(category) {
            return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* QuickView */ 3,
                _0: {
                    mediaId: category.id,
                    mediaParentId: $2whNH.map(parentCategory, function(c) {
                        return c.id;
                    }),
                    albumId: undefined,
                    productId: undefined,
                    relatedMediaProductIds: undefined,
                    relatedMediaCategoryId: undefined,
                    variantId: undefined,
                    panelClosed: undefined,
                    zoomedPhotoIndex: undefined,
                    time: undefined
                }
            });
        };
    }, [
        goTo
    ]);
    var handleCloseNavigation = $g85JO.useCallback(function(param) {
        $iv6Yc.app(trackEvent, [
            "exit click",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        $iv6Yc._1(reset, undefined);
    }, [
        reset
    ]);
    var handleProductClick = $g85JO.useCallback(function(product) {
        return function(variant) {
            $iv6Yc.app(trackEvent, [
                "slider:item",
                true,
                undefined,
                product,
                variant,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            if (typeof route !== "number" && route.TAG === /* QuickView */ 3) {
                var payload = route._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* QuickView */ 3,
                    _0: {
                        mediaId: payload.mediaId,
                        mediaParentId: payload.mediaParentId,
                        albumId: payload.albumId,
                        productId: product.id,
                        relatedMediaProductIds: payload.relatedMediaProductIds,
                        relatedMediaCategoryId: payload.relatedMediaCategoryId,
                        variantId: $2whNH.map(variant, function(v) {
                            return v.id;
                        }),
                        panelClosed: payload.panelClosed,
                        zoomedPhotoIndex: payload.zoomedPhotoIndex,
                        time: payload.time
                    }
                });
            }
            return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* PDP */ 2,
                _0: {
                    categoryId: $2whNH.flatMap(listPageType, function(id) {
                        if (typeof id === "number" || id.TAG !== /* Category */ 0) return;
                        else return id._0;
                    }),
                    productCategoryId: product.categoryId,
                    productId: product.id,
                    variantId: $2whNH.map(variant, function(v) {
                        return v.id;
                    }),
                    zoomedPhotoIndex: undefined
                }
            });
        };
    }, [
        config.id,
        listPageType,
        $hBcYV.toString(route),
        trackEvent
    ]);
    var handleBackClick = function handleBackClick(param) {
        var parent = $1xf0g.getCategoryParentById(config.categories, $2whNH.mapWithDefault(listPageType, "", function(id) {
            if (typeof id === "number" || id.TAG !== /* Category */ 0) return "";
            else return id._0;
        }));
        if (typeof route !== "number" && route.TAG === /* ListPage */ 1) {
            var listPageRoute = route._0;
            if (listPageRoute.viewPLP) return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* ListPage */ 1,
                _0: {
                    listPageType: listPageRoute.listPageType,
                    viewPLP: false,
                    filters: undefined,
                    sort: undefined
                }
            });
            if (parent !== undefined) return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* ListPage */ 1,
                _0: {
                    listPageType: {
                        TAG: /* Category */ 0,
                        _0: parent.id
                    },
                    viewPLP: false,
                    filters: undefined,
                    sort: undefined
                }
            });
        }
        var isHome;
        isHome = typeof route === "number" || route.TAG !== /* Home */ 0 ? false : true;
        if (isHome) $iv6Yc.app(trackEvent, [
            "back button",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        $iv6Yc._1(back, undefined);
    };
    var getLinkerParam = function getLinkerParam(param) {
        return new Promise(function(resolve, reject) {
            var timeout = setTimeout(function(param) {
                resolve(undefined);
            }, 500);
            $eklj4.$$catch($8Eq46.getLinkerParam(config.settings.gaTrackingId, config.settings.gaVersion, config.settings.checkoutLink, config.transitiveAccount, undefined), function(param) {
                return Promise.resolve(undefined);
            }).then(function(linkerParam) {
                clearTimeout(timeout);
                resolve(linkerParam);
            });
        }).then(function(linkerParam) {
            var match = config.settings.gaTrackingId;
            if (match !== undefined && linkerParam !== undefined) return linkerParam;
        });
    };
    var appendQueryParams = function appendQueryParams(url) {
        var transformedUrl = $bygWp.maybeMakeUrl($bygWp.resolveRelativePath($bygWp.addProtocolIfMissing(url)));
        if (transformedUrl === undefined) return Promise.resolve(url);
        var url$1 = $loT9g.valFromOption(transformedUrl);
        var params = url$1.searchParams;
        var urlHasUtmParams = params.has("utm_source");
        var existingUtmParams = $i7mYY.keep(Array.from(new URL(window.location.href).searchParams.entries()), function(param) {
            return param[0].includes("utm_");
        });
        var hasExistingUtmParams = existingUtmParams.length !== 0;
        var match = config.settings.mkrBio;
        if (hasExistingUtmParams) {
            if (urlHasUtmParams) ;
            else $i7mYY.forEach(existingUtmParams, function(param) {
                params.append(param[0], param[1]);
            });
        } else if (match !== undefined && !urlHasUtmParams) {
            params.append("utm_medium", "referral");
            params.append("utm_source", "mkr.bio");
            params.append("utm_campaign", "mkr.bio");
        }
        return getLinkerParam(undefined).then(function(linkerParam) {
            if (linkerParam !== undefined) params.append(linkerParam[0], linkerParam[1]);
            return url$1.href;
        });
    };
    var redirectToLink = function redirectToLink(category, product, variant, openLinkInNewTabOpt, url) {
        var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
        var url$1 = $bygWp.maybeMakeRelativeUrl(url);
        var tmp;
        tmp = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0.mediaId;
        $iv6Yc.app(trackEvent, [
            "open link",
            undefined,
            category,
            product,
            variant,
            undefined,
            undefined,
            undefined,
            tmp,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            url$1,
            undefined
        ]);
        appendQueryParams(url$1).then(function(url) {
            if (openLinkInNewTab) window.open(url, "_blank");
            else window.top.location.href = url;
        });
    };
    var handleOpenLink = function handleOpenLink(category, index, product, variant, param) {
        var variant$1 = $2whNH.getWithDefault(variant, product.firstVariant);
        $gFKzh.trackRetargeting(config.transitiveAccount, config.id, category, product, variant$1, isMobile, index, undefined, 1, undefined, undefined, "select_item");
        $hm3Un.storeLastCategory(route);
        if (externalOnOpenLink !== undefined) {
            var tmp;
            tmp = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0.mediaId;
            $iv6Yc.app(trackEvent, [
                "open link",
                undefined,
                undefined,
                product,
                variant$1,
                undefined,
                undefined,
                undefined,
                tmp,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return $iv6Yc._1(externalOnOpenLink, $7KlbQ.toLegacyDTO(product, variant$1));
        }
        var match = variant$1.link;
        var match$1 = product.link;
        if (match !== undefined) return redirectToLink(undefined, product, variant$1, undefined, match);
        else if (match$1 !== undefined) return redirectToLink(undefined, product, variant$1, undefined, match$1);
        else {
            $4QdUt.error1($4QdUt.makeError(true, "Couldn't open link because neither product " + product.id + " nor variant " + variant$1.id + " have a link."));
            return;
        }
    };
    var favoritesLink = $dMhWy.useFavoritesLink(undefined);
    var handleFavoritesClicked = $g85JO.useCallback(function(param) {
        if (favoritesLink !== undefined) return redirectToLink(undefined, undefined, undefined, undefined, favoritesLink);
        var destinationRoute;
        if (typeof route === "number") destinationRoute = {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* Favorites */ 1,
                filters: undefined,
                sort: undefined
            }
        };
        else switch(route.TAG | 0){
            case /* ListPage */ 1:
                destinationRoute = {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: /* Favorites */ 0,
                        viewPLP: route._0.viewPLP,
                        filters: undefined,
                        sort: undefined
                    }
                };
                break;
            case /* PDP */ 2:
                destinationRoute = route._0.categoryId !== undefined ? {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: /* Favorites */ 0,
                        viewPLP: false,
                        filters: undefined,
                        sort: undefined
                    }
                } : {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: /* Favorites */ 1,
                        filters: undefined,
                        sort: undefined
                    }
                };
                break;
            default:
                destinationRoute = {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: /* Favorites */ 1,
                        filters: undefined,
                        sort: undefined
                    }
                };
        }
        $iv6Yc._3(goTo, undefined, undefined, destinationRoute);
    }, [
        goTo,
        trackEvent,
        $hBcYV.toString(route)
    ]);
    var handleHistoryClicked = $g85JO.useCallback(function(param) {
        var destinationRoute;
        if (typeof route === "number") destinationRoute = {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* History */ 2,
                filters: undefined,
                sort: undefined
            }
        };
        else switch(route.TAG | 0){
            case /* ListPage */ 1:
                destinationRoute = {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: /* History */ 1,
                        viewPLP: route._0.viewPLP,
                        filters: undefined,
                        sort: undefined
                    }
                };
                break;
            case /* PDP */ 2:
                destinationRoute = route._0.categoryId !== undefined ? {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: /* History */ 1,
                        viewPLP: false,
                        filters: undefined,
                        sort: undefined
                    }
                } : {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: /* History */ 2,
                        filters: undefined,
                        sort: undefined
                    }
                };
                break;
            default:
                destinationRoute = {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: /* History */ 2,
                        filters: undefined,
                        sort: undefined
                    }
                };
        }
        $iv6Yc._3(goTo, undefined, undefined, destinationRoute);
    }, [
        goTo,
        trackEvent,
        $hBcYV.toString(route)
    ]);
    var handleLauncherItemClick = $g85JO.useCallback(function(category) {
        $iv6Yc.app(trackEvent, [
            "top category nav",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        var match = category.categoryType;
        if (typeof match === "number" || !(match.TAG === /* QuickView */ 2 && match._0.isStories)) return $iv6Yc._1(handleCategoryClick, category);
        else return $iv6Yc._2(handleQuickViewClick, undefined, category);
    }, [
        handleCategoryClick,
        handleQuickViewClick
    ]);
    var handleDrawerOpening = function handleDrawerOpening(param) {
        $2whNH.forEach(onOpeningDrawer, function(f) {
            $iv6Yc._1(f, undefined);
        });
        if (contextualRoot !== undefined) return $iv6Yc._1(handleCategoryClick, contextualRoot);
        else return $iv6Yc._1(handleHomeClicked, undefined);
    };
    var handleChangeSort = $g85JO.useCallback(function(sort) {
        if (sort !== undefined) $iv6Yc.app(trackEvent, [
            {
                NAME: "sort applied",
                VAL: $04dLg.ProductSortOrder.toString(sort)
            },
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        var tmp;
        if (typeof route === "number") tmp = route;
        else switch(route.TAG | 0){
            case /* Home */ 0:
                var data = route._0;
                tmp = {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: data.homeType,
                        filters: data.filters,
                        sort: sort
                    }
                };
                break;
            case /* ListPage */ 1:
                var data$1 = route._0;
                tmp = {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: data$1.listPageType,
                        viewPLP: data$1.viewPLP,
                        filters: data$1.filters,
                        sort: sort
                    }
                };
                break;
            default:
                tmp = route;
        }
        $iv6Yc._3(goTo, undefined, true, tmp);
    }, [
        $hBcYV.toString(route)
    ]);
    var handleChangeFilters = $g85JO.useCallback(function(filters) {
        var isEmpty = filters === undefined || $2whNH.mapWithDefault(filters, 0, $fEMeF.length) === 0;
        var filtersNames = $2whNH.map(filters, function(filters) {
            return $i7mYY.concatMany([
                $i7mYY.map(filters.entries, function(entry) {
                    return entry.facet;
                }),
                $2whNH.mapWithDefault(filters.minPrice, [], function(price) {
                    return [
                        $fEMeF.toMinPriceFacet(price)
                    ];
                }),
                $2whNH.mapWithDefault(filters.maxPrice, [], function(price) {
                    return [
                        $fEMeF.toMaxPriceFacet(price)
                    ];
                })
            ]).join(", ");
        });
        $2whNH.forEach(filtersNames, function(filtersNames) {
            $iv6Yc.app(trackEvent, [
                {
                    NAME: "filter applied",
                    VAL: filtersNames
                },
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        });
        var tmp;
        if (typeof route === "number") tmp = route;
        else switch(route.TAG | 0){
            case /* Home */ 0:
                var data = route._0;
                tmp = {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: data.homeType,
                        filters: isEmpty ? undefined : filters,
                        sort: data.sort
                    }
                };
                break;
            case /* ListPage */ 1:
                var data$1 = route._0;
                tmp = {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: data$1.listPageType,
                        viewPLP: data$1.viewPLP,
                        filters: isEmpty ? undefined : filters,
                        sort: data$1.sort
                    }
                };
                break;
            default:
                tmp = route;
        }
        $iv6Yc._3(goTo, undefined, true, tmp);
    }, [
        isMobile,
        goTo,
        listPageType,
        match$1.productSort,
        match$1.productFilters
    ]);
    var handleSmartCardClick = $g85JO.useCallback(function(category) {
        var match = category.displayPriority;
        $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: category.id
                },
                viewPLP: match ? false : true,
                filters: undefined,
                sort: undefined
            }
        });
    }, [
        goTo
    ]);
    var handleSectionTitleClick = $g85JO.useCallback(function(category) {
        var isQuickView = $1xf0g.isQuickView(category);
        $iv6Yc.app(trackEvent, [
            isQuickView ? "slider:promo title" : "slider:title",
            true,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        $iv6Yc._1(handleCategoryClick, category);
    }, [
        trackEvent,
        handleCategoryClick
    ]);
    var handleSectionLinkClick = $g85JO.useCallback(function(category) {
        var isConnected = $1xf0g.ExternalConnection.isConnectedToProductSource(category);
        var hasSubCategories = $1xf0g.hasSubCategories(category);
        if (isConnected) {
            if (hasSubCategories) return $iv6Yc._1(handleSmartCardClick, category);
            else return $iv6Yc._1(handleCategoryClick, category);
        }
    }, [
        handleSmartCardClick,
        handleCategoryClick
    ]);
    var match$9 = $6tZ3j.useMarkets($2whNH.map($2whNH.flatMap(attributes, function(attr) {
        return attr.currency;
    }), function(currency) {
        return {
            TAG: /* Currency */ 0,
            _0: currency
        };
    }), config.id, config.settings.currencyPickerEnabled, undefined);
    var handleMarketChange = match$9[2];
    var market = match$9[1];
    var allMarkets = match$9[0];
    var handleOverlayProductClick = $g85JO.useCallback(function(category) {
        return function(parentCategory, product, variant) {
            return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* QuickView */ 3,
                _0: {
                    mediaId: category.id,
                    mediaParentId: $2whNH.map(parentCategory, function(c) {
                        return c.id;
                    }),
                    albumId: undefined,
                    productId: product.id,
                    relatedMediaProductIds: undefined,
                    relatedMediaCategoryId: undefined,
                    variantId: $2whNH.map(variant, function(variant) {
                        return variant.id;
                    }),
                    panelClosed: undefined,
                    zoomedPhotoIndex: undefined,
                    time: undefined
                }
            });
        };
    }, [
        goTo
    ]);
    $g85JO.useEffect(function() {
        if (activeCategory !== undefined) $gFKzh.trackRetargeting(config.transitiveAccount, config.id, activeCategory, undefined, undefined, isMobile, undefined, undefined, undefined, undefined, $2whNH.map($1xf0g.ExternalConnection.getStoreCategoryConnection(activeCategory), function(connection) {
            return connection.count;
        }), "view_category");
    }, [
        $2whNH.map(activeCategory, function(cat) {
            return cat.id;
        })
    ]);
    var handleProductFormChange = $g85JO.useCallback(function(product) {
        return function(variant) {
            if (typeof route !== "number" && route.TAG === /* QuickView */ 3) {
                var payload = route._0;
                return $iv6Yc._3(goTo, undefined, true, {
                    TAG: /* QuickView */ 3,
                    _0: {
                        mediaId: payload.mediaId,
                        mediaParentId: payload.mediaParentId,
                        albumId: payload.albumId,
                        productId: product.id,
                        relatedMediaProductIds: payload.relatedMediaProductIds,
                        relatedMediaCategoryId: payload.relatedMediaCategoryId,
                        variantId: $2whNH.map(variant, function(param) {
                            return param.id;
                        }),
                        panelClosed: payload.panelClosed,
                        zoomedPhotoIndex: payload.zoomedPhotoIndex,
                        time: payload.time
                    }
                });
            }
            return $iv6Yc._3(goTo, undefined, true, {
                TAG: /* PDP */ 2,
                _0: {
                    categoryId: $2whNH.flatMap(listPageType, function(id) {
                        if (typeof id === "number" || id.TAG !== /* Category */ 0) return;
                        else return id._0;
                    }),
                    productCategoryId: product.categoryId,
                    productId: product.id,
                    variantId: $2whNH.map(variant, function(param) {
                        return param.id;
                    }),
                    zoomedPhotoIndex: undefined
                }
            });
        };
    }, [
        route,
        listPageType
    ]);
    var handleProductFormSubmit = $g85JO.useCallback(function(submission) {
        if (submission.TAG !== /* AllGood */ 0) return Promise.resolve(undefined);
        var match = submission._0;
        var match$1 = match.submitButtonType;
        if (typeof match$1 === "number") {
            if (match$1 !== 0) {
                handleOpenLink(undefined, undefined, match.product, match.variant, undefined);
                return Promise.resolve(undefined);
            } else {
                $iv6Yc._4(onAddToCart, match.product, match.variant, match.quantity, undefined);
                return new Promise(function(resolve, reject) {
                    setTimeout(function(param) {
                        resolve(config.settings.pdpAddToCartConfirmation);
                    }, 1000);
                });
            }
        }
        var confirmation = match$1.confirmation;
        $iv6Yc._3(match$1.run, match.product, match.variant, match.quantity);
        if (confirmation !== undefined) return new Promise(function(resolve, reject) {
            setTimeout(function(param) {
                resolve(confirmation);
            }, 1000);
        });
        else return Promise.resolve(undefined);
    }, [
        config.settings.pdpAddToCartConfirmation,
        handleOpenLink,
        onAddToCart
    ]);
    var ctxValue = $g85JO.useMemo(function() {
        return {
            smartnavApiHost: smartnavApiHost,
            embedType: embedType,
            isSidebarOpen: isSidebarOpen,
            isMobileFiltersOpen: isMobileFiltersOpen,
            lastProductAddedToCart: lastProductAddedToCart,
            trackEvent: trackEvent,
            toggleSidebar: toggleSidebar,
            toggleFiltersPanel: toggleFiltersPanel,
            onAddToCart: onAddToCart,
            onCategoryClick: handleCategoryClick,
            onPureCategoryClick: handlePureCategoryClick,
            onQuickViewClick: handleQuickViewClick,
            onProductClick: handleProductClick,
            onHomeClick: handleHomeClicked,
            onFavoritesClick: handleFavoritesClicked,
            onHistoryClick: handleHistoryClicked,
            onLauncherItemClick: handleLauncherItemClick,
            onSectionTitleClick: handleSectionTitleClick,
            onSectionLinkClick: handleSectionLinkClick,
            onSmartCardClick: handleSmartCardClick,
            onDrawerOpening: handleDrawerOpening,
            onChangeFilters: handleChangeFilters,
            onChangeSort: handleChangeSort,
            onCloseNavigation: handleCloseNavigation,
            onOverlayProductClick: handleOverlayProductClick,
            onOpenLink: handleOpenLink,
            onBackClick: handleBackClick,
            onProductFormChange: handleProductFormChange,
            onProductFormSubmit: handleProductFormSubmit,
            redirectToLink: redirectToLink,
            getLinkerParam: getLinkerParam,
            isMiniPDPVisible: isMiniPDPVisible,
            allMarkets: allMarkets,
            market: market,
            onMarketChange: handleMarketChange
        };
    }, [
        match$8.cart,
        lastProductAddedToCart,
        toggleSidebar,
        trackEvent,
        onAddToCart,
        handleCategoryClick,
        handleChangeSort,
        handleQuickViewClick,
        handleProductClick,
        handleHomeClicked,
        handleMarketChange,
        handleOverlayProductClick,
        handleCloseNavigation,
        handleProductFormChange,
        handleProductFormSubmit,
        market
    ]);
    return /*#__PURE__*/ $g85JO.createElement($9pMGg.Provider.make, {
        value: ctxValue,
        children: children
    });
}
$9aaee9cab1b92469$var$EntrypointCallbacks.displayName = "EntrypointCallbacks";
var $9aaee9cab1b92469$export$dd44f18ab656f3bb = $9aaee9cab1b92469$var$EntrypointCallbacks;
 /* react Not a pure module */ 
});
parcelRegister("6tZ3j", function(module, exports) {

$parcel$export(module.exports, "useMarkets", function () { return $4b84cf3c8248406d$export$f072c2e8a8bce353; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $c6E1z = parcelRequire("c6E1z");

var $16qP0 = parcelRequire("16qP0");

var $2gwg0 = parcelRequire("2gwg0");

var $8wpG4 = parcelRequire("8wpG4");
function $4b84cf3c8248406d$export$f072c2e8a8bce353($$default, configId, enabledOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $16qP0.use(undefined);
    var match$1 = $c6E1z.useMarkets(match.smartnavApiHost, enabled);
    var allMarkets = match$1.markets;
    var toString = function toString(value) {
        if (typeof value === "number") return "U";
        else if (value.TAG === /* Currency */ 0) return "CU_" + value._0;
        else return "CO_" + value._0;
    };
    var fromString = function fromString(string) {
        if (string.startsWith("CU_")) return {
            TAG: /* Currency */ 0,
            _0: string.replace(/^CU\_/, "")
        };
        else if (string.startsWith("CO_")) return {
            TAG: /* Country */ 1,
            _0: string.replace(/^CO\_/, "")
        };
        else return /* Unsupported */ 0;
    };
    var defaultCountry = $2whNH.map($2gwg0.getCountry(undefined), function(country) {
        return {
            TAG: /* Country */ 1,
            _0: country
        };
    });
    var $$default$1 = $2whNH.getWithDefault($2whNH.orElse($$default, defaultCountry), /* Unsupported */ 0);
    var match$2 = $g85JO.useState(function() {
        return $2whNH.getWithDefault($2whNH.map($8wpG4.get(undefined, {
            NAME: "selectedMarket",
            VAL: configId
        }), fromString), $$default$1);
    });
    var setMarket = match$2[1];
    var suggestedMarket;
    if (allMarkets !== undefined) {
        var match$3 = allMarkets.choices;
        suggestedMarket = match$3 !== undefined && typeof match$3 !== "number" ? match$3.TAG === /* Countries */ 0 ? {
            TAG: /* Country */ 1,
            _0: match$3._0.suggestedCountry
        } : {
            TAG: /* Currency */ 0,
            _0: match$3._0.suggestedCurrency
        } : undefined;
    } else suggestedMarket = undefined;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setMarket, function(previous) {
            if (typeof previous === "number" && suggestedMarket !== undefined) return suggestedMarket;
            else return previous;
        });
    }, [
        suggestedMarket
    ]);
    var handleMarketChange = $g85JO.useCallback(function(fn) {
        if (enabled) return $iv6Yc._1(setMarket, function(previous) {
            var next = $iv6Yc._1(fn, previous);
            var __x = toString(next);
            $8wpG4.set(undefined, {
                NAME: "selectedMarket",
                VAL: configId
            }, __x);
            return next;
        });
    }, [
        enabled,
        setMarket
    ]);
    return [
        allMarkets,
        match$2[0],
        handleMarketChange
    ];
}
 /* react Not a pure module */ 
});

parcelRegister("46DBn", function(module, exports) {

$parcel$export(module.exports, "useAddToCart", function () { return $2fd671149d43a141$export$9fc54cc5dc9ec596; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $7KlbQ = parcelRequire("7KlbQ");

var $2gwg0 = parcelRequire("2gwg0");

var $bBMv4 = parcelRequire("bBMv4");

var $h7kEx = parcelRequire("h7kEx");

var $dzlIC = parcelRequire("dzlIC");

var $4zpR6 = parcelRequire("4zpR6");

var $4QdUt = parcelRequire("4QdUt");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");

var $5BWWq = parcelRequire("5BWWq");
function $2fd671149d43a141$export$b9192a5067208c9a(param) {
    var match = $8E2YL.use(undefined).config;
    return $2whNH.map($2whNH.flatMap($i7mYY.getBy($2whNH.mapWithDefault(match.transitiveAccount, [], function(account) {
        return account.customActions;
    }), function(script) {
        return script.addToCart;
    }), function(script) {
        return script.onClickFn;
    }), function(prim) {
        return prim.trim();
    });
}
function $2fd671149d43a141$export$9fc54cc5dc9ec596(configId, smartnavApiHost) {
    var match = $8E2YL.use(undefined);
    var settings = match.config.settings;
    var match$1 = $lihS4.useCart(undefined);
    var onUpdateCart = match$1.onUpdateCart;
    var mutateCart = match$1.mutateCart;
    var match$2 = $5BWWq.use(undefined);
    var onAddToCart = match$2.onAddToCart;
    var customAddToCart = $2fd671149d43a141$export$b9192a5067208c9a(undefined);
    return $g85JO.useCallback(function(product) {
        return function(variant, category, quantity) {
            var legacyProduct = $7KlbQ.toLegacyDTO(product, variant);
            var variantId = $dzlIC.getVariantId(legacyProduct);
            var legacyProduct$1 = $dzlIC.prepareProduct(legacyProduct);
            var expectedCount = {
                contents: 0
            };
            $iv6Yc._2(mutateCart, function(cart) {
                try {
                    var itemCount = cart.itemCount + quantity | 0;
                    expectedCount.contents = itemCount;
                    return {
                        itemCount: itemCount,
                        items: cart.items,
                        currency: cart.currency
                    };
                } catch (raw_e) {
                    var e = $bBMv4.internalToOCamlException(raw_e);
                    $4QdUt.error2(e, "Failed to increment cart item count");
                    return {
                        itemCount: quantity,
                        items: $4zpR6.empty.items,
                        currency: $4zpR6.empty.currency
                    };
                }
            }, false);
            var verifyAddToCart = function() {
                var _ref = (0, $5YOUh._)(function(param) {
                    var updatedCart;
                    return (0, $j4B9x.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $iv6Yc._2(mutateCart, function(a) {
                                        return a;
                                    }, false)
                                ];
                            case 1:
                                updatedCart = _state.sent();
                                if (!(updatedCart !== undefined && updatedCart.itemCount !== expectedCount.contents)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $4QdUt.info2("Add to cart probably failed, the updated cart doesn't match what we expected", {
                                        updatedCart: JSON.stringify(updatedCart),
                                        expectedCount: JSON.stringify(expectedCount.contents),
                                        product: JSON.stringify(product),
                                        variant: JSON.stringify(variant),
                                        category: JSON.stringify(category),
                                        quantity: JSON.stringify(quantity)
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function verifyAddToCart(param) {
                    return _ref.apply(this, arguments);
                };
            }();
            setTimeout(function(param) {
                verifyAddToCart(undefined);
            }, 3000);
            var match = settings.cart;
            var match$1 = $2gwg0.isShopify(undefined);
            if (match) return $iv6Yc._4(onUpdateCart, category, product, variant, quantity);
            var exit = 0;
            if (customAddToCart !== undefined) {
                if (variantId !== undefined) {
                    if (customAddToCart !== "") return $dzlIC.triggerCustomFunction(customAddToCart, product, variant, quantity, "add to cart", undefined, undefined);
                    exit = 2;
                }
            } else exit = 2;
            if (exit === 2 && match$1 && variantId !== undefined) return $h7kEx.$$fetch(/* Post */ 2, $loT9g.some('{ "quantity": ' + String(quantity) + ', "id": "' + variantId + '" }'), [
                [
                    "Accept",
                    "application/json"
                ],
                [
                    "Content-Type",
                    "application/json"
                ]
            ], undefined, undefined, $h7kEx.Decoding.ignoreDecode, "/cart/add.js").then(function(param) {
                return Promise.resolve(undefined);
            });
            if (onAddToCart !== undefined) return Promise.resolve($iv6Yc._1(onAddToCart, legacyProduct$1));
            else return Promise.resolve(undefined);
        };
    }, [
        customAddToCart,
        settings.cart
    ]);
}
 /* react Not a pure module */ 
});


})();
//# sourceMappingURL=PDPApp.bs.99542b35.js.map
